var WIDGET_TRANSPORT_SCOPE = 'widgetTransport';
/**
 * Берем с запасом по 95 перцентилю dom_content_loaded
 * https://rum.yandex-team.ru/projects/messenger/
 */
var CONNECTION_TIMEOUT = 15 * 1000; // 15 сек.
var PASSPORT_URL = 'https://passport.yandex.{tld}';
var SUPPORT_URL = 'https://passport.yandex.{tld}/support';

function preset$2(config) {
    return {
        config: config,
    };
}
/**
 * @doctitle Прессеты
 * @docsubtitle `backend` - cреда бэкэнда
 * @doctemplate presets_annotation
 *
 * @example
 * import { presets, YandexConfig } from 'yandex-int/messenger.widget';
 *
 * const config = new YandexConfig(presets.backend.alpha);
 */
var backend = {
    /**
     * Тестовая база и тестовый паспорт
     */
    test: preset$2('testing'),
    /**
     * Альфа база, продовый паспорт
     */
    alpha: preset$2('development'),
    /**
     * Продовая база, продовый паспорт
     */
    prod: preset$2('production'),
};

/**
 * Актуальные ссылки тут https://wiki.yandex-team.ru/messengerfront/urls/
 */
var HOST_DEV = 'https://renderer-chat-dev.hamster.yandex.{tld}/chat';
var HOST_PROD = 'https://yandex.{tld}/chat';
var HOST_PULL = function (pullNumber) { return "https://renderer-chat-pull-" + pullNumber + ".hamster.yandex.{tld}/chat"; };
var HOST_RELEASE = 'https://webtemplates.hamster.yandex.{tld}/chat';
var HOST_DEV_INTERNAL = 'https://renderer-chat-dev.test.q.yandex-team.ru/embed';
var HOST_PROD_INTERNAL = 'https://q.yandex-team.ru/embed';
var HOST_PULL_INTERNAL = function (pullNumber) { return "https://renderer-chat-pull-" + pullNumber + ".test.q.yandex-team.ru/embed"; };
var HOST_RELEASE_INTERNAL = 'https://webtemplates.test.q.yandex-team.ru/embed';
var BACKEND_TEST = 'testing';
var BACKEND_DEV = 'development';
var BACKEND_PROD = 'production';

function preset$1(origin) {
    return {
        origin: origin,
    };
}
/**
 * @docsubtitle `origin` - ориджин мессенджера
 * @doctemplate presets_annotation
 *
 * @example
 * import { presets, YandexConfig } from 'yandex-int/messenger.widget';
 *
 * const config = new YandexConfig(presets.origin.external.dev);
 */
var origin = {
    /**
     * Ориджины для внешних сервисов яндекса
     */
    external: {
        /**
         * Ориджин из trunk ветки
         */
        dev: preset$1(HOST_DEV),
        /**
         * Продакшен хост
         */
        prod: preset$1(HOST_PROD),
        /**
         * Ориджин последнего отведенного релиза
         */
        release: preset$1(HOST_RELEASE),
        /**
         * Ориджин указанный в process.env.STAND_EXTERNAL_MSSNGR_ORIGIN
         */
        local: function (origin) { return preset$1(origin); },
        /**
         * Ориджин из пулл реквеста
         * @param pullId айди пулл реквеста в arcadia
         * @returns Ориджин
         */
        pull: function (pullId) { return preset$1(HOST_PULL(pullId)); },
    },
    /**
     * Ориджины для внутренних сервисов яндекса
     */
    team: {
        /**
         * Ориджин из trunk ветки
         */
        dev: preset$1(HOST_DEV_INTERNAL),
        /**
         * Продакшен Ориджин
         */
        prod: preset$1(HOST_PROD_INTERNAL),
        /**
         * Ориджин последнего отведенного релиза
         */
        release: preset$1(HOST_RELEASE_INTERNAL),
        /**
         * Ориджин указанный в process.env.STAND_TEAM_MSSNGR_ORIGIN
         */
        local: function (origin) { return preset$1(origin); },
        /**
         * Ориджин из пулл реквеста
         * @param pullId Айди пулл реквеста из arcadia
         * @returns Ориджин
         */
        pull: function (pullId) { return preset$1(HOST_PULL_INTERNAL(pullId)); },
    },
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends$d(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign$2 = function() {
    __assign$2 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$2.apply(this, arguments);
};

function __decorate$9(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function preset(preset) {
    return preset;
}

/**
 * @docsubtitle `type` - вид мессенджера
 * @doctemplate presets_annotation
 *
 * @example
 * import { presets, YandexConfig } from 'yandex-int/messenger.widget';
 *
 * const config = new YandexConfig(presets.type.external.singleChats());
 */
var type = {
    /**
     * Сборки для внешних чатов
     */
    external: {
        /**
         * Мессенджер со списком чатов
         */
        multiChats: function (params) { return preset({
            build: 'chamb',
            flags: __assign$2({ newHeader: '1', embedButton: '1' }, ((params === null || params === void 0 ? void 0 : params.inline) && { hideClose: '1' })),
        }); },
        /**
         * Мессенджер для одного чата
         */
        singleChat: function (params) { return preset({
            build: 'chamb',
            flags: __assign$2({ disableNavigation: '1', disableChatList: '1', newHeader: '1', embedButton: '1' }, ((params === null || params === void 0 ? void 0 : params.inline) && { hideClose: '1' })),
        }); },
    },
    /**
     * Сборки для тим чатов
     */
    team: {
        /**
         * Мессенджер со списком чатов
         */
        multiChats: function (params) { return preset({
            build: 'yamb-embed-internal',
            flags: __assign$2({ newHeader: '1', embedButton: '1' }, ((params === null || params === void 0 ? void 0 : params.inline) && { hideClose: '1' })),
        }); },
        /**
         * Мессенджер для одного чата
         */
        singleChat: function (params) { return preset({
            build: 'yamb-embed-internal',
            flags: __assign$2({ disableChatList: '1', disableNavigation: '1', newHeader: '1', embedButton: '1' }, ((params === null || params === void 0 ? void 0 : params.inline) && { hideClose: '1' })),
        }); },
    },
};

/**
 * @docsubtitle `debug` - включение debug режима мессенджера
 * @doctemplate presets_annotation
 * @doc
 * В консоли будут отображены все события и отладочная информация мессенджера
 *
 * @example
 * import { presets, YandexConfig } from 'yandex-int/messenger.widget';
 *
 * const config1 = new YandexConfig(presets.debug.all);
 * const config2 = new YandexConfig(presets.debug.filter('parentWindow'));
 */
var debug = {
    /**
     * Отображать все события
     */
    all: preset({ debug: '*' }),
    /**
     * Отображать события подпадающие под фильтр
     *
     * @param filter В качестве значения можно указать фильтр по названию события, * поддерживается *
     * @returns Пресет для дебага
     */
    filter: function (filter) { return preset({ debug: filter }); },
};

/**
 * Разрешает открытие айфрейма на все окно браузера
 * Мессенджер использует этот режим для полноэкранного отображения
 * галереи картинок
 */
var fullscreen = preset({
    flags: {
        fullscreenSupported: '1',
    },
});

/**
 * @docsubtitle `support` - пресет для открытия чатов поддержки
 * Использовать только для чатов находящихся в workspace `support`
 * @doctemplate presets_annotation
 *
 * @example
 * import { presets, YandexConfig } from 'yandex-int/messenger.widget';
 *
 * const config1 = new YandexConfig(presets.support(BOT_GUID));
 */
var support = function (botGuid) { return preset({
    unreadWithCountChats: true,
    unreadCounterOtherGuid: botGuid,
    workspaceId: 'support',
    iframeOpenData: {
        guid: botGuid,
    },
}); };

var presets = {
    backend: backend,
    origin: origin,
    type: type,
    debug: debug,
    fullscreen: fullscreen,
    support: support,
};

function hasAuth() {
    return document.cookie.search(/(^|; )yandex_login=[^;]+/) !== -1;
}

function safeRemoveNode(elem) {
    try {
        if (elem && elem.parentNode) {
            elem.parentNode.removeChild(elem);
        }
    }
    catch (e) { }
}

function setLocalStorageJsonItem(key, value) {
    try {
        window.localStorage && window.localStorage.setItem(key, JSON.stringify(value));
    }
    catch (error) { }
}
function getLocalStorageJsonItem(key) {
    try {
        var item = window.localStorage && window.localStorage.getItem(key);
        if (typeof item === 'string') {
            var result = JSON.parse(item);
            if (result && typeof result === 'object') {
                return result;
            }
        }
    }
    catch (error) { }
    return null;
}
function removeLocalStorageJsonItem(key) {
    try {
        window.localStorage && window.localStorage.removeItem(key);
    }
    catch (error) { }
}

function escapeDot(string) {
    return string.replace(/\./g, '\\.');
}
// @see https://wiki.yandex-team.ru/messengerfront/domains/
// @see https://github.yandex-team.ru/serp/web4/blob/dev/src/lib/GlobalContext/extend/reqdata.js
var YANDEX_TLD = [
    'com.tr',
    'com.ge',
    'com.am',
    'co.il',
    'ua',
    'ru',
    'kz',
    'by',
    'com',
    'net',
    'uz',
    'fr',
    'az',
    'kg',
    'lv',
    'lt',
    'md',
    'tj',
    'tm',
    'ee',
];
var URL_REGEX_YANDEX_TLD_LIST = '(' + YANDEX_TLD.map(function (tld) {
    return escapeDot(tld);
}).join('|') + ')';
var URL_REGEX_YANDEX_TLD = "yandex\\." + URL_REGEX_YANDEX_TLD_LIST;
var DEFAULT_TLD = 'ru';
function getYandexTld(hostname) {
    var tld = (new RegExp(URL_REGEX_YANDEX_TLD + "$")).exec(hostname);
    return tld && tld[1] || '';
}
function isCookiedYandexTld(yandexTld) {
    // yandex.net - безкуковый домен.
    // https://messenger-test.s3.mds.yandex.net - используется для стенда виджета.
    return yandexTld && yandexTld !== 'net';
}
function getTld(hostname) {
    var tld = getYandexTld(hostname);
    return isCookiedYandexTld(tld) ? tld : DEFAULT_TLD;
}
var getCurrentTld = function () {
    if (!getCurrentTld.memo) {
        getCurrentTld.memo = getTld(window.location.hostname);
    }
    return getCurrentTld.memo;
};
function replaceTld(url, tld) {
    if (tld === void 0) { tld = getCurrentTld(); }
    return url.replace(/\{tld\}/, tld);
}

function buildParam(name, value) {
    if (value === undefined || value === null || value === '') {
        return '';
    }
    return encodeURIComponent(name) + '=' + encodeURIComponent(String(value));
}
function buildParams(params) {
    return params.map(function (item) {
        var name = item.name;
        var value = item.value;
        if (Array.isArray(value)) {
            return value
                .map(function (subvalue) { return buildParam(name, subvalue); })
                .filter(Boolean).join('&');
        }
        return buildParam(name, value);
    }).filter(Boolean).join('&');
}
function queryStringify$1(url, hashParams) {
    var prefix = (url.search(/\?/) === -1 ? '?' : '&');
    var params = Object.keys(hashParams).map(function (key) {
        return {
            name: key,
            value: hashParams[key],
        };
    });
    var query = buildParams(params);
    return url + (query ? prefix + query : '');
}
function getOrigin() {
    // IE11 не поддерживает origin.
    return window.location.origin || (window.location.protocol + '//' + window.location.host);
}
var compareOrigins = function (remoteOrigin, allowedOrigins) {
    // Отсекаем пустые и пробельные строки
    if (!remoteOrigin.trim()) {
        return false;
    }
    return allowedOrigins.some(function (origin) { return origin === remoteOrigin; });
};

var DEFAULT_GUID_MASK = 'xxxx-xxxx-xxxx-xxxx';
var UUID_MASK = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
function guid(mask) {
    if (mask === void 0) { mask = DEFAULT_GUID_MASK; }
    return mask.replace(/[xy]/g, function (char) {
        var value = Math.random() * 16 | 0;
        return (char === 'x' ? value : (value & 0x3 | 0x8)).toString(16);
    });
}
function createUUID() {
    return guid(UUID_MASK);
}

var noop = function () { };

var __values = (undefined && undefined.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var Event = /** @class */ (function () {
    function Event() {
        this.listeners = new Set();
    }
    Event.prototype.addListener = function (listener) {
        if (this.listeners.has(listener)) {
            return false;
        }
        this.listeners.add(listener);
        return true;
    };
    Event.prototype.removeListener = function (listener) {
        return this.listeners.delete(listener);
    };
    Event.prototype.removeAllListener = function () {
        this.listeners.clear();
    };
    Event.prototype.hasListeners = function () {
        return this.listeners.size > 0;
    };
    Event.prototype.dispatch = function (event) {
        var e_1, _a;
        try {
            for (var _b = __values(this.listeners), _c = _b.next(); !_c.done; _c = _b.next()) {
                var listener = _c.value;
                try {
                    var result = listener(event);
                    if (result && result.stopPropagation) {
                        return;
                    }
                }
                catch (error) {
                    Event.errorHandler(error);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    Event.errorHandler = noop;
    return Event;
}());

function isDefined(value) {
    return typeof value !== 'undefined';
}
function assertDefined(value, message) {
    if (typeof value === 'undefined') {
        throw new Error(message);
    }
}

function isString(value) {
    return typeof value === 'string';
}

function isObject(value) {
    return typeof value === 'object' && value !== null;
}

function isBoolean(value) {
    return typeof value === 'boolean';
}

function isNumber(value) {
    return typeof value === 'number' && !Number.isNaN(value);
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var lib$2 = {};

var attachRef$1 = {};

Object.defineProperty(attachRef$1, "__esModule", { value: true });
attachRef$1.attachRef = void 0;
function attachRef(refKey) {
    return function (target, propertyKey) {
        Object.defineProperty(target, propertyKey, {
            configurable: true,
            get: function () {
                var _this = this;
                var ref = (function (instance) {
                    ref.current = instance;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    var forwardedRef = _this.props[refKey];
                    if (!forwardedRef) {
                        return;
                    }
                    if (typeof forwardedRef === 'function') {
                        forwardedRef(instance);
                    }
                    else if (typeof forwardedRef === 'object') {
                        forwardedRef.current = instance;
                    }
                });
                ref.current = null;
                Object.defineProperty(this, propertyKey, {
                    configurable: true,
                    value: ref,
                });
                return ref;
            },
        });
    };
}
attachRef$1.attachRef = attachRef;

var bind = {};

Object.defineProperty(bind, "__esModule", { value: true });
bind.bind = void 0;
bind.bind = (function (prototype, method, descriptor) {
    // Запрещаем для статических методов
    if (typeof prototype === 'function') {
        throw new TypeError("Cannot bind static method " + method);
    }
    var func = descriptor.value;
    // В IE11 при вызове Object.defineProperty есть проблемы при
    // указании getter'а: уходит в бесконечную рекурсию
    var isDefining = false;
    return {
        configurable: true,
        get: function get() {
            if (isDefining) {
                return func;
            }
            var boundFunc = func.bind(this);
            isDefining = true;
            Object.defineProperty(this, method, {
                configurable: true,
                get: function () {
                    return boundFunc;
                },
            });
            isDefining = false;
            return boundFunc;
        },
    };
});

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(attachRef$1, exports);
__exportStar(bind, exports);
}(lib$2));

var __decorate$8 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var Timer = /** @class */ (function () {
    function Timer(callback, timeout, step) {
        if (step === void 0) { step = 500; }
        this.callback = callback;
        this.timeout = timeout;
        this.step = step;
        this.timeoutId = undefined;
        this.endTime = 0;
        this.endTime = Date.now() + timeout;
        this.tick();
    }
    Timer.prototype.cancel = function () {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
    };
    Timer.prototype.tick = function () {
        var now = Date.now();
        if (this.endTime <= now || this.timeout <= 0) {
            this.timeoutId = undefined;
            this.callback();
            return;
        }
        this.timeoutId = setTimeout(this.tick, this.endTime - now > this.step ? this.step : this.endTime - now);
    };
    __decorate$8([
        lib$2.bind
    ], Timer.prototype, "tick", null);
    return Timer;
}());

function isRemoveOldByTag(options) {
    return 'tag' in options;
}
/**
 * Очередь с возможностью приостановки выполнения
 * и удалению по задач по тэгу или идентификатору
 */
var Queue = /** @class */ (function () {
    function Queue(isLocked) {
        if (isLocked === void 0) { isLocked = false; }
        this.isLocked = isLocked;
        this.queue = [];
        this.isExecuting = false;
        this.isFreezed = false;
    }
    Queue.prototype.lock = function () {
        this.isLocked = true;
    };
    Queue.prototype.unlock = function () {
        if (!this.isLocked) {
            return;
        }
        this.isLocked = false;
        this.execute();
    };
    Queue.prototype.push = function (task, removeOld) {
        if (this.isFreezed) {
            return false;
        }
        if (removeOld) {
            this.cancel(removeOld);
        }
        this.queue.push(task);
        this.execute();
        return true;
    };
    Queue.prototype.execute = function () {
        if (this.isLocked || this.isExecuting) {
            return;
        }
        this.isExecuting = true;
        while (this.queue.length) {
            if (this.isLocked) {
                break;
            }
            var task = this.queue.shift();
            if (task) {
                task.run();
            }
        }
        this.isExecuting = false;
    };
    Queue.prototype.cancel = function (options, reason) {
        if (!options) {
            this.cancelAll(reason);
            return;
        }
        this.isFreezed = true;
        this.queue = this.queue.filter(function (item) {
            var shouldCancel = isRemoveOldByTag(options) ?
                item.tag === options.tag :
                item.id === options.id;
            if (shouldCancel) {
                item.cancel(reason);
            }
            return !shouldCancel;
        });
        this.isFreezed = false;
    };
    Queue.prototype.isEmpty = function () {
        return !this.queue.length;
    };
    Queue.prototype.cancelAll = function (reason) {
        this.isFreezed = true;
        this.queue.forEach(function (task) {
            task.cancel(reason);
        });
        this.queue = [];
        this.isFreezed = false;
    };
    return Queue;
}());

var DEFAULT_TAG = 'default';
var QueueTask = /** @class */ (function () {
    function QueueTask(task, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.tag, tag = _c === void 0 ? DEFAULT_TAG : _c, _d = _b.id, id = _d === void 0 ? createUUID() : _d, onCancel = _b.onCancel;
        this.task = task;
        this.tag = tag;
        this.onCancel = onCancel;
        this.id = id;
    }
    QueueTask.prototype.run = function () {
        try {
            this.task();
        }
        catch (_a) {
            // do nothing
        }
    };
    QueueTask.prototype.cancel = function (reason) {
        if (this.onCancel) {
            try {
                this.onCancel(reason);
            }
            catch (_a) {
                // do nothing
            }
        }
    };
    return QueueTask;
}());

var lib$1 = {};

var BaseError$1 = {};

var ErrorVisitor$1 = {};

Object.defineProperty(ErrorVisitor$1, "__esModule", { value: true });
ErrorVisitor$1.createHandler = ErrorVisitor$1.ErrorVisitor = void 0;
var ErrorVisitor = /** @class */ (function () {
    function ErrorVisitor(error, callback) {
        this.error = error;
        this.callback = callback;
    }
    return ErrorVisitor;
}());
ErrorVisitor$1.ErrorVisitor = ErrorVisitor;
function createHandler(dictionary, visitorFactory) {
    return Object.keys(dictionary).reduce(function (aux, key) {
        aux[key] = function (callback) { return visitorFactory(callback, key); };
        return aux;
    }, {});
}
ErrorVisitor$1.createHandler = createHandler;

var __extends$c = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(BaseError$1, "__esModule", { value: true });
BaseError$1.BaseError = void 0;
var ErrorVisitor_1 = ErrorVisitor$1;
var BaseError = /** @class */ (function (_super) {
    __extends$c(BaseError, _super);
    function BaseError(message, stack) {
        var _this = _super.call(this, message) || this;
        if (stack) {
            _this.stack = stack;
        }
        /**
         * @see https://github.com/Microsoft/TypeScript/wiki/FAQ#why-doesnt-extending-built-ins-like-error-array-and-map-work
         */
        Object.setPrototypeOf(_this, BaseError.prototype);
        return _this;
    }
    BaseError.handle = function (callback) {
        return new ErrorVisitor_1.ErrorVisitor(this, callback);
    };
    BaseError.is = function (error) {
        return error instanceof this;
    };
    BaseError.prototype.accept = function (visitor) {
        if (this instanceof visitor.error) {
            visitor.callback(this);
        }
    };
    return BaseError;
}(Error));
BaseError$1.BaseError = BaseError;

var LoggableError$1 = {};

var __extends$b = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(LoggableError$1, "__esModule", { value: true });
LoggableError$1.LoggableError = void 0;
var BaseError_1$2 = BaseError$1;
var LoggableError = /** @class */ (function (_super) {
    __extends$b(LoggableError, _super);
    function LoggableError(message, loggerFields, stack) {
        var _this = _super.call(this, message) || this;
        _this.loggerFields = loggerFields;
        _this.additional = loggerFields && loggerFields.additional;
        if (stack) {
            _this.stack = stack;
        }
        Object.setPrototypeOf(_this, LoggableError.prototype);
        return _this;
    }
    return LoggableError;
}(BaseError_1$2.BaseError));
LoggableError$1.LoggableError = LoggableError;

var SerializableError$1 = {};

var __extends$a = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(SerializableError$1, "__esModule", { value: true });
SerializableError$1.serializeId = SerializableError$1.SerializableError = void 0;
var BaseError_1$1 = BaseError$1;
var SerializableError = /** @class */ (function (_super) {
    __extends$a(SerializableError, _super);
    function SerializableError(message, stack) {
        var _this = _super.call(this, message, stack) || this;
        Object.setPrototypeOf(_this, SerializableError.prototype);
        return _this;
    }
    SerializableError.makeSerializable = function (error) {
        this.cache.set(error.SERIALIZE_ID, error);
    };
    SerializableError.serialize = function (error) {
        return error.serialize();
    };
    SerializableError.deserialize = function (error) {
        if (error.serializeId === SerializableError.SERIALIZE_ID) {
            return new SerializableError(error.message);
        }
        var ctr = this.cache.get(error.serializeId);
        if (ctr) {
            return new ctr(error.message);
        }
        return new Error(error.message);
    };
    SerializableError.prototype.serialize = function () {
        return {
            serializeId: this.constructor.SERIALIZE_ID,
            message: this.message,
        };
    };
    SerializableError.SERIALIZE_ID = '@SerializableError';
    SerializableError.cache = new Map();
    return SerializableError;
}(BaseError_1$1.BaseError));
SerializableError$1.SerializableError = SerializableError;
function serializeId(id) {
    return function (constructor) {
        constructor.SERIALIZE_ID = id;
        SerializableError.makeSerializable(constructor);
    };
}
SerializableError$1.serializeId = serializeId;

var TransportError$1 = {};

var __extends$9 = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(TransportError$1, "__esModule", { value: true });
TransportError$1.TransportError = void 0;
var BaseError_1 = BaseError$1;
var TransportError = /** @class */ (function (_super) {
    __extends$9(TransportError, _super);
    function TransportError(message, stack) {
        var _this = _super.call(this, "TransportError, " + message, stack) || this;
        Object.setPrototypeOf(_this, TransportError.prototype);
        return _this;
    }
    return TransportError;
}(BaseError_1.BaseError));
TransportError$1.TransportError = TransportError;

var RequestTimeoutError$1 = {};

var __extends$8 = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(RequestTimeoutError$1, "__esModule", { value: true });
RequestTimeoutError$1.RequestTimeoutError = void 0;
var TransportError_1 = TransportError$1;
var RequestTimeoutError = /** @class */ (function (_super) {
    __extends$8(RequestTimeoutError, _super);
    function RequestTimeoutError(stack) {
        var _this = _super.call(this, 'Request timeout', stack) || this;
        Object.setPrototypeOf(_this, RequestTimeoutError.prototype);
        return _this;
    }
    return RequestTimeoutError;
}(TransportError_1.TransportError));
RequestTimeoutError$1.RequestTimeoutError = RequestTimeoutError;

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoggableError = exports.ErrorVisitor = exports.createHandler = exports.BaseError = void 0;
var BaseError_1 = BaseError$1;
Object.defineProperty(exports, "BaseError", { enumerable: true, get: function () { return BaseError_1.BaseError; } });
var ErrorVisitor_1 = ErrorVisitor$1;
Object.defineProperty(exports, "createHandler", { enumerable: true, get: function () { return ErrorVisitor_1.createHandler; } });
Object.defineProperty(exports, "ErrorVisitor", { enumerable: true, get: function () { return ErrorVisitor_1.ErrorVisitor; } });
var LoggableError_1 = LoggableError$1;
Object.defineProperty(exports, "LoggableError", { enumerable: true, get: function () { return LoggableError_1.LoggableError; } });
__exportStar(SerializableError$1, exports);
__exportStar(TransportError$1, exports);
__exportStar(RequestTimeoutError$1, exports);
}(lib$1));

var DEFAULT_TIMEOUT = 10000;
var Request = /** @class */ (function () {
    function Request(onResult, timeout, RequestTimeoutErrorCtr) {
        var _this = this;
        if (timeout === void 0) { timeout = DEFAULT_TIMEOUT; }
        this.onResult = onResult;
        this.timeout = new Timer(function () {
            _this.result(new RequestTimeoutErrorCtr());
        }, timeout);
    }
    Request.prototype.result = function (error, response) {
        this.clearTimeout();
        if (error) {
            this.onResult(error);
        }
        else {
            this.onResult(undefined, response);
        }
    };
    Request.prototype.clearTimeout = function () {
        if (this.timeout) {
            this.timeout.cancel();
            this.timeout = undefined;
        }
    };
    return Request;
}());

var RequestsBucket = /** @class */ (function () {
    function RequestsBucket(RequestTimeoutErrorCtr) {
        if (RequestTimeoutErrorCtr === void 0) { RequestTimeoutErrorCtr = lib$1.RequestTimeoutError; }
        this.RequestTimeoutErrorCtr = RequestTimeoutErrorCtr;
        this.awaiters = new Map();
        this.seqNo = 1;
    }
    RequestsBucket.prototype.event = function (sender) {
        var id = sender(this.seqNo);
        this.seqNo++;
        return id;
    };
    RequestsBucket.prototype.request = function (sender, timeout) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var id = sender(_this.seqNo);
            _this.seqNo++;
            var request = new Request(function (error, resp) {
                _this.remove(id);
                if (error) {
                    reject(error);
                }
                else {
                    resolve(resp);
                }
            }, timeout, _this.RequestTimeoutErrorCtr);
            _this.awaiters.set(id, request);
        });
    };
    RequestsBucket.prototype.result = function (reqId, error, data) {
        var request = this.awaiters.get(reqId);
        if (!request) {
            return false;
        }
        if (error) {
            request.result(error);
        }
        else {
            request.result(undefined, data);
        }
        return true;
    };
    RequestsBucket.prototype.drop = function (error) {
        this.awaiters.forEach(function (value) { return value.result(error); });
        this.awaiters.clear();
        this.seqNo = 1;
    };
    RequestsBucket.prototype.remove = function (reqId) {
        return this.awaiters.delete(reqId);
    };
    return RequestsBucket;
}());

var Assert = /** @class */ (function () {
    function Assert() {
        this.isOptional = false;
        this.isUndefinable = false;
        this.validators = [];
    }
    Object.defineProperty(Assert.prototype, "string", {
        get: function () {
            this.validators.push(isString);
            return this;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Assert.prototype, "notEmptyString", {
        get: function () {
            this.validators.push(function (value) { return isString(value) && value !== ''; });
            return this;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Assert.prototype, "object", {
        get: function () {
            this.validators.push(isObject);
            return this;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Assert.prototype, "number", {
        get: function () {
            this.validators.push(isNumber);
            return this;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Assert.prototype, "boolean", {
        get: function () {
            this.validators.push(isBoolean);
            return this;
        },
        enumerable: false,
        configurable: true
    });
    Assert.prototype.shape = function (shape) {
        this.validators.push(function (value) { return shape.validate(value); });
        return this;
    };
    Object.defineProperty(Assert.prototype, "optional", {
        get: function () {
            this.isOptional = true;
            return this;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Assert.prototype, "undefinable", {
        get: function () {
            this.isUndefinable = true;
            return this;
        },
        enumerable: false,
        configurable: true
    });
    Assert.prototype.values = function () {
        var values = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            values[_i] = arguments[_i];
        }
        this.validators.push(function (value) { return values.some(function (possibleValue) { return value === possibleValue; }); });
        return this;
    };
    Assert.prototype.arrayOf = function (validator) {
        this.validators.push(function (value) { return Array.isArray(value) && value.every(validator); });
        return this;
    };
    Object.defineProperty(Assert.prototype, "any", {
        get: function () {
            this.isUndefinable = true;
            this.validators.push(function () { return true; });
            return this;
        },
        enumerable: false,
        configurable: true
    });
    Assert.prototype.validate = function (value) {
        if (!isDefined(value)) {
            return this.isOptional || this.isUndefinable;
        }
        return this.validators.some(function (validator) { return validator(value); });
    };
    return Assert;
}());

var ShapeValidator = /** @class */ (function () {
    function ShapeValidator(shape) {
        this.shape = shape;
    }
    ShapeValidator.prototype.validate = function (value) {
        var _this = this;
        if (!isDefined(value) || !isObject(value)) {
            return false;
        }
        return Object.keys(this.shape).every(function (key) {
            if (!(key in value)) {
                return _this.shape[key].isOptional;
            }
            return _this.shape[key].validate(value[key]);
        });
    };
    ShapeValidator.is = function () { return new Assert(); };
    return ShapeValidator;
}());

var Shape = {
    get is() {
        return new Assert();
    },
    create: function (schema) {
        return new ShapeValidator(schema);
    },
};

var __read$1 = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread$1 = (undefined && undefined.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read$1(arguments[i]));
    return ar;
};
function once(fn) {
    var called = false;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (called) {
            return;
        }
        called = true;
        fn.apply(void 0, __spread$1(args));
    };
}

/**
 * Проверяет что массивы одинаковы
 *
 * @param a Массив А
 * @param b Массив Б
 * @returns Одинаковы ли массивы
 */
var compareArray = function (a, b) {
    if (a.length === b.length) {
        return a.every(function (el, i) { return el === b[i]; });
    }
    return false;
};

var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (undefined && undefined.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
/**
 *  Мемоизирует функцию сохраняя результат последнего вызванного аргумента
 *
 * @param callback Функция требующая мемоизации
 * @returns Мемоизированная функция
 */
var memo = function (callback) {
    var cache = undefined;
    var result = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (cache && compareArray(cache.args, args)) {
            return cache.result;
        }
        var result = callback.apply(void 0, __spread(args));
        cache = { result: result, args: args };
        return result;
    };
    result.clear = function () {
        cache = undefined;
    };
    return result;
};

/**
 * @doctitle Конфигуратор виджета
 * @doc
 * Используется для конфигурации виджета. Пакет поставляет набор часто используемых настроек виджета
 * а так же пресеты для переопределения стандартных настроек (таких как ориджин мессенджера, env бэкэнда,
 * вид мессенджера и т.п.). Существующие прессеты описаны ниже.
 *
 * В конфиг необходимо передать [serviceId](/doc/cookbook.md#serviceid)!
 *
 * @example
 * const config = new Config(
 *     presets.origin.external.prod,
 *     presets.backend.prod,
 *     presets.type.multiChats,
 *     {
 *         serviceId: 1337, // 1337 - это пример
 *     }
 * )
 *
 * const widget = new Widget(config);
 */
var Config = /** @class */ (function () {
    /**
     * В конструктор можно передать набор прессетов и опции (ознакомиться с ними можно ниже)
     * @doctemplate method_annotation
     */
    function Config() {
        var presets = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            presets[_i] = arguments[_i];
        }
        this.values = {};
        this.extend.apply(this, __spreadArrays(this.constructor.DEFAULTS, presets));
    }
    Config.extend = function () {
        var _a;
        var presets = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            presets[_i] = arguments[_i];
        }
        return _a = /** @class */ (function (_super) {
                __extends$d(ExtendedConfig, _super);
                function ExtendedConfig() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                return ExtendedConfig;
            }(this)),
            _a.DEFAULTS = presets,
            _a;
    };
    /**
     * Добавляет переданные пресеты в конфиг, во время создания конфига
     * все пресеты объединяются в 1 конфиг в порядке добавления
     * @param presets Пресеты для расширения
     * @returns Конфиг с обновленными пресетами
     */
    Config.prototype.extend = function () {
        var presets = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            presets[_i] = arguments[_i];
        }
        this.values = presets.reduce(function (aux, item) {
            return __assign$2(__assign$2(__assign$2({}, aux), item), { iframeOpenData: __assign$2(__assign$2({}, aux.iframeOpenData), item.iframeOpenData), flags: __assign$2(__assign$2({}, aux.flags), item.flags) });
        }, __assign$2({}, this.values));
    };
    Config.prototype.getFlags = function () {
        var allFlags = __assign$2(__assign$2({}, this.values.flags), (this.values.fullscreen ? presets.fullscreen.flags : undefined));
        return Object.keys(allFlags).reduce(function (aux, flag) {
            if (flag !== null && flag !== undefined && allFlags[flag] !== undefined) {
                aux.push(flag + "=" + allFlags[flag]);
            }
            return aux;
        }, []).join(';');
    };
    Config.prototype.getMessengerUrl = function (widgetId, protocolVersion, additional) {
        var _a = this.values, origin = _a.origin, config = _a.config, build = _a.build, tld = _a.tld, _b = _a.lang, lang = _b === void 0 ? 'ru' : _b, serviceId = _a.serviceId, workspaceId = _a.workspaceId, orgId = _a.orgId, catchUrlClick = _a.catchUrlClick, unreadCounterChatId = _a.unreadCounterChatId, unreadCounterOtherGuid = _a.unreadCounterOtherGuid, unreadCounterNsFilter = _a.unreadCounterNsFilter, unreadWithCountChats = _a.unreadWithCountChats, debug = _a.debug, authType = _a.authType;
        var params = __assign$2({ config: config,
            build: build,
            lang: lang,
            debug: debug, parentOrigin: getOrigin(), parentUrl: window.location.href, serviceId: serviceId,
            workspaceId: workspaceId,
            orgId: orgId, utm_source: 'widget', utm_medium: 'iframe', widgetId: widgetId, flags: this.getFlags(), protocolVersion: protocolVersion,
            authType: authType,
            unreadCounterChatId: unreadCounterChatId,
            unreadCounterOtherGuid: unreadCounterOtherGuid,
            unreadCounterNsFilter: unreadCounterNsFilter,
            unreadWithCountChats: unreadWithCountChats, catchUrlClick: catchUrlClick ? 'true' : undefined }, additional);
        var result = queryStringify$1(replaceTld(replaceTld(origin, tld)), params);
        return result;
    };
    Config.DEFAULTS = [];
    return Config;
}());

/**
 * @doctemplate doc_only
 * @doctitle Часто используемые конфиги
 * @doc
 * Для быстрой конфигурации виджета можно использовать готовые конфиги,
 * они все настроены на продакшен (при необходимости дефолтные параметры можно изменить)
 *
 * @docsubtitle Пример импорта конфига
 * @example
 * import { Widget, YandexConfig } from 'yandex-int/messenger.widget'
 *
 * const widget = new Widget(new YandexConfig({
 *     serviceId: 12,
 * }));
 *
 * @doc
 * `YandexConfig` - Конфиг виджета для внешних сервисов яндекса (версия со списком чатов)
 */
var YandexConfig = /** @class */ (function (_super) {
    __extends$d(YandexConfig, _super);
    function YandexConfig() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    YandexConfig.DEFAULTS = [
        presets.backend.prod,
        presets.origin.external.prod,
        presets.type.external.multiChats(),
    ];
    return YandexConfig;
}(Config));

/**
 * @doctemplate doc_only
 * @doc
 * `YandexSingleChatConfig` - Конфиг виджета для внешних сервисов яндекса (версия для одного чата)
 */
var YandexSingleChatConfig = /** @class */ (function (_super) {
    __extends$d(YandexSingleChatConfig, _super);
    function YandexSingleChatConfig() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    YandexSingleChatConfig.DEFAULTS = [
        presets.backend.prod,
        presets.origin.external.prod,
        presets.type.external.multiChats(),
    ];
    return YandexSingleChatConfig;
}(Config));
/**
 * @doctemplate doc_only
 * @doc
 * `YandexSingleBlockChatConfig` - Конфиг виджета для внешних сервисов яндекса
 * для BlockUI (версия для одного чата)
 */
var YandexSingleBlockChatConfig = /** @class */ (function (_super) {
    __extends$d(YandexSingleBlockChatConfig, _super);
    function YandexSingleBlockChatConfig() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    YandexSingleBlockChatConfig.DEFAULTS = [
        presets.backend.prod,
        presets.origin.external.prod,
        presets.type.external.singleChat({ inline: true }),
    ];
    return YandexSingleBlockChatConfig;
}(Config));

/**
 * @doctemplate doc_only
 * @doc
 * `YandexTeamConfig` - Конфиг виджета для внутренних сервисов яндекса (версия со списком чатов)
 */
var YandexTeamConfig = /** @class */ (function (_super) {
    __extends$d(YandexTeamConfig, _super);
    function YandexTeamConfig() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    YandexTeamConfig.DEFAULTS = [
        presets.backend.prod,
        presets.origin.team.prod,
        presets.type.team.multiChats(),
    ];
    return YandexTeamConfig;
}(Config));

/**
 * @doctemplate doc_only
 * @doc
 * `YandexTeamSingleChatConfig` - Конфиг виджета для внутренних сервисов яндекса (версия для одного чата)
 */
var YandexTeamSingleChatConfig = /** @class */ (function (_super) {
    __extends$d(YandexTeamSingleChatConfig, _super);
    function YandexTeamSingleChatConfig() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    YandexTeamSingleChatConfig.DEFAULTS = [
        presets.backend.prod,
        presets.origin.team.prod,
        presets.type.team.singleChat(),
    ];
    return YandexTeamSingleChatConfig;
}(Config));
/**
 * @doctemplate doc_only
 * @doc
 * `YandexTeamSingleBlockChatConfig` - Конфиг виджета для внутренних сервисов яндекса
 * для BlockUI (версия для одного чата)
 */
var YandexTeamSingleBlockChatConfig = /** @class */ (function (_super) {
    __extends$d(YandexTeamSingleBlockChatConfig, _super);
    function YandexTeamSingleBlockChatConfig() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    YandexTeamSingleBlockChatConfig.DEFAULTS = [
        presets.backend.prod,
        presets.origin.team.prod,
        presets.type.team.singleChat({ inline: true }),
    ];
    return YandexTeamSingleBlockChatConfig;
}(Config));

var LoggerFacade = /** @class */ (function () {
    function LoggerFacade() {
    }
    LoggerFacade.prototype.configurate = function (loggerFactory) {
        this.loggerFactory = loggerFactory;
    };
    LoggerFacade.prototype.create = function (name) {
        if (!this.loggerFactory) {
            return {
                log: function () { },
                error: function () { },
            };
        }
        return this.loggerFactory(name);
    };
    return LoggerFacade;
}());

var loggerFacade = new LoggerFacade();
function createLogger(name) {
    return loggerFacade.create(name);
}

var GUID_MASK = 'xxxx-xxxx-xxxx-xxxx';
var CLOSE_CODE;
(function (CLOSE_CODE) {
    /**
     * Закрыто пользователем
     */
    CLOSE_CODE[CLOSE_CODE["NORMAL"] = 0] = "NORMAL";
    /**
     * Соединение прервано, но возможно восстановится
     */
    CLOSE_CODE[CLOSE_CODE["CONNECTION_CLOSED"] = 1] = "CONNECTION_CLOSED";
    /**
     * Соединение невозможно установить
     */
    CLOSE_CODE[CLOSE_CODE["ERROR"] = 2] = "ERROR";
    /**
     * Соединение закрыто, не может быть восстановлено без перезагрузки транспорта
     */
    CLOSE_CODE[CLOSE_CODE["CONNECTION_TERMINATED"] = 3] = "CONNECTION_TERMINATED";
})(CLOSE_CODE || (CLOSE_CODE = {}));
var PING_MESSAGE = '@@@@ping';
var PONG_MESSAGE = '@@@@pong';

var __extends$7 = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate$7 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ChannelError = /** @class */ (function (_super) {
    __extends$7(ChannelError, _super);
    function ChannelError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, ChannelError_1.prototype);
        return _this;
    }
    ChannelError_1 = ChannelError;
    var ChannelError_1;
    ChannelError = ChannelError_1 = __decorate$7([
        lib$1.serializeId('@ChannelError')
    ], ChannelError);
    return ChannelError;
}(lib$1.SerializableError));

var __extends$6 = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate$6 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ConnectionClosedError = /** @class */ (function (_super) {
    __extends$6(ConnectionClosedError, _super);
    function ConnectionClosedError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, ConnectionClosedError_1.prototype);
        return _this;
    }
    ConnectionClosedError_1 = ConnectionClosedError;
    var ConnectionClosedError_1;
    ConnectionClosedError = ConnectionClosedError_1 = __decorate$6([
        lib$1.serializeId('@ConnectionClosedError')
    ], ConnectionClosedError);
    return ConnectionClosedError;
}(ChannelError));

var __extends$5 = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate$5 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var UnhandledResponseError = /** @class */ (function (_super) {
    __extends$5(UnhandledResponseError, _super);
    function UnhandledResponseError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, UnhandledResponseError_1.prototype);
        return _this;
    }
    UnhandledResponseError_1 = UnhandledResponseError;
    var UnhandledResponseError_1;
    UnhandledResponseError = UnhandledResponseError_1 = __decorate$5([
        lib$1.serializeId('@UnhandledResponseError')
    ], UnhandledResponseError);
    return UnhandledResponseError;
}(ChannelError));

var validator = Shape.create({
    channelId: Shape.is.string,
    id: Shape.is.string,
    error: Shape.is.optional.any,
    type: Shape.is.values('request', 'response', 'registration', 'kill', 'observe', 'unobserve', 'notify', 'event', 'ready'),
    refId: Shape.is.optional.string,
    data: Shape.is.any,
});
function isChannelEvent(object) {
    return validator.validate(object);
}
function deserializeError(serializedError) {
    var error = lib$1.SerializableError.deserialize(serializedError);
    return error || new ChannelError('unknown');
}
function serializeError(error) {
    if (!error) {
        return;
    }
    if (typeof error === 'string') {
        return new ChannelError(error).serialize();
    }
    if (error instanceof lib$1.SerializableError) {
        return lib$1.SerializableError.serialize(error);
    }
    if (error instanceof Error) {
        return new ChannelError(error.message).serialize();
    }
    return new ChannelError('unknown').serialize();
}
function eventFactoryProvider(channelId) {
    return function (type, data, error, refId) {
        if (error === void 0) { error = undefined; }
        if (refId === void 0) { refId = ''; }
        return {
            channelId: channelId,
            id: guid(GUID_MASK),
            refId: refId,
            type: type,
            data: data,
            error: serializeError(error),
        };
    };
}

var __decorate$4 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var log$1 = createLogger('ChannelBase').log;
var ChannelBase = /** @class */ (function () {
    function ChannelBase(channelId) {
        this.channelId = channelId;
        /**
         * Статус соединения
         */
        this.connectionStatus = 'closed';
        /**
         * Вызывается при приходе запроса
         */
        this.onRequest = new Event();
        /**
         * Вызывается при приходе события
         */
        this.onEvent = new Event();
        /**
         * Вызывается при закрытии соединения
         */
        this.onClose = new Event();
        /**
         * Вызывается при запросе на обзервинг объекта
         */
        this.onObserve = new Event();
        /**
         * Мэппинг обзерверов объектов
         */
        this.observers = new Map();
        /**
         * Список обзервируемых объектов
         */
        this.observables = new Set();
        /**
         * Бакет запросов
         */
        this.requests = new RequestsBucket();
        /**
         * Очередь сообщений в порт
         */
        this.queue = new Queue(true);
        /**
         * Мапа обработчиков событий
         */
        this.eventHandlers = new Map();
        this.eventFactory = eventFactoryProvider(this.channelId);
        this.eventHandlers
            .set('observe', this.handleObserveMessage)
            .set('unobserve', this.handleUnobserveMessage)
            .set('event', this.handleEventMessage)
            .set('response', this.handleResponseMessage)
            .set('request', this.handleRequestMessage)
            .set('notify', this.handleNotifyMessage)
            .set('kill', this.handleKillMessage);
    }
    /**
     * Выполнить запрос
     *
     * @param type Имя запроса
     * @param data Данные запроса
     * @param options Опции запроса
     * @returns Promise
     */
    ChannelBase.prototype.request = function (type, data, options) {
        if (options === null || options === void 0 ? void 0 : options.cancelPreviousRequestsWithSameType) {
            this.queue.cancel({ tag: type });
        }
        return this.sendRequest(this.eventFactory('request', { type: type, data: data }), options);
    };
    /**
     * Отправить событие
     *
     * @param type Имя события
     * @param data Данные события
     */
    ChannelBase.prototype.event = function (type, data) {
        this.sendEvent(this.eventFactory('event', { type: type, data: data }));
    };
    /**
     * Подписаться на обновление объекта с именем @param objectName
     *
     * @param objectName Имя обозреваемого объекта
     * @param callback Колбек вызываемый при получении нотификации
     * @returns Promise
     */
    ChannelBase.prototype.observe = function (objectName, callback) {
        log$1('adding observer: %s', objectName);
        this.addObserver(objectName, callback);
        return this.sendRequest(this.eventFactory('observe', { objectName: objectName }));
    };
    /**
     * Отписаться от обновление объекта с именем @param objectName
     *
     * @param objectName Имя обозреваемого объекта
     * @param callback Колбек вызываемый при получении нотификации
     * @returns Promise
     */
    ChannelBase.prototype.unobserve = function (objectName, callback) {
        this.removeObserver(objectName, callback);
        if (this.getObserver(objectName).callbacks.size) {
            return Promise.resolve();
        }
        return this.sendRequest(this.eventFactory('unobserve', { objectName: objectName }));
    };
    /**
     * Уведомить обозревателей об изменении объекта
     *
     * @param objectName Имя обозреваемого объекта
     * @param object Объект
     */
    ChannelBase.prototype.notifyObservers = function (objectName, object) {
        if (this.observables.has(objectName)) {
            this.sendEvent(this.eventFactory('notify', {
                object: object,
                objectName: objectName,
            }));
        }
    };
    /**
     * Установить порт
     * @param port MessagePort для общения
     */
    ChannelBase.prototype.setPort = function (port) {
        if (this.port) {
            this.port.close();
            this.port.removeEventListener('message', this.handleMessage);
        }
        this.port = port;
        this.port.addEventListener('message', this.handleMessage);
        this.port.start();
    };
    /**
     * Разблокировать очередь событий
     */
    ChannelBase.prototype.unlock = function () {
        this.connectionStatus = 'opened';
        this.queue.unlock();
    };
    /**
     * Закрыть канал c причиной @param reason
     * После закрытия канала будет вызвано событие @see onClose
     * Закрытый канал открывается снова при приходе входящего сообщения
     *
     * @param closeCode Код закрытия канала
     * @param reason Причина закрытия канала
     * @param error Ошибка закрытия канала
     */
    ChannelBase.prototype.close = function (_a) {
        var _b = _a.closeCode, closeCode = _b === void 0 ? CLOSE_CODE.NORMAL : _b, _c = _a.reason, reason = _c === void 0 ? 'Transport was closed' : _c, _d = _a.error, error = _d === void 0 ? new ConnectionClosedError(reason) : _d, _e = _a.persistQueue, persistQueue = _e === void 0 ? false : _e;
        log$1('destroying', this.channelId, reason);
        if (this.connectionStatus === 'closed') {
            return;
        }
        this.closeCode = closeCode;
        this.closeReason = reason;
        this.closeError = error;
        this.connectionStatus = 'closed';
        this.cleanup(error, persistQueue);
        this.queue.lock();
        var port = this.port;
        if (port) {
            port.removeEventListener('message', this.handleMessage);
            try {
                this.sendBypass(this.eventFactory('kill', undefined, error));
            }
            catch (_f) { }
            try {
                port.close();
            }
            catch (_g) { }
        }
        this.port = undefined;
        this.onClose.dispatch(this);
    };
    ChannelBase.prototype.cleanup = function (error, persistQueue) {
        if (error === void 0) { error = new ChannelBase.CancelError('Cleanup'); }
        if (persistQueue === void 0) { persistQueue = false; }
        this.observers.clear();
        if (!persistQueue) {
            this.queue.cancel(undefined, error);
        }
        this.requests.drop(error);
    };
    ChannelBase.prototype.sendRequest = function (event, options) {
        var _this = this;
        log$1('enqueue request: %o', event);
        var type = (event.data || {}).type;
        return new Promise(function (resolve, reject) {
            _this.queue.push(new QueueTask(function () {
                _this.requests.request(function () { return _this.sendBypass(event); }, options === null || options === void 0 ? void 0 : options.timeout)
                    .then(resolve)
                    .catch(reject);
            }, {
                onCancel: function (error) {
                    if (error === void 0) { error = new ChannelBase.CancelError('Request cancelled'); }
                    reject(error);
                },
                tag: type,
            }));
        });
    };
    ChannelBase.prototype.sendEvent = function (event) {
        var _this = this;
        log$1('enqueue event: %o', event);
        var type = (event.data || {}).type;
        this.queue.push(new QueueTask(function () {
            _this.sendBypass(event);
        }, {
            tag: type,
        }));
    };
    ChannelBase.prototype.sendBypass = function (event) {
        if (!this.port) {
            throw new ChannelError('Port not found');
        }
        log$1('sending message: %o', event);
        this.port.postMessage(event);
        return event.id;
    };
    ChannelBase.prototype.handleMessage = function (event) {
        var _a;
        var data = event.data;
        log$1('message handled: %o', data);
        if (!isChannelEvent(data)) {
            return;
        }
        if (data.channelId !== this.channelId) {
            return;
        }
        event.stopImmediatePropagation();
        (_a = this.eventHandlers.get(data.type)) === null || _a === void 0 ? void 0 : _a(event);
    };
    ChannelBase.prototype.handleResponseMessage = function (event) {
        var _a = event.data, refId = _a.refId, data = _a.data, error = _a.error;
        if (error) {
            log$1('handle response error: %o', error);
            this.requests.result(refId, deserializeError(error));
        }
        else {
            log$1('handle response: %o', event.data);
            this.requests.result(refId, undefined, data);
        }
    };
    ChannelBase.prototype.handleRequestMessage = function (event) {
        var _this = this;
        var _a = event.data, data = _a.data, id = _a.id;
        this.onRequest.dispatch({
            type: data.type,
            payload: data.data,
            reject: function (error) {
                _this.sendBypass(_this.eventFactory('response', undefined, error, id));
            },
            response: function (response) {
                Promise.resolve(response)
                    .then(function (unPromisedResponse) {
                    _this.sendBypass(_this.eventFactory('response', unPromisedResponse, undefined, id));
                })
                    .catch(function (error) {
                    _this.sendBypass(_this.eventFactory('response', undefined, error, id));
                });
            },
        });
    };
    ChannelBase.prototype.handleKillMessage = function (event) {
        log$1('handle kill message: %o', event.data);
        var error = event.data.error ? deserializeError(event.data.error) : undefined;
        this.close({
            closeCode: ConnectionClosedError.is(error) ? CLOSE_CODE.CONNECTION_CLOSED : CLOSE_CODE.ERROR,
            reason: 'kill signal',
            error: error,
        });
    };
    ChannelBase.prototype.handleUnobserveMessage = function (event) {
        var _a;
        log$1('handle unobserve message: %o', event.data);
        var objectName = (_a = event.data.data) === null || _a === void 0 ? void 0 : _a.objectName;
        this.observables.delete(objectName);
        this.sendEvent(this.eventFactory('response', undefined, undefined, event.data.id));
    };
    ChannelBase.prototype.handleObserveMessage = function (event) {
        var _this = this;
        log$1('handle observe message: %o', event);
        var _a = event.data, data = _a.data, id = _a.id;
        var objectName = data.objectName;
        this.observables.add(objectName);
        this.onObserve.dispatch({
            data: {
                objectName: objectName,
            },
            notify: function (object) {
                _this.notifyObservers(objectName, object);
            },
        });
        this.sendEvent(this.eventFactory('response', undefined, undefined, id));
    };
    ChannelBase.prototype.handleNotifyMessage = function (event) {
        log$1('handle notify message: %o', event.data);
        var _a = event.data.data, objectName = _a.objectName, object = _a.object;
        this.getObserver(objectName).callbacks.forEach(function (callback) { return callback(object); });
    };
    ChannelBase.prototype.handleEventMessage = function (event) {
        log$1('handle event message: $o', event.data);
        this.onEvent.dispatch({
            type: event.data.data.type,
            data: event.data.data.data,
        });
    };
    ChannelBase.prototype.getObserver = function (objectName) {
        var observer = this.observers.get(objectName);
        if (!observer) {
            observer = {
                callbacks: new Set(),
            };
            this.observers.set(objectName, observer);
        }
        return observer;
    };
    ChannelBase.prototype.addObserver = function (objectName, callback) {
        var observer = this.getObserver(objectName);
        observer.callbacks.add(callback);
    };
    ChannelBase.prototype.removeObserver = function (objectName, callback) {
        var observer = this.getObserver(objectName);
        observer.callbacks.delete(callback);
    };
    ChannelBase.CancelError = ChannelError;
    __decorate$4([
        lib$2.bind
    ], ChannelBase.prototype, "handleMessage", null);
    __decorate$4([
        lib$2.bind
    ], ChannelBase.prototype, "handleResponseMessage", null);
    __decorate$4([
        lib$2.bind
    ], ChannelBase.prototype, "handleRequestMessage", null);
    __decorate$4([
        lib$2.bind
    ], ChannelBase.prototype, "handleKillMessage", null);
    __decorate$4([
        lib$2.bind
    ], ChannelBase.prototype, "handleUnobserveMessage", null);
    __decorate$4([
        lib$2.bind
    ], ChannelBase.prototype, "handleObserveMessage", null);
    __decorate$4([
        lib$2.bind
    ], ChannelBase.prototype, "handleNotifyMessage", null);
    __decorate$4([
        lib$2.bind
    ], ChannelBase.prototype, "handleEventMessage", null);
    return ChannelBase;
}());

var __extends$4 = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate$3 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var log = createLogger('ChannelOutgoing').log;
var ChannelOutgoing = /** @class */ (function (_super) {
    __extends$4(ChannelOutgoing, _super);
    /**
     * @param channelId Индентификатор канала
     * @param channelTransportProvider Провайдер для инстанса транспорта
     * @param params Параметры канала
     */
    function ChannelOutgoing(channelId, channelTransportProvider, params) {
        var _this = _super.call(this, channelId) || this;
        _this.channelTransportProvider = channelTransportProvider;
        _this.params = params;
        /**
         * События установки соединения с ответным каналом
         */
        _this.onConnectionEstablished = new Event();
        _this.eventHandlers.set('ready', _this.handleReady);
        return _this;
    }
    /**
     * Открыть соединение
     */
    ChannelOutgoing.prototype.connect = function () {
        this.sendRegistrationEvent();
    };
    /**
     * Удалить текущий транспорт
     * При удалении не очищается очередь запросов и событий
     * Канал тихо (без вызова onClose) перейдет в режим close
     */
    ChannelOutgoing.prototype.disposeTransport = function () {
        var _a, _b;
        (_a = this.transport) === null || _a === void 0 ? void 0 : _a.onClose.removeListener(this.handleClose);
        (_b = this.transport) === null || _b === void 0 ? void 0 : _b.onOpen.removeListener(this.handleOpen);
        this.transport = undefined;
        this.requestTransportCallback = undefined;
        this.connectionStatus = 'closed';
    };
    ChannelOutgoing.prototype.sendRegistrationEvent = function (isReconnect) {
        var _this = this;
        var _a;
        if (isReconnect === void 0) { isReconnect = false; }
        if (!this.ensureTransport()) {
            return;
        }
        log('connecting');
        this.connectionStatus = 'connecting';
        this.closeReason = undefined;
        this.closeCode = undefined;
        this.closeError = undefined;
        this.requests.request(function () {
            var _a;
            var event = _this.eventFactory('registration', (_a = _this.params) === null || _a === void 0 ? void 0 : _a.scope);
            log('sending register event to receiver: %o, %s', event);
            var channel = new MessageChannel();
            _this.setPort(channel.port1);
            _this.transport.send(event, [channel.port2]);
            return event.id;
        }, (_a = this.params) === null || _a === void 0 ? void 0 : _a.connectTimeout)
            .then(function (response) {
            log('connected, status: %o', status);
            if (!response.manualUnlock) {
                _this.ready(isReconnect);
            }
        })
            .catch(function (error) {
            log('failed to connect: %o', error);
            _this.close({
                closeCode: CLOSE_CODE.ERROR,
                reason: error === null || error === void 0 ? void 0 : error.message,
                error: error,
                persistQueue: true,
            });
        });
    };
    ChannelOutgoing.prototype.sendRequest = function (event) {
        if (this.connectionStatus === 'closed') {
            this.connect();
        }
        return _super.prototype.sendRequest.call(this, event);
    };
    ChannelOutgoing.prototype.sendEvent = function (event) {
        if (this.connectionStatus === 'closed') {
            this.connect();
        }
        return _super.prototype.sendEvent.call(this, event);
    };
    ChannelOutgoing.prototype.ensureTransport = function () {
        if (this.transport && this.transport.closed()) {
            this.disposeTransport();
        }
        if (!this.transport && !this.requestTransportCallback) {
            this.requestTransport();
        }
        return Boolean(this.transport);
    };
    ChannelOutgoing.prototype.requestTransport = function () {
        var _this = this;
        var requestTransportCallback = once(function (transport, error) {
            if (requestTransportCallback !== _this.requestTransportCallback) {
                return;
            }
            _this.requestTransportCallback = undefined;
            if (error) {
                _this.close({
                    closeCode: CLOSE_CODE.ERROR,
                    reason: 'Request transport callback error',
                    error: error,
                    persistQueue: true,
                });
                return;
            }
            _this.transport = transport;
            _this.transport.onClose.addListener(_this.handleClose);
            _this.transport.onOpen.addListener(_this.handleOpen);
            if (_this.transport.connectionStatus === 'opened') {
                _this.connect();
            }
            else {
                _this.connectionStatus = 'closed';
                _this.transport.connect();
            }
        });
        this.requestTransportCallback = requestTransportCallback;
        this.connectionStatus = 'connecting';
        try {
            this.channelTransportProvider(this.requestTransportCallback);
        }
        catch (error) {
            this.close({
                closeCode: CLOSE_CODE.ERROR,
                reason: 'Transport provider error',
                error: error,
                persistQueue: true,
            });
        }
    };
    ChannelOutgoing.prototype.handleClose = function (error) {
        this.close({
            closeCode: CLOSE_CODE.ERROR,
            reason: error === null || error === void 0 ? void 0 : error.message,
            error: error,
        });
    };
    ChannelOutgoing.prototype.handleOpen = function (_a) {
        var reconnect = _a.reconnect;
        log('handle open singal', reconnect, this.connectionStatus);
        if (reconnect || this.connectionStatus === 'closed') {
            this.close({
                closeCode: CLOSE_CODE.CONNECTION_CLOSED,
                reason: 'reconnecting',
            });
            this.sendRegistrationEvent(reconnect);
        }
    };
    ChannelOutgoing.prototype.handleReady = function () {
        this.ready();
    };
    ChannelOutgoing.prototype.ready = function (isReconnect) {
        if (isReconnect === void 0) { isReconnect = false; }
        this.unlock();
        this.onConnectionEstablished.dispatch({ reconnect: isReconnect });
    };
    /**
     * Завершить работу с каналом.
     * После завершения работы каналом больше нельзя пользоваться.
     * После завершения работы канал не откроется автоматически.
     *
     * @param closeCode Код закрытия канала
     * @param reason Причина закрытия канала
     */
    ChannelOutgoing.prototype.dispose = function (closeCode, reason) {
        var currentConnectionStatus = this.connectionStatus;
        this.disposeTransport();
        // Грязный хак, так как disposeTransport тихо переводит
        // канал в connectionStatus = closed, а метод close не отработает
        // если канал уже закрыт
        this.connectionStatus = currentConnectionStatus;
        this.close({ closeCode: closeCode, reason: reason });
    };
    __decorate$3([
        lib$2.bind
    ], ChannelOutgoing.prototype, "handleClose", null);
    __decorate$3([
        lib$2.bind
    ], ChannelOutgoing.prototype, "handleOpen", null);
    __decorate$3([
        lib$2.bind
    ], ChannelOutgoing.prototype, "handleReady", null);
    return ChannelOutgoing;
}(ChannelBase));

var __decorate$2 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var PostMessageChannelTransport = /** @class */ (function () {
    /**
     * @param manualOpen последовательностью открытия транспорта управляет наследник
     */
    function PostMessageChannelTransport(manualOpen) {
        if (manualOpen === void 0) { manualOpen = false; }
        this.manualOpen = manualOpen;
        this.onMessage = new Event();
        this.onClose = new Event();
        this.onOpen = new Event();
        this.connectionStatus = 'closed';
        this.connectionCount = 0;
        this.queue = new Queue(true);
    }
    PostMessageChannelTransport.prototype.send = function (message, transfer) {
        var _this = this;
        this.queue.push(new QueueTask(function () {
            _this.sendBypass(message, transfer);
        }));
    };
    PostMessageChannelTransport.prototype.ping = function () {
        this.sendBypass(PING_MESSAGE);
    };
    PostMessageChannelTransport.prototype.pong = function () {
        this.sendBypass(PONG_MESSAGE);
    };
    PostMessageChannelTransport.prototype.close = function (error) {
        if (this.connectionStatus === 'closed') {
            return;
        }
        this.connectionStatus = 'closed';
        this.queue.cancel(undefined, error === null || error === void 0 ? void 0 : error.message);
        this.queue.lock();
        this.onClose.dispatch(error);
    };
    PostMessageChannelTransport.prototype.handleOpen = function () {
        var isOpenned = this.connectionStatus === 'opened';
        if (!isOpenned) {
            this.connectionStatus = 'opened';
        }
        this.connectionCount++;
        this.onOpen.dispatch({
            reconnect: this.connectionCount > 1,
        });
        if (!isOpenned) {
            this.queue.unlock();
        }
    };
    PostMessageChannelTransport.prototype.handleMessage = function (message) {
        if (!this.validateMessage(message)) {
            return;
        }
        // https://html.spec.whatwg.org/multipage/web-messaging.html#posting-messages
        // w3c рекомендует использовать ping для того что бы понять,
        // что обратная сторона готова принимать сообщения.
        // Так как чисто теоретически в конструктор можно передать уже давно созданный iframe
        // то используем ping/pong для того что бы точно убедиться что транспорты готовы.
        if (isString(message.data)) {
            switch (message.data) {
                case PING_MESSAGE:
                    this.pong();
                    if (!this.manualOpen) {
                        this.handleOpen();
                    }
                    return;
                case PONG_MESSAGE:
                    if (!this.manualOpen && this.connectionStatus === 'connecting') {
                        this.handleOpen();
                    }
                    return;
            }
        }
        if (this.connectionStatus === 'opened') {
            this.onMessage.dispatch(message);
        }
    };
    __decorate$2([
        lib$2.bind
    ], PostMessageChannelTransport.prototype, "handleMessage", null);
    return PostMessageChannelTransport;
}());

var __extends$3 = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var IframePostMessageTransport = /** @class */ (function (_super) {
    __extends$3(IframePostMessageTransport, _super);
    /**
     * @param childWindow Инстанс окна (window/iframe.contentWindow) получателя сообщений
     * @param targetOrigin Ориджин получателя сообщений
     */
    function IframePostMessageTransport(childWindow, targetOrigin) {
        var _this = _super.call(this) || this;
        _this.childWindow = childWindow;
        _this.targetOrigin = targetOrigin;
        childWindow.parent.addEventListener('message', _this.handleMessage);
        return _this;
    }
    IframePostMessageTransport.prototype.connect = function () {
        this.connectionStatus = 'connecting';
        this.ping();
    };
    IframePostMessageTransport.prototype.sendBypass = function (message, transfer) {
        var _a;
        (_a = this.childWindow) === null || _a === void 0 ? void 0 : _a.postMessage(message, this.targetOrigin, transfer);
    };
    IframePostMessageTransport.prototype.validateMessage = function (message) {
        return message.source === this.childWindow && compareOrigins(message.origin, [this.targetOrigin]);
    };
    IframePostMessageTransport.prototype.dispose = function () {
        var _a;
        (_a = this.childWindow) === null || _a === void 0 ? void 0 : _a.parent.removeEventListener('message', this.handleMessage);
        this.childWindow = undefined;
        this.close();
    };
    IframePostMessageTransport.prototype.closed = function () {
        var _a;
        return Boolean((_a = this.childWindow) === null || _a === void 0 ? void 0 : _a.closed);
    };
    return IframePostMessageTransport;
}(PostMessageChannelTransport));

var __extends$2 = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var ChildWindowPostMessageTransport = /** @class */ (function (_super) {
    __extends$2(ChildWindowPostMessageTransport, _super);
    /**
     * @param childWindow Инстанс окна получателя сообщений
     * @param currentWindow Ориджин получателя сообщений
     * @param targetOrigin Ориджин получателя сообщений
     * @param allowedOrigins Разрешенные ориджины для входящих сообщений
     */
    function ChildWindowPostMessageTransport(childWindow, currentWindow, targetOrigin, allowedOrigins) {
        var _this = _super.call(this, false) || this;
        _this.childWindow = childWindow;
        _this.currentWindow = currentWindow;
        _this.targetOrigin = targetOrigin;
        _this.allowedOrigins = allowedOrigins;
        _this.currentWindow.addEventListener('message', _this.handleMessage);
        return _this;
    }
    ChildWindowPostMessageTransport.prototype.connect = function () {
        this.connectionStatus = 'connecting';
        this.ping();
    };
    ChildWindowPostMessageTransport.prototype.sendBypass = function (message, transfer) {
        var _a;
        (_a = this.childWindow) === null || _a === void 0 ? void 0 : _a.postMessage(message, this.targetOrigin, transfer);
    };
    ChildWindowPostMessageTransport.prototype.validateMessage = function (message) {
        return compareOrigins(message.origin, this.allowedOrigins);
    };
    ChildWindowPostMessageTransport.prototype.dispose = function () {
        this.currentWindow.removeEventListener('message', this.handleMessage);
        this.childWindow = undefined;
        this.currentWindow = undefined;
        this.close();
    };
    ChildWindowPostMessageTransport.prototype.closed = function () {
        return Boolean(this.childWindow.closed);
    };
    return ChildWindowPostMessageTransport;
}(PostMessageChannelTransport));

var lib = {};

var settings = {};

var __assign$1 = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign$1 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};
Object.defineProperty(settings, "__esModule", { value: true });
settings.getSettings = settings.updateSettings = void 0;
var baseSettings = {
    clck: 'https://yandex.ru/clck/click',
    project: 'unknown',
    additional: {},
    level: 'error',
};
var updateSettings = function (newSettings) {
    baseSettings = __assign$1(__assign$1({}, baseSettings), newSettings);
};
settings.updateSettings = updateSettings;
var getSettings = function () {
    return baseSettings;
};
settings.getSettings = getSettings;

var implementation = {};

var send$1 = {};

Object.defineProperty(send$1, "__esModule", { value: true });
send$1.send = void 0;
var settings_1 = settings;
var getCounterSections = function (path, vars) {
    return [
        '/path=' + path,
        vars ? '/vars=' + vars : '',
        '/cts=' + new Date().getTime(),
        '/*',
    ];
};
var send = function (path, vars) {
    var data = getCounterSections(path, vars).join('');
    var clck = settings_1.getSettings().clck;
    if (!clck) {
        return;
    }
    var sendBeaconResult = navigator && navigator.sendBeacon && navigator.sendBeacon(clck, data);
    if (!sendBeaconResult) {
        if (typeof window !== 'undefined' && window.fetch) {
            fetch(clck, {
                method: 'POST',
                body: data,
            });
        }
        else {
            var xhr = new XMLHttpRequest();
            xhr.open('POST', clck);
            xhr.send(data);
        }
    }
};
send$1.send = send;

(function (exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (commonjsGlobal && commonjsGlobal.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleError = exports.sendError = exports.baseNormalizeError = void 0;
var send_1 = send$1;
var settings_1 = settings;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var baseNormalizeError = function (err) {
    if (err === void 0) { err = {}; }
    var file = err.filename || err.fileName || '';
    var stack = (err.error && err.error.stack) || err.stack || '';
    var message = err.message || '';
    return {
        file: file,
        line: err.lineno || err.lineNumber,
        col: err.colno || err.colNumber,
        stack: stack,
        message: message,
        additional: err.additional,
        referrer: typeof location !== 'undefined' && location.href,
    };
};
exports.baseNormalizeError = baseNormalizeError;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var createVarsString = function (vars) {
    var varsArr = [];
    Object.keys(vars).map(function (key) {
        if (vars.hasOwnProperty(key) && (vars[key] || vars[key] === 0)) {
            var value = encodeURIComponent(vars[key]).replace(/\*/g, '%2A');
            varsArr.push(key + "=" + value);
        }
    });
    return varsArr.join(',');
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function safeConsoleError(message) {
    var _a;
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (typeof console !== 'undefined') {
        (_a = console.error).call.apply(_a, __spreadArrays([console, message], args));
    }
}
var sendError = function (err, params) {
    if (params === void 0) { params = {}; }
    var settings = settings_1.getSettings();
    var vars = {
        // генерится браузером
        '-url': err.file,
        '-line': err.line,
        '-col': err.col,
        '-stack': err.stack,
        // окружение
        '-env': settings.env,
        // заполняется в событии браузера или передается вручную
        '-msg': err.message,
        // принадлежность к сервису
        '-project': settings.project,
        '-page': err.page || settings.page,
        '-level': err.level,
        '-version': settings.version,
        '-referrer': err.referrer,
        // хэш с дополнительными параметрами
        '-additional': params.additional,
        // ua - попробуем брать из кук
        '-ua': typeof navigator !== 'undefined' && navigator.userAgent,
        // клиентское время ошибки
        '-ts': +new Date(),
    };
    if (settings.debug) {
        safeConsoleError('[error-counter]', vars);
    }
    send_1.send(err.path, createVarsString(vars));
};
exports.sendError = sendError;
var PATH_CLIENT_ERROR = '690.2354';
var handleError = function (error) {
    var settings = settings_1.getSettings();
    error.path = PATH_CLIENT_ERROR;
    var additional = '';
    try {
        additional = JSON.stringify(__assign(__assign({}, settings.additional), error.additional));
    }
    catch (e) {
        safeConsoleError('[error-counter] json.stringify:', e);
    }
    exports.sendError(error, { additional: additional });
};
exports.handleError = handleError;
}(implementation));

var logError$2 = {};

Object.defineProperty(logError$2, "__esModule", { value: true });
logError$2.logError = void 0;
var implementation_1 = implementation;
var fields = [
    'type',
    'additional',
    'level',
    'referrer',
];
var logError$1 = function (error, params) {
    if (params === void 0) { params = {}; }
    var err = implementation_1.baseNormalizeError(error);
    err.message = [params.message, err.message].filter(Boolean).join('; ') || 'Empty error';
    for (var i = 0; i < fields.length; i++) {
        var name_1 = fields[i];
        if (params[name_1]) {
            err[name_1] = params[name_1];
        }
        else if (error && error[name_1]) {
            err[name_1] = error[name_1];
        }
    }
    implementation_1.handleError(err);
};
logError$2.logError = logError$1;

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(settings, exports);
__exportStar(implementation, exports);
__exportStar(logError$2, exports);
}(lib));

var __extends$1 = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate$1 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var RequestCanceledError = /** @class */ (function (_super) {
    __extends$1(RequestCanceledError, _super);
    function RequestCanceledError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, RequestCanceledError_1.prototype);
        return _this;
    }
    RequestCanceledError_1 = RequestCanceledError;
    var RequestCanceledError_1;
    RequestCanceledError = RequestCanceledError_1 = __decorate$1([
        lib$1.serializeId('RequestCanceledError')
    ], RequestCanceledError);
    return RequestCanceledError;
}(lib$1.SerializableError));

var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var CookieNeededError = /** @class */ (function (_super) {
    __extends(CookieNeededError, _super);
    function CookieNeededError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, CookieNeededError_1.prototype);
        return _this;
    }
    CookieNeededError_1 = CookieNeededError;
    var CookieNeededError_1;
    CookieNeededError = CookieNeededError_1 = __decorate([
        lib$1.serializeId('CookieNeededError')
    ], CookieNeededError);
    return CookieNeededError;
}(lib$1.SerializableError));

/**
 * Никогда не менять имя скопа
 */
 var API_SCOPE = 'widgetTransport';
 var API_VERSION = 2;

lib.updateSettings({
    project: 'messenger-widget-npm',
    version: "1.21.0",
    env: "production" ,
});
var LOGGED_SYMBOL = '__logged__';
function isLogged(obj) {
    return obj && obj[LOGGED_SYMBOL] === true;
}
var logError = function (error, params) {
    if (error instanceof Error) {
        if (isLogged(error)) {
            return;
        }
        Object.defineProperty(error, LOGGED_SYMBOL, {
            value: true,
            enumerable: false,
            configurable: false,
        });
    }
    lib.logError(error, params);
};
var loggable = function (target) {
    var LoggableProxy = /** @class */ (function (_super) {
        __extends$d(LoggableProxy, _super);
        function LoggableProxy() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var _this_1 = this;
            try {
                _this_1 = _super.apply(this, args) || this;
            }
            catch (error) {
                logError(error);
                throw error;
            }
            return _this_1;
        }
        return LoggableProxy;
    }(target));
    var _loop_1 = function (key) {
        if (!target.prototype.hasOwnProperty(key)) {
            return "continue";
        }
        Object.defineProperty(LoggableProxy.prototype, key, {
            get: function () {
                var _this = this;
                var descriptor = Object.getOwnPropertyDescriptor(target.prototype, key);
                // Вытаскиваем свойство именно через дескриптор
                // Так как некоторые декораторы могут биндить функцию на this в get
                // из-за чего при попытке достать функцию из прототипа происходит бинд на прототип
                // а не текущий this
                var property = (descriptor.get ? descriptor.get.call(_this) : descriptor.value);
                if (typeof property !== 'function') {
                    return property;
                }
                function callable() {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    try {
                        var result = property.apply(_this, args);
                        if (isDefined(result) && typeof result.catch === 'function') {
                            result.catch(logError);
                        }
                        return result;
                    }
                    catch (error) {
                        logError(error);
                        throw error;
                    }
                }
                Object.defineProperty(this, key, {
                    value: callable,
                });
                return callable;
            },
            configurable: true,
        });
    };
    for (var _i = 0, _a = Object.keys(target.prototype); _i < _a.length; _i++) {
        var key = _a[_i];
        _loop_1(key);
    }
    return LoggableProxy;
};

function rnd() {
    return Math.random().toString(36).substring(7);
}

var hasDocument = typeof document !== 'undefined';
var hasWindow = typeof window !== 'undefined';
var hasNavigator = typeof navigator != 'undefined';
var hasScreen = typeof screen != 'undefined';
function getCharset() {
    return hasDocument && typeof document.charset === 'string' ?
        document.charset.toLowerCase() :
        '';
}
function getHost() {
    return hasWindow && window.location ? window.location.hostname : '';
}
function getPageUrl() {
    return hasWindow && window.location ? window.location.href : '';
}
function getReferrer() {
    return hasDocument ? document.referrer : '';
}
function getTitle() {
    return hasDocument ? document.title : '';
}
function cookieEnabled() {
    return hasNavigator ? navigator.cookieEnabled : false;
}
function getScreenSize() {
    return hasScreen ? [
        screen.width,
        screen.height,
        screen.colorDepth
    ].join('x') : '';
}

function truncate(str, len) {
    return (str || '').slice(0, len);
}

function getRandom() {
    return Math.floor(Math.random() * 1E6);
}

var MAX_TITLE_LEN = 512;
function addParam(result, name, value) {
    if (value || value === 0) {
        result.push(name + ':' + (value === true ? '1' : value));
    }
}
function getBrowserInfo(params, title) {
    var result = [];
    if (params) {
        Object.keys(params).forEach(function (key) { return addParam(result, key, params[key]); });
    }
    addParam(result, 'rn', getRandom());
    addParam(result, 'c', cookieEnabled());
    addParam(result, 's', getScreenSize());
    addParam(result, 'en', getCharset());
    addParam(result, 't', truncate(title, MAX_TITLE_LEN));
    return result.join(':');
}

function queryStringify(params) {
    return Object.keys(params)
        .filter(function (key) {
        var val = params[key];
        return val !== '' && val !== undefined && val !== null;
    })
        .map(function (key) { return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]); })
        .join('&');
}
var MAX_URL_LEN = 1024;
function prepareUrl(url) {
    return truncate(url, MAX_URL_LEN);
}

function sendData(counterId, queryParams) {
    var url = 'https://mc.yandex.ru/watch/' + counterId + '?' + queryStringify(queryParams);
    if (typeof navigator !== 'undefined' && navigator.sendBeacon) {
        navigator.sendBeacon(url, ' ');
    }
    else if (typeof fetch !== 'undefined') {
        fetch(url, { credentials: 'include' });
    }
    else if (typeof Image !== 'undefined') {
        new Image().src = url;
    }
}

function hitExt(params) {
    var browserInfo = params.browserInfo, counterId = params.counterId, pageParams = params.pageParams, userVars = params.userVars;
    var data = {
        'browser-info': getBrowserInfo(browserInfo, pageParams.title),
        rn: getRandom(),
        ut: pageParams.ut
    };
    if (pageParams.url) {
        data['page-url'] = prepareUrl(pageParams.url);
    }
    if (pageParams.referrer) {
        data['page-ref'] = prepareUrl(pageParams.referrer);
    }
    if (userVars) {
        data['site-info'] = JSON.stringify(userVars);
    }
    sendData(counterId, data);
}
/**
 * Отправка хита.
 *
 * @param counterId - Номер счётчика.
 * @param hitParams -  Параметры страницы.
 * @param userVars - Параметры визитов.
 *
 * @example
 * hit('123456');
 *
 * hit('123456', {
 *     referer: document.referer,
 *     title: document.title,
 *     url: window.location.href
 * }, {
 *     myParam: 'value'
 * });
 */
function hit(counterId, hitParams, userVars) {
    var referrer = hitParams && hitParams.referrer !== undefined ?
        hitParams.referrer :
        getReferrer();
    var title = hitParams && hitParams.title !== undefined ?
        hitParams.title :
        getTitle();
    var url = hitParams && hitParams.url !== undefined ?
        hitParams.url :
        getPageUrl();
    hitExt({
        counterId: counterId,
        pageParams: {
            referrer: referrer,
            title: title,
            url: url
        },
        userVars: userVars
    });
}
/**
 * Достижение цели.
 *
 * @param counterId - Номер счётчика.
 * @param name - Название цели.
 * @param userVars - Параметры визитов.
 *
 * @example
 * reachGoal('123456', 'goalName');
*/
function reachGoal(counterId, name, userVars) {
    var referrer;
    var url;
    if (name) {
        referrer = getPageUrl();
        url = "goal://" + getHost() + "/" + name;
    }
    else {
        referrer = getReferrer();
        url = getPageUrl();
    }
    hitExt({
        counterId: counterId,
        pageParams: { referrer: referrer, url: url },
        userVars: userVars
    });
}

/*
 * Подключает счётчик Яндекс.Метрики
 *
 * Используем только JS-версию
 * Счётчик 52122583 создан в аккаунте yndx.chat, доступ есть у @ivansmirn
 * https://metrika.yandex.ru/dashboard?id=52122583
 */
var COUNTER_ID = '52122583';
function metrikaHit(hitParams, userVars) {
    hit(COUNTER_ID, hitParams, userVars);
}
function metrikaReachGoal(name, params) {
    reachGoal(COUNTER_ID, name, params);
}

/**
 * Очередь отслеживающая состояние сети
 *
 * Если клиент онлайн, то выполняет таск из очереди
 */
var OnlineEnsurer = /** @class */ (function () {
    function OnlineEnsurer() {
        this.queue = new Queue(true);
    }
    OnlineEnsurer.prototype.init = function () {
        if (window.navigator.onLine) {
            this.queue.unlock();
        }
        window.addEventListener('online', this.handleOnline);
        window.addEventListener('offline', this.handleOffline);
    };
    OnlineEnsurer.prototype.handleOnline = function () {
        this.queue.unlock();
    };
    OnlineEnsurer.prototype.handleOffline = function () {
        this.queue.lock();
    };
    OnlineEnsurer.prototype.run = function (task, removeOld) {
        this.queue.push(task, removeOld);
    };
    OnlineEnsurer.prototype.destroy = function () {
        window.removeEventListener('online', this.handleOnline);
        window.removeEventListener('offline', this.handleOffline);
        this.queue.cancel();
    };
    __decorate$9([
        lib$2.bind
    ], OnlineEnsurer.prototype, "handleOnline", null);
    __decorate$9([
        lib$2.bind
    ], OnlineEnsurer.prototype, "handleOffline", null);
    return OnlineEnsurer;
}());

var WidgetEvent = /** @class */ (function () {
    function WidgetEvent(data, options) {
        this.data = data;
        this.defaultPrevented = false;
        this.preventable = false;
        this.preventable = Boolean(options === null || options === void 0 ? void 0 : options.preventable);
    }
    WidgetEvent.prototype.preventDefault = function (resolveWith) {
        if (!this.preventable) {
            return;
        }
        this.resolvedWith = resolveWith;
        this.defaultPrevented = true;
    };
    return WidgetEvent;
}());

function channelFactory(channelId, transportFactory, initParams) {
    var _a;
    return new ChannelOutgoing(channelId, transportFactory, {
        scope: (_a = {},
            _a[API_SCOPE] = initParams,
            _a),
        connectTimeout: CONNECTION_TIMEOUT,
    });
}
var WidgetTransport = /** @class */ (function () {
    function WidgetTransport(widgetId, channelTransportFactory, initParams, events, handlers) {
        this.widgetId = widgetId;
        this.channelTransportFactory = channelTransportFactory;
        this.initParams = initParams;
        this.events = events;
        this.handlers = handlers;
        /**
         * Вызывается при внутренней перезагрузке дочернего окна,
         * например при авторизации
         */
        this.onReloaded = new Event();
        /**
         * Вызывается при закрытии транспорта
         */
        this.onClose = new Event();
    }
    Object.defineProperty(WidgetTransport.prototype, "channel", {
        get: function () {
            if (!this.channelInstance) {
                this.channelInstance = channelFactory(this.widgetId, this.channelTransportFactory, this.initParams);
                this.channelInstance.onClose.addListener(this.handleClose);
                this.channelInstance.onConnectionEstablished.addListener(this.handleConnectionEstablished);
                this.channelInstance.onEvent.addListener(this.handleEvent);
                this.channelInstance.onRequest.addListener(this.handleRequest);
            }
            return this.channelInstance;
        },
        enumerable: false,
        configurable: true
    });
    WidgetTransport.prototype.destroy = function () {
        var _a, _b, _c, _d;
        (_a = this.channelInstance) === null || _a === void 0 ? void 0 : _a.onClose.removeListener(this.handleClose);
        (_b = this.channelInstance) === null || _b === void 0 ? void 0 : _b.onEvent.removeListener(this.handleEvent);
        (_c = this.channelInstance) === null || _c === void 0 ? void 0 : _c.onRequest.removeListener(this.handleRequest);
        (_d = this.channelInstance) === null || _d === void 0 ? void 0 : _d.dispose();
        this.channelInstance = undefined;
    };
    WidgetTransport.prototype.isConnectionClosed = function () {
        return !this.channelInstance || this.channelInstance.connectionStatus === 'closed';
    };
    WidgetTransport.prototype.handleConnectionEstablished = function (_a) {
        var reconnect = _a.reconnect;
        if (reconnect) {
            this.onReloaded.dispatch();
        }
    };
    WidgetTransport.prototype.handleClose = function (channel) {
        var _a;
        var isCriticalError = (channel.closeCode === CLOSE_CODE.ERROR);
        if (isCriticalError) {
            (_a = this.channelInstance) === null || _a === void 0 ? void 0 : _a.disposeTransport();
        }
        this.onClose.dispatch({
            isCriticalError: isCriticalError,
            error: channel.closeError,
        });
    };
    WidgetTransport.prototype.handleEvent = function (event) {
        var _a;
        (_a = this.events[event.type]) === null || _a === void 0 ? void 0 : _a.dispatch(new WidgetEvent(event.data));
    };
    WidgetTransport.prototype.handleRequest = function (event) {
        var handler = this.handlers[event.type];
        if (handler && handler.hasListeners()) {
            handler.dispatch(event);
        }
        else {
            event.reject(new UnhandledResponseError('not_supported'));
        }
    };
    __decorate$9([
        lib$2.bind
    ], WidgetTransport.prototype, "handleConnectionEstablished", null);
    __decorate$9([
        lib$2.bind
    ], WidgetTransport.prototype, "handleClose", null);
    __decorate$9([
        lib$2.bind
    ], WidgetTransport.prototype, "handleEvent", null);
    __decorate$9([
        lib$2.bind
    ], WidgetTransport.prototype, "handleRequest", null);
    return WidgetTransport;
}());

function createIframe(params) {
    var iframe = document.createElement('iframe');
    iframe.setAttribute('scrolling', 'no');
    iframe.src = params.url;
    if (params.className) {
        iframe.className = params.className;
    }
    if (params.allow) {
        iframe.setAttribute('allow', params.allow.join('; '));
    }
    return iframe;
}
function generateClickId() {
    return rnd();
}

var EVENTS_NAMES = ['ready', 'close', 'chatChange', 'chatLeave', 'error', 'locationChange', 'members', 'unload', 'messageSent', 'catchUrlClick', 'userNeedReAssign', 'userLoaded', 'chatHistoryLoaded', 'chatListLoaded', 'chatLoadError', 'fullscreenOn', 'fullscreenOff', 'counter', 'unreadCountersByChats', 'channelSubscribed', 'channelUnsubscribed', 'authRequest', 'sendMessage'];
var eventsFactory = function () {
    return Object.defineProperties({}, EVENTS_NAMES.reduce(function (aux, name) {
        aux[name] = {
            get: function () {
                var event = new Event();
                Object.defineProperty(this, name, {
                    value: event,
                });
                return event;
            },
            configurable: true,
        };
        return aux;
    }, {}));
};

function beforeRequest(name) {
    return function (target, method, descriptor) {
        var value = descriptor.value;
        return {
            value: function (params) {
                var event = new WidgetEvent({
                    type: name,
                    params: params,
                }, { preventable: true });
                this.dispatchLC('LCBeforeRequest', event);
                if (event.defaultPrevented) {
                    return Promise.resolve()
                        .then(function () {
                        return event.resolvedWith;
                    });
                }
                return value.call(this, params);
            },
        };
    };
}

/**
 * @autogenerated by scripts/codegen/codegen-widget-api.js
 * Добавить опции в запросы можно через конфиг в файле генераторе @see CODE_GEN_CONFIG
 * Для того что бы ручка прорасла в публичный api ее нужно добавить в @see CODE_GEN_CONFIG.publicAPI
 */
/**
 * @nodoc
 */
var WidgetAPI = /** @class */ (function () {
    function WidgetAPI(getTransport, dispatchLC) {
        this.getTransport = getTransport;
        this.dispatchLC = dispatchLC;
    }
    /**
 * Открыть мессенджер с указанным чатом или на нулевом экране
 * @param params Параметры открыти мессенджера
 */
    WidgetAPI.prototype.iframeOpen = function (params) {
        return this.getTransport().channel.request('iframeOpen', params, {
            cancelPreviousRequestsWithSameType: true
        });
    };
    /**
     * Отправить данные сервиса в BotRequest
     * @param params Сервисные данные
     */
    WidgetAPI.prototype.serviceMeta = function (params) {
        return this.getTransport().channel.request('serviceMeta', params);
    };
    /**
     * Вставиь текст в поле ввода
     * @param params Текст и идентификатор чата
     */
    WidgetAPI.prototype.pasteMessage = function (params) {
        return this.getTransport().channel.request('pasteMessage', params);
    };
    /**
     * Установить видимость мессенджера
     * Если передан параметр visible: false мессенджер выключит автоматический подскролл
     * к новому сообщению и отправку прочитанности.
     * Применимо в случае, когда у хоста есть своя логика отображения/скрытия мессенджера
     * @param params Параметры видимости мессенджера
     */
    WidgetAPI.prototype.setVisibility = function (params) {
        return this.getTransport().channel.request('setVisibility', params, {
            cancelPreviousRequestsWithSameType: true
        });
    };
    /**
     * Изменить параметры темы мессенджера
     * Документация https://a.yandex-team.ru/arc/trunk/arcadia/frontend/services/messenger.widget_deprecated/docs/themes.md
     * @param params Параметры темы мессенджера
     */
    WidgetAPI.prototype.setThemeVariables = function (params) {
        return this.getTransport().channel.request('setThemeVariables', params, {
            cancelPreviousRequestsWithSameType: true
        });
    };
    /**
     * Установить метаданные чата
     * @param params Метаданные чата
     */
    WidgetAPI.prototype.chatMetadata = function (params) {
        return this.getTransport().channel.request('chatMetadata', params);
    };
    /**
     * Вызвать экшен
     * @param params Массив экшенов
     */
    WidgetAPI.prototype.actions = function (params) {
        return this.getTransport().channel.request('actions', params);
    };
    /**
     * Отправить сообщение с указанным номером телефона боту
     * @param params Параметры вызова
     */
    WidgetAPI.prototype.requestCallback = function (params) {
        return this.getTransport().channel.request('requestCallback', params);
    };
    /**
     * Отправить текстовое сообщение
     * @param params
     */
    WidgetAPI.prototype.sendTextMessage = function (params) {
        return this.getTransport().channel.request('sendTextMessage', params);
    };
    /**
     * Отправить сообщение - картинку
     * @param params
     */
    WidgetAPI.prototype.sendImage = function (params) {
        return this.getTransport().channel.request('sendImage', params);
    };
    /**
     * Отправить BotRequest
     * @param params
     */
    WidgetAPI.prototype.sendBotRequest = function (params) {
        return this.getTransport().channel.request('sendBotRequest', params);
    };
    /**
     * Проверить создан ли чат
     * @param params
     */
    WidgetAPI.prototype.isChatCreated = function (params) {
        return this.getTransport().channel.request('isChatCreated', params);
    };
    __decorate$9([
        beforeRequest('iframeOpen')
    ], WidgetAPI.prototype, "iframeOpen", null);
    __decorate$9([
        beforeRequest('serviceMeta')
    ], WidgetAPI.prototype, "serviceMeta", null);
    __decorate$9([
        beforeRequest('pasteMessage')
    ], WidgetAPI.prototype, "pasteMessage", null);
    __decorate$9([
        beforeRequest('setVisibility')
    ], WidgetAPI.prototype, "setVisibility", null);
    __decorate$9([
        beforeRequest('setThemeVariables')
    ], WidgetAPI.prototype, "setThemeVariables", null);
    __decorate$9([
        beforeRequest('chatMetadata')
    ], WidgetAPI.prototype, "chatMetadata", null);
    __decorate$9([
        beforeRequest('actions')
    ], WidgetAPI.prototype, "actions", null);
    __decorate$9([
        beforeRequest('requestCallback')
    ], WidgetAPI.prototype, "requestCallback", null);
    __decorate$9([
        beforeRequest('sendTextMessage')
    ], WidgetAPI.prototype, "sendTextMessage", null);
    __decorate$9([
        beforeRequest('sendImage')
    ], WidgetAPI.prototype, "sendImage", null);
    __decorate$9([
        beforeRequest('sendBotRequest')
    ], WidgetAPI.prototype, "sendBotRequest", null);
    __decorate$9([
        beforeRequest('isChatCreated')
    ], WidgetAPI.prototype, "isChatCreated", null);
    return WidgetAPI;
}());

/**
 * @autogenerated by scripts/codegen/codegen-widget-api.js
 * Добавить опции в запросы можно через конфиг в файле генераторе @see CODE_GEN_CONFIG
 */
/**
 * @doctitle API Мессенджера
 * @doc Виджет предоставляет (`Widget::api`) промисифицированный API для взаимодействия с мессенджером.
 *
 * Доступ к ручкам отправки сообщений от имени пользователя ограничен, разрешение необходимо
 * согласовать с командой мессенджера
 *
 * @docsubtitle Пример вызова ручки
 * @example
 * widgetInstance.api.setVisiblity({ visible: true })
 *     .then(() => console.log('ok'))
 *
 * @docsubtitle Доступные ручки
 *
 * @doctemplate members_annotation
 */
var PublicWidgetAPI = /** @class */ (function () {
    function PublicWidgetAPI(api) {
        this.api = api;
    }
    /**
 * Отправить данные сервиса в BotRequest
 * @param params Сервисные данные
 */
    PublicWidgetAPI.prototype.serviceMeta = function (params) {
        return this.api.serviceMeta(params);
    };
    /**
 * Вставиь текст в поле ввода
 * @param params Текст и идентификатор чата
 */
    PublicWidgetAPI.prototype.pasteMessage = function (params) {
        return this.api.pasteMessage(params);
    };
    /**
 * Установить видимость мессенджера
 * Если передан параметр visible: false мессенджер выключит автоматический подскролл
 * к новому сообщению и отправку прочитанности.
 * Применимо в случае, когда у хоста есть своя логика отображения/скрытия мессенджера
 * @param params Параметры видимости мессенджера
 */
    PublicWidgetAPI.prototype.setVisibility = function (params) {
        return this.api.setVisibility(params);
    };
    /**
 * Изменить параметры темы мессенджера
 * Документация https://a.yandex-team.ru/arc/trunk/arcadia/frontend/services/messenger.widget_deprecated/docs/themes.md
 * @param params Параметры темы мессенджера
 */
    PublicWidgetAPI.prototype.setThemeVariables = function (params) {
        return this.api.setThemeVariables(params);
    };
    /**
 * Установить метаданные чата
 * @param params Метаданные чата
 */
    PublicWidgetAPI.prototype.chatMetadata = function (params) {
        return this.api.chatMetadata(params);
    };
    return PublicWidgetAPI;
}());

/**
 * @doctitle Обработчики запросов из Мессенджера
 *
 * @doc
 * Все возможные запросы из мессенджера собраны в `Widget::handlers`. Со стороны виджета
 * каждый запрос это событие, на которое можно подписаться с помощью `Event::addListener`.
 *
 * Само событие это объект со следующими полями:
 *
 * `response` - ответить на запрос, в качестве ответа можно передать промис.
 *
 * `reject` - отклонить запрос
 *
 * `payload` - параметры запроса
 *
 * @docsubtitle Пример обработки запроса
 * @example
 * widgetInstance.handlers.getLog.addListener(async (request) => {
 *     try {
 *         const logs = await fetchLogs();
 *
 *         request.response(logs.map(log => new Blob([log])));
 *     } catch (error) {
 *         request.reject(error);
 *     }
 * });
 *
 * @docsubtitle Доступные обработчики
 *
 * @doctemplate members_annotation
 */
var WidgetHandlers = /** @class */ (function () {
    function WidgetHandlers() {
        /**
         * Получить логи с хоста
         * @returns массив Blob или GetLogResponse
         */
        this.getLog = new Event();
        /**
         * Получить данные о хосте
         * @returns произвольный объект
         */
        this.getEnv = new Event();
        /**
         * Позволяет хосту выполнять свои действия вместо открытия стандартных интефейсов
         * Для включения необхоимо передать в мессенджер флаг uiInterceptor
         *
         * chat_info - перехват открытия панели информации о чате
         * user_info - перехват открытия панели информации о пользователе
         * @returns undefined
         */
        this.uiInterceptor = new Event();
    }
    return WidgetHandlers;
}());

ChannelBase.CancelError = RequestCanceledError;
var API = Symbol('API');
function assertServiceId(options) {
    if (!isNumber(options.serviceId)) {
        throw new Error('serviceId is required');
    }
}
/**
 * @doctitle Базовый класс для работы с виджетом
 * @doc
 * Для инициализации виджета необхоимо:
 * 1. Выбрать один из вариантов интерфейса виджета [UI](/doc/ui.md), либо реализовать свой.
 * 2. Выбрать нужные плагины, для расширения функциональности [Plugins](/doc/plugins.md)
 * 3. Создать и сконфигурировать экземпляр класса `Widget`
 * 4. Проинициализировать виджет `Widget::init` и задать точку монтирования для интерфейса, вызвав `mount`
 *
 * @docsubtitle Конфигурация виджета
 * @doc
 * Для конфигурации необходимо использовать [Config](/doc/config.md), пакет содержит несколько пресетов
 * с часто используемыми базовыми конфигурациями виджета.
 *
 * @docsubtitle serviceId
 * @doc
 * **serviceId** - идентификатор сервиса является обязательным. [Как завести serviceId](/doc/cookbook.md#serviceid)
 *
 * @docsubtitle Запуск и работа с виджетом
 * @doc
 * Для запуска виджета необходимо вызвать метод `Widget::init`,
 * перед этим необходимо инициализировать ui (`Widget::setUI`) и плагины (`Widget::setPlugin`),
 * смонитровать ui, вызвав `mount`.
 * Подписки на события/запросы также лучше делать до вызова.
 *
 * Для програмного открытия/скрытия виджета нужно использовать
 * методы `Widget::show`/`Widget::hide`.
 *
 * Виджет должен быть полностью инициализирован до начала работы с его программными api
 *
 * @docsubtitle Подробнее
 * [API Мессенджера](/doc/api.md)
 *
 * [События Мессенджера](/doc/events.md)
 *
 * [Обработка запросов Мессенджера](/doc/handlers.md)
 *
 * [Настройка отображения Мессенджера (флаги)](/doc/flags.md)
 *
 * [Интеграция в React приложения](/doc/react.md)
 *
 * @docsubtitle Storybook
 * `https://messenger-test.s3.mds.yandex.net/storybook/widget/latest/index.html`
 *
 * @docsubtitle Пример интеграции виджета с кнопкой
 * @example
 * import {
 *     Widget,
 *     YandexConfig,
 *     buttonUIFactory,
 *     yandexUnreadCounterFactory,
 * } from 'yandex-int/messenger.widget';
 * import 'yandex-int/messenger.widget/lib/ui/button.css';
 *
 * const unreadCounterPlugin = yandexUnreadCounterFactory(),
 * const ui = buttonUIFactory({
 *     unreadCounterPlugin,
 * });
 *
 * const widget = new Widget(new YandexConfig({
 *      // [подробнее](/doc/config.md)
 * }));
 *
 * widget.events.ready.addListener(() => console.log('Widget ready'));
 *
 * widget
 *     .addPlugin(unreadCounterPlugin)
 *     .setUI(ui)
 *     .init()
 *
 * ui.mount(document.body);
 */
var Widget = /** @class */ (function () {
    /**
     * @docsubtitle Конструктор
     * @doctemplate method_annotation
     */
    function Widget(
    /**
     * @doc
     * Настройки виджета. Пакет содержит несколько преднастроенных конфигов
     * Подробнее можно прочитать в разделе [конфига](/doc/config.md)
     *
     * Параметр flags позволяет настроить интерфейс мессенджера (например отключить шапку чата)
     * [Доступные флаги](/doc/flags.md)
     */
    config) {
        var _this = this;
        this.config = config;
        /**
         * Версия виджета
         */
        this.version = "1.21.0" ;
        /**
         * Идентификатор виджета
         */
        this.widgetId = "msngr_widget_" + rnd();
        this.plugins = [];
        this.forceSendOpenIframe = true;
        this.onlineEnsurer = new OnlineEnsurer();
        this[_a] = new WidgetAPI(function () { return _this.transport; }, function (name, event) { return _this.dispatchLC(name, event); });
        /**
         * API Мессенджера
         */
        this.api = new PublicWidgetAPI(this[API]);
        /**
         * Обработчики событий
         */
        this.handlers = new WidgetHandlers();
        /**
         * События Мессенджера
         */
        this.events = eventsFactory();
        lib.updateSettings({
            service: "" + this.options.serviceId,
            additional: __assign$2(__assign$2({}, lib.getSettings().additional), { workspaceId: "" + this.options.workspaceId, orgId: "" + this.options.orgId }),
        });
        metrikaHit(undefined, {
            serviceId: "" + this.options.serviceId,
            workspaceId: "" + this.options.workspaceId,
            orgId: "" + this.options.orgId,
            version: this.version,
            stat: typeof this.options.stat === 'object' ? this.options.stat : undefined,
            visitId: this.widgetId,
        });
        this.lastShowData = this.options.iframeOpenData;
        this.events.ready.addListener(function () {
            _this.dispatchLC('LCReady', new WidgetEvent());
        });
        this.events.close.addListener(function () {
            _this.dispatchLC('LCHidden', new WidgetEvent());
        });
    }
    /**
     * @docsubtitle Инициализировать виджет
     * @doctemplate method_annotation
     */
    Widget.prototype.init = function () {
        var _this = this;
        var options = this.options;
        assertServiceId(options);
        this.plugins.forEach(function (plugin) {
            plugin.init(options, _this);
        });
        this.onlineEnsurer.init();
        return this;
    };
    /**
     * @docsubtitle Открыть мессенджер
     * @doc
     * Метод позволяет открыть определенный чат или список чатов в мессенджере
     * Если `params` не передан, при первом открытии
     * будут использованы данные из `iframeOpenData`,
     * при последующих открытиях будет вызван только `LCShown`
     *
     * При вызове ручки возможно создание нового чата.
     * Если необходимо предзагрузить виджет используйте `preload`
     *
     * @doctemplate method_annotation
     */
    Widget.prototype.show = function (
    /**
     * @doc Параметры открытия мессенджера
     * @docref template=members_annotation
     */
    params, 
    /**
     * @doc Колбэк открытия чата/нулвого экрана
     */
    callback) {
        if (callback === void 0) { callback = noop; }
        var lcBeforeShowEvent = new WidgetEvent(params, { preventable: true });
        this.dispatchLC('LCBeforeShow', lcBeforeShowEvent);
        if (lcBeforeShowEvent.defaultPrevented) {
            callback();
            return;
        }
        var clickId = generateClickId();
        if (params || this.forceSendOpenIframe) {
            this.forceSendOpenIframe = false;
            var data = params || this.lastShowData;
            this.lastShowData = data;
            this[API].iframeOpen(__assign$2(__assign$2({}, data), { visitId: this.widgetId, eventTimestamp: Date.now(), clickId: clickId, visible: true }))
                .then(callback, callback);
        }
        else {
            this.api.setVisibility({ visible: true })
                .catch(noop);
            callback();
        }
        metrikaReachGoal('widget-opened', { clickId: clickId });
        this.dispatchLC('LCShown', new WidgetEvent());
    };
    /**
     * @docsubtitle Свернуть мессенджер
     *
     * @doctemplate method_annotation
     */
    Widget.prototype.hide = function () {
        var lcBeforeHideEvent = new WidgetEvent(undefined, { preventable: true });
        this.dispatchLC('LCBeforeHide', lcBeforeHideEvent);
        if (lcBeforeHideEvent.defaultPrevented) {
            return;
        }
        if (!this.transport.isConnectionClosed()) {
            this.api.setVisibility({ visible: false })
                .catch(noop);
        }
        var clickId = generateClickId();
        metrikaReachGoal('widget-closed', { clickId: clickId });
        this.dispatchLC('LCHidden', new WidgetEvent());
    };
    /**
     * @docsubtitle Фоновое открытие мессенджера
     *
     * @doc
     *
     * Фоновое открытие чаще всего приводит к лишней нагрзке.
     * Использование этой функциональности лучше согласовать с разработчиками.
     *
     * @doctemplate method_annotation
     */
    Widget.prototype.preload = function () {
        this.transport.channel.connect();
    };
    /**
     * @docsubtitle Установить UI плагин
     * @doctemplate method_annotation
     */
    Widget.prototype.setUI = function (plugin) {
        this.uiPlugin = plugin;
        return this.addPlugin(plugin);
    };
    /**
     * @docsubtitle Установить плагин.
     * @doc
     * Порядок плагинов имеет значение!
     *
     * @doctemplate method_annotation
     */
    Widget.prototype.addPlugin = function (plugin) {
        this.plugins.push(plugin);
        return this;
    };
    /**
     * @docsubtitle Удалить виджет.
     * @doctemplate method_annotation
     */
    Widget.prototype.destroy = function () {
        var _b, _c;
        (_b = this.transportInstance) === null || _b === void 0 ? void 0 : _b.onClose.removeListener(this.handleErrorConnect);
        (_c = this.transportInstance) === null || _c === void 0 ? void 0 : _c.destroy();
        this.transportInstance = undefined;
        this.onlineEnsurer.destroy();
        this.dispatchLC('LCClose', new WidgetEvent());
    };
    Object.defineProperty(Widget.prototype, "options", {
        get: function () {
            return this.config.values;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @private
     */
    Widget.prototype.dispatchLC = function (name, event) {
        for (var _i = 0, _b = this.plugins; _i < _b.length; _i++) {
            var plugin = _b[_i];
            if (typeof plugin[name] === 'function') {
                plugin[name](event);
            }
        }
        return event;
    };
    Widget.prototype.getIframeUrl = function (additional) {
        return this.config.getMessengerUrl(this.widgetId, API_VERSION, __assign$2({ utm_source: 'widget', utm_medium: 'iframe' }, additional));
    };
    Widget.prototype.handleErrorConnect = function (event) {
        this.forceSendOpenIframe = true;
        if (event.isCriticalError) {
            this.dispatchLC('LCErrorCritical', new WidgetEvent({
                error: event.error || new Error('Connection Terminated'),
            }));
        }
    };
    Object.defineProperty(Widget.prototype, "transport", {
        get: function () {
            var _this = this;
            if (!this.transportInstance) {
                this.transportInstance = new WidgetTransport(this.widgetId, function (callback) {
                    _this.onlineEnsurer.run(new QueueTask(function () {
                        if (!_this.uiPlugin) {
                            throw new Error('UI plugin was not initialized');
                        }
                        _this.uiPlugin.getChildWindowTransport({
                            urlProvider: function () { return _this.getIframeUrl(); },
                            allow: _this.options.allow,
                        }, callback);
                    }, { tag: 'childWindowProvider' }), { tag: 'childWindowProvider' });
                }, {
                    authToken: this.options.authToken,
                    themeVariables: this.options.themeVariables,
                }, this.events, this.handlers);
                this.transportInstance.onClose.addListener(this.handleErrorConnect);
            }
            return this.transportInstance;
        },
        enumerable: false,
        configurable: true
    });
    var _a;
    _a = API;
    __decorate$9([
        lib$2.bind
    ], Widget.prototype, "handleErrorConnect", null);
    Widget = __decorate$9([
        loggable
    ], Widget);
    return Widget;
}());

function getMods(mods) {
    return Object.keys(mods)
        .filter(function (key) {
        var value = mods[key];
        return value || value === 0;
    })
        .map(function (key) {
        var name = key.trim();
        var value = mods[key];
        return value === true ?
            "_" + name : // Булевый модификатор
            "_" + name + "_" + value;
    });
}
function block(blockName) {
    return function (elemName, elemMods) {
        var prefix = block.prefix + blockName;
        if (typeof elemName === 'string') {
            prefix += '__' + elemName;
        }
        var classBuffer = [prefix];
        var mods = {};
        if (typeof elemName === 'object') { // Блок с модификаторами
            mods = elemName;
        }
        else if (typeof elemMods === 'object') { // Элемент блока с модификаторами
            mods = elemMods;
        }
        getMods(mods).forEach(function (item) {
            classBuffer.push(prefix + item);
        });
        return classBuffer.join(' ');
    };
}
block.prefix = 'ya-chat-';
function classname(blockName, elemName, elemMods) {
    return block(blockName)(elemName, elemMods).split(' ').pop() || '';
}

var close$9 = "Закрыть";
var ru = {
	close: close$9,
	"error-title": "Не удалось загрузить чат",
	"error-try-again": "Попробовать ещё раз",
	"button-text-default": "Напишите нам!",
	"cookie-blocked-text": "К сожалению доступов к cookie нет.",
	"new-window-button": "Подтвердите переход на новую страницу",
	"support-unread-text": "Все обращения",
	"support-unread-text-count": [
	"Еще {value} обращение",
	"Еще {value} обращения",
	"Еще {value} обращений"
]
};

var close$8 = "Close";
var en = {
	close: close$8,
	"error-title": "Failed to load chat",
	"error-try-again": "Try again",
	"button-text-default": "Write to us!",
	"cookie-blocked-text": "Unfortunately, there is no access to cookies.",
	"new-window-button": "Confirm the transition to a new page",
	"support-unread-text": "All requests",
	"support-unread-text-count": [
	"{value} more request",
	"{value} more requests",
	"{value} more requests"
]
};

var close$7 = "Fermer";
var fr = {
	close: close$7,
	"error-title": "Impossible de charger le chat",
	"error-try-again": "Réessayer",
	"button-text-default": "Write to us!",
	"cookie-blocked-text": "Unfortunately, there is no access to cookies.",
	"new-window-button": "Confirm the transition to a new page",
	"support-unread-text": "All requests",
	"support-unread-count": [
	"{value} more request",
	"{value} more requests",
	"{value} more requests"
]
};

var close$6 = "Փակել";
var hy = {
	close: close$6,
	"error-title": "Չհաջողվեց բեռնել չաթը",
	"error-try-again": "Կրկին փորձել",
	"button-text-default": "Write to us!",
	"cookie-blocked-text": "Unfortunately, there is no access to cookies.",
	"new-window-button": "Confirm the transition to a new page",
	"support-unread-text": "All requests",
	"support-unread-text-count": [
	"{value} more request",
	"{value} more requests",
	"{value} more requests"
]
};

var close$5 = "Жабу";
var kk = {
	close: close$5,
	"error-title": "Чатты жүктеу мүмкін емес",
	"error-try-again": "Тағы бір рет көріңіз",
	"button-text-default": "Напишите нам!",
	"cookie-blocked-text": "К сожалению доступов к cookie нет.",
	"new-window-button": "Подтвердите переход на новую страницу",
	"support-unread-text": "Все обращения",
	"support-unread-text-count": [
	"Еще {value} обращение",
	"Еще {value} обращения",
	"Еще {value} обращений"
]
};

var close$4 = "Zatvori";
var sr = {
	close: close$4,
	"error-title": "Učitavanje ćaskanja nije uspelo",
	"error-try-again": "Pokušajte još jednom",
	"button-text-default": "Write to us!",
	"cookie-blocked-text": "Unfortunately, there is no access to cookies.",
	"new-window-button": "Confirm the transition to a new page",
	"support-unread-text": "All requests",
	"support-unread-text-count": [
	"{value} more request",
	"{value} more requests",
	"{value} more requests"
]
};

var close$3 = "Kapat";
var tr = {
	close: close$3,
	"error-title": "Sohbet yüklenemedi",
	"error-try-again": "Tekrar dene",
	"button-text-default": "Write to us!",
	"cookie-blocked-text": "Unfortunately, there is no access to cookies.",
	"new-window-button": "Confirm the transition to a new page",
	"support-unread-text": "All requests",
	"support-unread-text-count": [
	"{value} more request",
	"{value} more requests",
	"{value} more requests"
]
};

var close$2 = "Yopish";
var uz = {
	close: close$2,
	"error-title": "Chatni yuklash imkoni boʻlmadi",
	"error-try-again": "Qayta urinish",
	"button-text-default": "Write to us!",
	"cookie-blocked-text": "Unfortunately, there is no access to cookies.",
	"new-window-button": "Confirm the transition to a new page",
	"support-unread-text": "All requests",
	"support-unread-text-count": [
	"{value} more request",
	"{value} more requests",
	"{value} more requests"
]
};

var close$1 = "סגור";
var he = {
	close: close$1,
	"error-title": "טעינת צ'אט נכשלה",
	"error-try-again": "נסה שנית",
	"button-text-default": "Write to us!",
	"cookie-blocked-text": "Unfortunately, there is no access to cookies.",
	"new-window-button": "Confirm the transition to a new page",
	"support-unread-text": "All requests",
	"support-unread-text-count": [
	"{value} more request",
	"{value} more requests",
	"{value} more requests"
]
};

var texts = { ru: ru, en: en, fr: fr, hy: hy, kk: kk, sr: sr, tr: tr, uz: uz, he: he };
var PLURAL_HANDLERS = {
    ru: function (values, count) {
        var modulo = Math.abs(count) % 100;
        if (modulo >= 5 && modulo <= 20) {
            return values[2];
        }
        modulo %= 10;
        if (modulo === 1) {
            return values[0];
        }
        else if (modulo >= 2 && modulo <= 4) {
            return values[1];
        }
        return values[2];
    },
    en: function (values, count) {
        return count === 1 ? values[0] : values[1];
    },
};
function plural(values, lang, count) {
    var fn = PLURAL_HANDLERS[lang];
    if (fn) {
        var countNumber = count;
        if (typeof count === 'string') {
            countNumber = Number.parseInt(count);
            if (Number.isNaN(countNumber)) {
                return values[0];
            }
        }
        var text = fn(values, countNumber);
        return text.replace('{value}', count);
    }
    return values[0];
}
function i18n(key, lang, count) {
    var hash = texts[lang] || {};
    var value = hash[key] || '';
    if (Array.isArray(value)) {
        return plural(value, lang, count);
    }
    return value;
}

var b$c = block('error');
function errorTemplate(context) {
    var errorRef = context.useRef();
    var retryButtonRef = context.useRef();
    retryButtonRef.on('click', context.props.onRetryErrorClick);
    var lang = context.props.lang;
    /* eslint-disable indent */
    return "\n        <div\n            " + errorRef.id + "\n            class=\"" + errorRef.useClassName(function (_a) {
        var visible = _a.visible;
        return b$c({
            visible: visible,
        });
    }, ['visible']) + "\"\n        >\n            <div class=\"" + b$c('title') + "\">" + i18n('error-title', lang) + "</div>\n            <div " + retryButtonRef.id + " class=\"" + b$c('button') + "\">" + i18n('error-try-again', lang) + "</div>\n        </div>\n    ";
    /* eslint-enable indent */
}

var b$b = block('loader');
function loaderTemplate(context) {
    var loaderRef = context.useRef();
    /* eslint-disable indent */
    return "\n        <div\n            " + loaderRef.id + "\n            class=\"" + loaderRef.useClassName(function (_a) {
        var visible = _a.visible;
        return b$b({
            visible: visible,
        });
    }, ['visible']) + "\">\n            <div class=\"" + b$b('spinner') + "\"></div>\n        </div>\n    ";
    /* eslint-enable indent */
}

function render(template, context, mountNode) {
    var fragment = document.createDocumentFragment();
    var elem = document.createElement('div');
    elem.innerHTML = template(context);
    var firstElementChild = elem.firstElementChild;
    if (!firstElementChild) {
        throw new Error('Bad template');
    }
    var openNoIndexCommentNode = document.createComment('noindex');
    var closeNoIndexCommentNode = document.createComment('noindex');
    fragment.appendChild(openNoIndexCommentNode);
    fragment.appendChild(firstElementChild);
    fragment.appendChild(closeNoIndexCommentNode);
    mountNode.appendChild(fragment);
    context.mount([openNoIndexCommentNode, firstElementChild, closeNoIndexCommentNode]);
}

function partialShallowEqual(a, b) {
    if (a === b) {
        return true;
    }
    if (typeof a === 'object' && typeof b === 'object') {
        for (var key in a) {
            if (a[key] !== b[key]) {
                return false;
            }
        }
        return true;
    }
    return false;
}
function camelCaseToStyle(str) {
    return str.replace(/([a-z])([A-Z])/g, function (_, g1, g2) {
        return g1 + "-" + g2.toLowerCase();
    });
}
var DATA_REGEXP = /^data-/;
var FIRST_LETTER_REGEXP = /-(.)/g;
function getDataset(node) {
    if (node.dataset) {
        return node.dataset;
    }
    var attributes = node.attributes;
    var dataset = {};
    for (var i = 0; i < attributes.length; i++) {
        var attr = attributes[i];
        if (attr && attr.name.match(DATA_REGEXP)) {
            var dataName = attr.name.slice(5).replace(FIRST_LETTER_REGEXP, function (_, char) {
                return char.toUpperCase();
            });
            dataset[dataName] = attr.value;
        }
    }
    return dataset;
}

var Ref = /** @class */ (function () {
    function Ref(context) {
        this.context = context;
        this.refId = "widget_ref" + rnd();
        this.detached = false;
        this.listeners = {};
        this.childrens = new Map();
        this.effects = [];
        this.subscriptions = [];
    }
    Object.defineProperty(Ref.prototype, "id", {
        get: function () {
            return "id=\"" + this.refId + "\"";
        },
        enumerable: false,
        configurable: true
    });
    Ref.prototype.useClassName = function (provider, deps, state) {
        var _this = this;
        this.subscribe(function (props, state) {
            if (_this.node) {
                _this.node.className = provider(props, state);
            }
            else {
                _this.className = provider(props, state);
            }
        }, deps, state);
        return provider(this.context.props, state === null || state === void 0 ? void 0 : state.value);
    };
    Ref.prototype.useStyle = function (provider, deps, state) {
        var _this = this;
        this.subscribe(function (props, stateValue) {
            if (_this.node) {
                var style_1 = provider(props, stateValue);
                Object.keys(style_1).forEach(function (key) {
                    if (!isDefined(style_1[key])) {
                        _this.node.style[key] = '';
                    }
                    else {
                        _this.node.style.setProperty(key, style_1[key], 'important');
                    }
                });
            }
            else {
                _this.style = provider(props, stateValue);
            }
        }, deps, state);
        var style = provider(this.context.props, state === null || state === void 0 ? void 0 : state.value);
        return Object.keys(style).map(function (key) {
            if (!isDefined(style[key])) {
                return;
            }
            return camelCaseToStyle(key) + ": " + style[key];
        }).filter(isDefined).join(';');
    };
    Ref.prototype.useText = function (provider, deps, state) {
        var _this = this;
        this.subscribe(function (props, stateValue) {
            if (_this.node) {
                _this.node.innerText = provider(props, stateValue);
            }
            else {
                _this.innerText = provider(props, stateValue);
            }
        }, deps, state);
        return provider(this.context.props, state === null || state === void 0 ? void 0 : state.value);
    };
    Ref.prototype.useChildren = function (provider, deps, state) {
        var _this = this;
        var id = rnd();
        this.childrens.set(id, {
            provider: provider,
            node: undefined,
        });
        this.subscribe(function (props, stateValue) {
            var old = _this.childrens.get(id);
            if (old.node) {
                safeRemoveNode(old.node);
            }
            var childNode = provider(props, stateValue);
            if (childNode) {
                old.node = childNode;
                _this.node.appendChild(childNode);
            }
        }, deps, state);
        return '';
    };
    Ref.prototype.useEffect = function (provider, deps, state) {
        var ctx = {
            id: rnd(),
            provider: provider,
            result: undefined,
        };
        this.effects.push(ctx);
        this.subscribe(function (props, stateValue) {
            if (ctx.result) {
                ctx.result();
            }
            ctx.result = provider(props, stateValue);
        }, deps, state);
    };
    Ref.prototype.on = function (type, listener) {
        if (this.node && this.listeners[type]) {
            this.node.removeEventListener(type, this.listeners[type]);
        }
        this.listeners[type] = listener;
        if (this.node) {
            this.node.addEventListener(type, listener);
        }
    };
    Ref.prototype.mount = function () {
        var node = document.getElementById(this.refId);
        if (!node) {
            throw new Error('Attribute data-ref should be non empty string');
        }
        var attachTo = getDataset(node).attachTo;
        if (attachTo === 'body') {
            this.detached = true;
            document.body.appendChild(node);
        }
        this.setNode(node);
    };
    Ref.prototype.setNode = function (node) {
        var _this = this;
        this.node = node;
        if (this.className) {
            this.node.className = this.className;
        }
        if (this.innerText) {
            this.node.innerText = this.innerText;
        }
        if (this.style) {
            Object.keys(this.style).forEach(function (key) {
                _this.node.style.setProperty(key, _this.style[key], 'important');
            });
        }
        this.childrens.forEach(function (child) {
            var childNode = child.provider(_this.context.props);
            if (childNode) {
                _this.node.appendChild(childNode);
            }
        });
        Object.keys(this.listeners).forEach(function (event) {
            node.addEventListener(event, _this.listeners[event]);
        });
        this.effects.forEach(function (effect) {
            effect.result = effect.provider(_this.context.props, undefined);
        });
    };
    Ref.prototype.subscribe = function (listener, deps, state) {
        var _this = this;
        var handlePropsChanged = function (_a) {
            var prevValue = _a.prevValue, value = _a.value;
            if (deps.some(function (item) { return prevValue[item] !== value[item]; })) {
                listener(value, state === null || state === void 0 ? void 0 : state.value);
            }
        };
        this.context.onPropsChanged.addListener(handlePropsChanged);
        this.subscriptions.push(function () {
            _this.context.onPropsChanged.removeListener(handlePropsChanged);
        });
        if (state) {
            var handleStateChange_1 = function (event) {
                listener(_this.context.props, event.value);
            };
            state === null || state === void 0 ? void 0 : state.onChange.addListener(handleStateChange_1);
            this.subscriptions.push(function () {
                state.onChange.removeListener(handleStateChange_1);
            });
        }
    };
    Ref.prototype.getNode = function () {
        return this.node;
    };
    Ref.prototype.remove = function () {
        var _this = this;
        this.subscriptions.forEach(function (unsubscribe) { return unsubscribe(); });
        this.subscriptions = undefined;
        this.effects.forEach(function (effect) {
            var _a;
            (_a = effect.result) === null || _a === void 0 ? void 0 : _a.call(effect);
        });
        if (this.node) {
            Object.keys(this.listeners).forEach(function (event) {
                _this.node.removeEventListener(event, _this.listeners[event]);
            });
            if (this.detached) {
                safeRemoveNode(this.node);
            }
        }
        this.listeners = undefined;
        this.node = undefined;
        this.effects = undefined;
    };
    return Ref;
}());

var StateGetter = /** @class */ (function () {
    function StateGetter(getter, onChange) {
        this.getter = getter;
        this.onChange = onChange;
    }
    Object.defineProperty(StateGetter.prototype, "value", {
        get: function () {
            return this.getter();
        },
        enumerable: false,
        configurable: true
    });
    return StateGetter;
}());

var State = /** @class */ (function () {
    function State(id, value) {
        this.id = id;
        this.value = value;
        this.onChange = new Event();
    }
    State.prototype.setState = function (value) {
        var prevValue = this.value;
        if (partialShallowEqual(value, this.value)) {
            return;
        }
        this.value = __assign$2(__assign$2({}, prevValue), value);
        this.onChange.dispatch({ value: this.value, prevValue: prevValue });
    };
    State.prototype.getValueProvider = function () {
        var _this = this;
        var getter = function () { return _this.value; };
        return [
            new StateGetter(getter, this.onChange),
            function (getNextValue) {
                _this.setState(getNextValue(_this.value));
            },
        ];
    };
    State.prototype.destroy = function () {
        this.value = undefined;
        this.onChange.removeAllListener();
    };
    return State;
}());

var Context = /** @class */ (function () {
    function Context(props) {
        this.refs = new Map();
        this.states = new Set();
        this.children = [];
        this._props = new State(rnd(), props);
    }
    Object.defineProperty(Context.prototype, "props", {
        get: function () {
            return this._props.value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "onPropsChanged", {
        get: function () {
            return this._props.onChange;
        },
        enumerable: false,
        configurable: true
    });
    Context.prototype.getRef = function (name) {
        return this.refs[name];
    };
    Context.prototype.pipe = function (map) {
        var child = new Context(map(this.props));
        this.onPropsChanged.addListener(function (_a) {
            var value = _a.value;
            child.setProps(map(value));
        });
        this.children.push(child);
        return child;
    };
    Context.prototype.useState = function (value) {
        var state = new State(rnd(), value);
        this.states.add(state);
        return state.getValueProvider();
    };
    Context.prototype.setProps = function (props) {
        this._props.setState(props);
    };
    Context.prototype.useRef = function () {
        var ref = new Ref(this);
        this.refs.set(ref.refId, ref);
        return ref;
    };
    Context.prototype.mount = function (fragments) {
        this.fragments = fragments;
        this.refs.forEach(function (ref) {
            ref.mount();
        });
        this.children.forEach(function (child) {
            child.mount();
        });
    };
    Context.prototype.destroy = function () {
        this.refs.forEach(function (ref) {
            ref.remove();
        });
        this.refs.clear();
        this.onPropsChanged.removeAllListener();
        this.children.forEach(function (child) {
            child.destroy();
        });
        this.children = [];
        this.states.forEach(function (state) {
            state.destroy();
        });
        this.states.clear();
        this._props = undefined;
        if (this.fragments) {
            for (var i = 0; i < this.fragments.length; i++) {
                safeRemoveNode(this.fragments[i]);
            }
        }
    };
    return Context;
}());

var b$a = block('base');
function baseTemplate(context, children) {
    var mountRef = context.useRef();
    var loaderComponent = loaderTemplate(context.pipe(function (props) { return ({
        visible: props.page === 'loader',
    }); }));
    var errorComponent = errorTemplate(context.pipe(function (props) { return ({
        visible: props.page === 'error',
        lang: props.lang,
        onRetryErrorClick: props.onRetry,
    }); }));
    /* eslint-disable indent */
    return "\n        <div class=\"" + b$a() + "\">\n            " + (isDefined(children) ? children : '') + "\n            <div\n                " + mountRef.id + "\n                class=\"" + mountRef.useClassName(function (props) { return b$a('mount', {
        visible: props.page === 'messenger',
        fullscreen: props.fullscreen,
    }); }, ['page', 'fullscreen']) + "\"\n            >\n                " + mountRef.useChildren(function (props) {
        if (!props.iframe) {
            return;
        }
        props.iframe.className = b$a('iframe');
        return props.iframe;
    }, ['iframe']) + "\n            </div>\n            " + loaderComponent + "\n            " + errorComponent + "\n        </div>\n    ";
    /* eslint-enable indent */
}

var BaseUI = /** @class */ (function () {
    function BaseUI(template) {
        this.template = template;
        this.ready = false;
        this.destroyed = false;
        this.initialized = false;
    }
    BaseUI.prototype.render = function (node) {
        if (!this.initialized) {
            throw new Error('Widget should be initialized before mounting');
        }
        render(this.template, this.context, node);
    };
    /**
     * @private
     */
    BaseUI.prototype.init = function (_, widget) {
        var _a;
        this.widget = widget;
        widget.events.fullscreenOn.addListener(this.handleFullscreenOn);
        widget.events.fullscreenOff.addListener(this.handleFullscreenOff);
        this._context = new Context(__assign$2({ lang: this.options.lang || 'ru', onRetry: this.handleErrorRetryClick }, (_a = this.contextProvider) === null || _a === void 0 ? void 0 : _a.call(this, widget)));
        this.initialized = true;
    };
    Object.defineProperty(BaseUI.prototype, "context", {
        get: function () {
            var _context = this._context;
            assertDefined(_context, 'Widget should be initalized before using context');
            return _context;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseUI.prototype, "options", {
        get: function () {
            var widget = this.widget;
            assertDefined(widget, 'Widget should be initialzed before using options');
            return widget.options;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @private
     */
    BaseUI.prototype.LCClose = function () {
        this.destroy();
    };
    BaseUI.prototype.iframeOpen = function (props) {
        if (this.ready) {
            this.showMount(props);
            return;
        }
        this.showLoader(props);
    };
    BaseUI.prototype.toggleFullscreen = function (enabled) {
        this.context.setProps({
            fullscreen: enabled,
        });
    };
    BaseUI.prototype.showMount = function (props) {
        this.ready = true;
        this.context.setProps(__assign$2({ page: 'messenger' }, props));
    };
    BaseUI.prototype.showError = function (props) {
        this.context.setProps(__assign$2({ page: 'error' }, props));
    };
    BaseUI.prototype.showLoader = function (props) {
        this.context.setProps(__assign$2({ page: 'loader' }, props));
    };
    BaseUI.prototype.destroy = function () {
        this.widget.events.fullscreenOn.removeListener(this.handleFullscreenOn);
        this.widget.events.fullscreenOff.removeListener(this.handleFullscreenOff);
        this.context.destroy();
        this.ready = false;
        this.destroyed = true;
    };
    BaseUI.prototype.handleFullscreenOn = function () {
        this.toggleFullscreen(true);
    };
    BaseUI.prototype.handleFullscreenOff = function () {
        this.toggleFullscreen(false);
    };
    BaseUI.prototype.handleErrorRetryClick = function () {
        this.iframeOpen();
        this.widget.preload();
    };
    __decorate$9([
        lib$2.bind
    ], BaseUI.prototype, "handleFullscreenOn", null);
    __decorate$9([
        lib$2.bind
    ], BaseUI.prototype, "handleFullscreenOff", null);
    __decorate$9([
        lib$2.bind
    ], BaseUI.prototype, "handleErrorRetryClick", null);
    return BaseUI;
}());

var b$9 = block('block');
function template$2 (context) {
    /* eslint-disable indent */
    return "\n        <div class=\"" + b$9() + "\">\n            " + baseTemplate(context) + "\n        </div>\n    ";
    /* eslint-enable indent */
}

function iframeChildWindowProvider(_a, factory, callback) {
    var urlProvider = _a.urlProvider, allow = _a.allow;
    var url = urlProvider({
        utm_medium: 'iframe',
    });
    var childWIndow = factory(url, allow);
    var origin = new URL(url).origin;
    callback(new IframePostMessageTransport(childWIndow, origin));
}

function windowChildWindowProvider(_a, factory, callback) {
    var urlProvider = _a.urlProvider;
    var url = urlProvider({
        utm_medium: 'new_tab',
    });
    try {
        var childWindow = factory(url);
        var origin_1 = new URL(url).origin;
        callback(new ChildWindowPostMessageTransport(childWindow, window, origin_1, [origin_1]));
    }
    catch (error) {
        callback(undefined, error);
    }
}

function normalizeBadgeString(value, maxValue) {
    return String(maxValue < value ? maxValue + "+" : value) || '';
}

var normalizeFeatureInfo = function (featureInfo) {
    if (typeof featureInfo !== 'string') {
        return featureInfo;
    }
    try {
        return JSON.parse(featureInfo);
    }
    catch (e) {
        logError(e, {
            message: 'Can not get yandex application availability feature',
            additional: { featureInfo: featureInfo },
        });
    }
};
var getWindowWithFeature = function () {
    var _a;
    if ((_a = window.top) === null || _a === void 0 ? void 0 : _a.YandexApplicationsFeatureAvailability) {
        return window.top;
    }
    return window;
};
var getFeatureInfo = memo(function (name) {
    var featureAvailabilityHolder = getWindowWithFeature();
    var featureInfo = normalizeFeatureInfo(featureAvailabilityHolder.YandexApplicationsFeatureAvailability &&
        featureAvailabilityHolder.YandexApplicationsFeatureAvailability.getFeatureInfo(name));
    return {
        isAvailable: Boolean(featureInfo && featureInfo.isAvailable),
        params: featureInfo && featureInfo.params,
    };
});
var getNativeMessengerScheme = function () { return getFeatureInfo('messenger'); };
var isNativeAvailable = function () { return getNativeMessengerScheme().isAvailable; };
getFeatureInfo.clear;

var Block = /** @class */ (function (_super) {
    __extends$d(Block, _super);
    function Block() {
        return _super.call(this, template$2) || this;
    }
    /**
     * @doc
     * Смонтировать UI в указанный DOM узел.
     *
     * @doctemplate method_annotation
     */
    Block.prototype.mount = function (
    /**
     * @doc
     * Узел в который будет смонитрован UI
     */
    node) {
        this.render(node);
    };
    Block.prototype.getChildWindowTransport = function (params, callback) {
        var _this = this;
        iframeChildWindowProvider(params, function (url, allow) {
            var iframe = createIframe({
                url: url,
                allow: allow,
            });
            _this.context.setProps({
                iframe: iframe,
            });
            return iframe.contentWindow;
        }, callback);
    };
    /**
     * @private
     */
    Block.prototype.LCShown = function () {
        this.iframeOpen();
    };
    /**
     * @private
     */
    Block.prototype.LCReady = function () {
        this.showMount();
    };
    /**
     * @private
     */
    Block.prototype.LCErrorCritical = function () {
        this.showError();
    };
    return Block;
}(BaseUI));

// eslint-disable-next-line valid-jsdoc
/**
 * @doctemplate function_annotation
 * @doctitle Block ui
 * @doc
 * Интерфейс виджета для инлайн встраивания в страницу.
 * Подходит, например, для трансляций (когда чат находится рядом с видео).
 *
 * Виджет будет занимать 100% высоты и ширины узла в который он встроен
 *
 * [Storybook](https://messenger-test.s3.mds.yandex.net/storybook/widget/latest/index.html?path=/story/widget--ui-block)
 *
 * @docsubtitle Получение кол-ва непрочитанных сообщений в чате
 * В случае если вы планируете постоянно отображать виджет - можно использовать событие
 * виджета `counter` ([подробнее о том как подписываться на события](/doc/events.md)).
 * Иначе можно подключить плагин [UnreadCounter](/doc/plugin-unread-counter.md).
 *
 * @example
 * import 'yandex-int/messenger.widget/lib/ui/button.css';
 * import {
 *     YandexSingleBlockChatConfig,
 *     blockUIfactory,
 *     Widget,
 * } from 'yandex-int/messenger.widget';
 *
 * const ui = new Block();
 * const widget = new Widget(new YandexSingleBlockChatConfig(
 *     {
 *         serviceId: YOUR_SERVICE_ID,
 *         iframeOpenData: {
 *             // Параметры открытия виджета (идентификатор чата, идентификатор бота и т.п.)
 *             // [подробнее](/doc/interfaces.md#baseiframeopenparams)
 *         },
 *     },
 * ))
 *   .setUI(ui)
 *   .init();
 *
 * ui.mount(document.getElementById('widget_wrapper_node'))
 *
 * widget.show();
 */
function blockUIFactory() {
    return new Block();
}

var hasTouchEvent = false;
try {
    document.createEvent('TouchEvent');
    hasTouchEvent = true;
}
catch (e) { }
// Для телефонов логическое разрешение меньше 900 пикселей.
// http://iosres.com/  iPhone Xs Max - 896
var MAX_TOUCH_SCREEN_SIZE = 900;
var isSmallScreen = function () { return Math.max(window.screen.width, window.screen.height) < MAX_TOUCH_SCREEN_SIZE; };
function testIOS(userAgent) {
    return /iPad|iPhone|iPod/.test(userAgent);
}
/**
 * Часть скрипта из http://detectmobilebrowsers.com/
 */
function testIsMobile(userAgent) {
    return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(userAgent);
}
var isMobile = function () { return hasTouchEvent && (isSmallScreen() || testIsMobile(window.navigator.userAgent)); };
var isIOS = function () { return testIOS(window.navigator.userAgent); };

var NewWindowBlockedError = /** @class */ (function (_super) {
    __extends$d(NewWindowBlockedError, _super);
    function NewWindowBlockedError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, NewWindowBlockedError.prototype);
        return _this;
    }
    return NewWindowBlockedError;
}(lib$1.BaseError));

var IframeStrategy = /** @class */ (function () {
    function IframeStrategy(adapter) {
        this.adapter = adapter;
    }
    IframeStrategy.prototype.show = function () {
        this.adapter.show();
    };
    IframeStrategy.prototype.hide = function () {
        this.adapter.hide();
    };
    IframeStrategy.prototype.remove = function () {
        this.adapter.remove();
    };
    IframeStrategy.prototype.ready = function () {
    };
    IframeStrategy.prototype.getChildWindowTransport = function (params, callback) {
        var _this = this;
        iframeChildWindowProvider(params, function (url, allow) {
            _this.remove();
            return _this.adapter.create(url, allow).contentWindow;
        }, callback);
    };
    return IframeStrategy;
}());

var WindowStrategy = /** @class */ (function () {
    function WindowStrategy(adapter) {
        this.adapter = adapter;
    }
    WindowStrategy.prototype.show = function () {
        var _a;
        (_a = this.childWindow) === null || _a === void 0 ? void 0 : _a.focus();
    };
    WindowStrategy.prototype.ready = function () {
        var _a;
        (_a = this.adapter) === null || _a === void 0 ? void 0 : _a.ready();
    };
    WindowStrategy.prototype.hide = function () {
    };
    WindowStrategy.prototype.remove = function () {
        var _a;
        window.removeEventListener('unload', this.handleUnload);
        (_a = this.childWindow) === null || _a === void 0 ? void 0 : _a.close();
    };
    WindowStrategy.prototype.getChildWindowTransport = function (params, callback) {
        var _this = this;
        windowChildWindowProvider(params, function (url) {
            _this.remove();
            _this.childWindow = window.open(url);
            if (!_this.childWindow) {
                throw new NewWindowBlockedError('ChildWindow creation was failed');
            }
            window.addEventListener('unload', _this.handleUnload);
            return _this.childWindow;
        }, callback);
    };
    WindowStrategy.prototype.handleUnload = function () {
        if (window.document.visibilityState === 'visible') {
            this.remove();
        }
    };
    __decorate$9([
        lib$2.bind
    ], WindowStrategy.prototype, "handleUnload", null);
    return WindowStrategy;
}());

var defaultBehaviorStrategies = [
    {
        name: 'iframe',
        behavior: IframeStrategy,
    },
    {
        name: 'detached',
        behavior: WindowStrategy,
    },
];

var PageScrollController = /** @class */ (function () {
    function PageScrollController() {
        this.blockName = 'disable-page-scroll';
        this.POPUP_ANIMATION_TIMEOUT = 300;
        this.marginLeft = '';
        this.marginTop = '';
        this.scrollX = 0;
        this.scrollY = 0;
        this.disabled = false;
    }
    PageScrollController.prototype.clearPageScrollTimeout = function () {
        window.clearTimeout(this.scrollTimeout);
    };
    PageScrollController.prototype.handleChangeProps = function (props) {
        if (props.visible && props.isMobile) {
            this.disable();
        }
        else {
            this.enable();
        }
    };
    PageScrollController.prototype.disable = function () {
        var _this = this;
        if (this.disabled) {
            return;
        }
        this.clearPageScrollTimeout();
        this.scrollTimeout = window.setTimeout(function () {
            try {
                var body = document.body;
                if (isIOS) {
                    _this.scrollX = window.scrollX;
                    _this.scrollY = window.scrollY;
                    _this.marginLeft = body.style.marginLeft;
                    _this.marginTop = body.style.marginTop;
                    body.style.marginLeft = "-" + _this.scrollX + "px";
                    body.style.marginTop = "-" + _this.scrollY + "px";
                    body.classList.add(classname(_this.blockName, { ios: true }));
                }
                body.classList.add(classname(_this.blockName));
                _this.disabled = true;
            }
            catch (error) {
                logError(error);
            }
        }, this.POPUP_ANIMATION_TIMEOUT);
    };
    PageScrollController.prototype.enable = function () {
        try {
            // Флаг disabled выставляется только после таймаута
            // поэтому в любом случае сначала его отменяем а потом проверяем флаг
            this.clearPageScrollTimeout();
            if (!this.disabled) {
                return;
            }
            var body = document.body;
            body.classList.remove(classname(this.blockName));
            if (isIOS) {
                body.classList.remove(classname(this.blockName, { ios: true }));
                body.style.marginLeft = this.marginLeft;
                body.style.marginTop = this.marginTop;
                window.scrollTo(this.scrollX, this.scrollY);
            }
            this.disabled = false;
        }
        catch (error) {
            logError(error);
        }
    };
    return PageScrollController;
}());

var OFFSET = 10;
var MIN_HEIGHT = 250;
function getViewportBounds() {
    var left = 0;
    var top = 0;
    var width = window.innerWidth;
    var height = window.innerHeight;
    return {
        left: left + OFFSET,
        top: top + OFFSET,
        right: left + width - OFFSET,
        bottom: top + height - OFFSET,
        width: width,
        height: height,
    };
}
function getPopupHeight(viewportHeight, popupHeight, anchorBounds, anchor, position) {
    var targetOffset = anchor.offsetParent ? anchor.offsetParent.offsetTop || 0 : 0;
    var availableHeight = position === 'top' ?
        anchorBounds.top - OFFSET :
        viewportHeight - (window.pageYOffset - targetOffset + anchorBounds.bottom + OFFSET * 2);
    return Math.max(MIN_HEIGHT, Math.min(availableHeight, popupHeight));
}
function parsePosition(targetPosition) {
    return isDefined(targetPosition) ? targetPosition.split('-') : ['bottom', 'left'];
}
function calculatePosition(el, anchor, targetPosition, prevPosition) {
    var anchorBounds = anchor.getBoundingClientRect();
    var anchorBoundsLeft = anchorBounds.left;
    var anchorBoundsRight = anchorBounds.right;
    var anchorBoundsTop = anchorBounds.top;
    var anchorBoundsBottom = anchorBounds.bottom;
    var posSplit = parsePosition(targetPosition);
    var top = posSplit[0] === 'top' ? anchorBoundsTop : anchorBoundsBottom;
    var left = posSplit[1] === 'right' ? anchorBoundsRight : anchorBoundsLeft;
    var viewportBounds = getViewportBounds();
    var width = el.offsetWidth;
    var naturalHeight = (prevPosition === null || prevPosition === void 0 ? void 0 : prevPosition.naturalHeight) || el.offsetHeight;
    var height = getPopupHeight(viewportBounds.height, naturalHeight, anchorBounds, anchor, posSplit[0]);
    var viewportCenter = {
        left: viewportBounds.left + (viewportBounds.right - viewportBounds.left) / 2,
        top: viewportBounds.top + (viewportBounds.bottom - viewportBounds.top) / 2,
    };
    if (anchorBoundsLeft + width > viewportBounds.right) {
        if (anchorBoundsRight > viewportCenter.left) {
            left = Math.max(anchorBoundsRight - width, OFFSET);
        }
        else {
            left = Math.min(anchorBoundsLeft, viewportBounds.right - width);
        }
    }
    if (anchorBoundsBottom + height > viewportBounds.bottom) {
        if (anchorBoundsTop > viewportCenter.top) {
            top = anchorBoundsTop - height;
        }
    }
    return {
        left: Math.floor(left),
        top: Math.floor(top),
        height: height,
        naturalHeight: naturalHeight,
    };
}

var b$8 = block('popup');
var RESET_POSITION = {
    left: undefined,
    top: undefined,
};
function getPositionClass(props) {
    if (props.inner) {
        return 'inner';
    }
    return props.target ? 'target' : 'fixed';
}
function popupTemplate$1(context, children, header) {
    var _a = context.useState(RESET_POSITION), place = _a[0], setPlace = _a[1];
    var paranjaRef = context.useRef();
    var popupRef = context.useRef();
    var popupWrapperRef = context.useRef();
    paranjaRef.on('click', context.props.onParanjaClick);
    popupRef.useEffect(function (props) {
        function handleDocumentClick(e) {
            var target = e.target;
            if (target &&
                !popupRef.getNode().contains(target)) {
                props.onParanjaClick();
            }
        }
        if (props.autocloseable && props.visible) {
            document.addEventListener('click', handleDocumentClick, true);
        }
        return function () {
            document.removeEventListener('click', handleDocumentClick, true);
        };
    }, ['visible', 'autocloseable', 'onParanjaClick']);
    popupRef.useEffect(function (props) {
        function handleUpdatePosition() {
            setPlace(function (current) {
                return !props.visible || !props.target || props.isMobile || props.inner ?
                    RESET_POSITION :
                    props.calculatePosition(popupWrapperRef.getNode(), props.target, props.position, current);
            });
        }
        window.addEventListener('resize', handleUpdatePosition);
        window.addEventListener('scroll', handleUpdatePosition);
        window.addEventListener('orientationchange', handleUpdatePosition);
        handleUpdatePosition();
        return function () {
            window.removeEventListener('resize', handleUpdatePosition);
            window.removeEventListener('scroll', handleUpdatePosition);
            window.removeEventListener('orientationchange', handleUpdatePosition);
        };
    }, ['target', 'position', 'visible', 'isMobile', 'inner', 'calculatePosition']);
    popupRef.useEffect(function (props) { return function () { return props.pageScrollController.enable(); }; }, ['pageScrollController']);
    popupRef.useEffect(function (props) {
        props.pageScrollController.handleChangeProps(props);
    }, ['visible', 'isMobile']);
    /* eslint-disable indent */
    return "\n        <div\n            class=\"" + b$8('container') + "\"\n        >\n            <div\n                " + paranjaRef.id + "\n                class=\"" + paranjaRef.useClassName(function (props) { return b$8('paranja', {
        visible: props.visible && (props.isMobile || props.paranjaVisible),
    }); }, ['visible', 'isMobile', 'paranjaVisible']) + "\"\n            >\n            </div>\n            <div\n                " + popupRef.id + "\n                style=\"" + popupRef.useStyle(function (_, _a) {
        var left = _a.left, top = _a.top;
        return ({
            left: isDefined(left) ? left + "px" : undefined,
            top: isDefined(top) ? top + "px" : undefined,
        });
    }, [], place) + "\"\n                class=\"" + popupRef.useClassName(function (props) { return b$8({
        button: props.buttonMode,
        position: getPositionClass(props),
        desktop: !props.isMobile,
        mobile: props.isMobile,
        visible: props.visible,
        fullscreen: props.fullscreen,
    }); }, ['buttonMode', 'target', 'isMobile', 'visible', 'fullscreen', 'inner']) + "\"\n            >\n                <div\n                    " + popupWrapperRef.id + "\n                    class=\"" + b$8('content-wrapper') + "\"\n                    style=\"" + popupWrapperRef.useStyle(function (_, _a) {
        var height = _a.height;
        return ({
            height: isDefined(height) ? height + "px" : undefined,
        });
    }, [], place) + "\"\n                >\n                    " + (isDefined(header) ? header : '') + "\n                    " + children + "\n                </div>\n            </div>\n        </div>\n    ";
    /* eslint-enable indent */
}

var PopupBase = /** @class */ (function (_super) {
    __extends$d(PopupBase, _super);
    function PopupBase(template, contextProvider, 
    /**
     * @doc
     * Настройки интерфейса
     * @docref template=members_annotation
     */
    props) {
        var _this = _super.call(this, template) || this;
        _this.props = props;
        /**
         * @doc Скрыт ли попап
         * @doctemplate members_annotation
         */
        _this.hidden = true;
        /**
         * @doc Вызывается при открытии/закрытии попапа
         * @doctemplate members_annotation
         */
        _this.onToggled = new Event();
        _this.contextProvider = function (widget) { return (__assign$2({ popupTarget: props.popupTargetNode, popupPosition: props.popupTargetPosition, popupAutocloseable: props.autocloseable, isMobile: isDefined(props.isMobile) ? props.isMobile : isMobile(), paranjaVisible: props.paranjaVisible, calculatePosition: props.calculatePosition, onClose: function () { return widget.hide(); }, onNewTab: _this.handleNewWindowClick, pageScrollController: _this.props.pageScrollController || new PageScrollController() }, contextProvider(widget, props))); };
        _this.strategies = _this.props.strategies || defaultBehaviorStrategies;
        _this.currentStrategyName = _this.strategies[0].name;
        _this.setBehavior(_this.getStrategyByName(_this.currentStrategyName));
        return _this;
    }
    PopupBase.prototype.getChildWindowTransport = function (params, callback) {
        this.behavior.getChildWindowTransport(params, callback);
    };
    PopupBase.prototype.LCReady = function () {
        this.showMount();
        this.behavior.ready();
    };
    PopupBase.prototype.LCErrorCritical = function (event) {
        var error = event.data.error;
        if (NewWindowBlockedError.is(error)) {
            this.showNewWindowRequest();
            return;
        }
        if (CookieNeededError.is(error) &&
            this.currentStrategyName === 'iframe' &&
            this.getStrategyByName('detached')) {
            try {
                this.setBehavior(this.getStrategyByName('detached'));
                this.widget.preload();
                return;
            }
            catch (_a) { }
        }
        this.showError();
    };
    PopupBase.prototype.LCHidden = function () {
        this.behavior.hide();
    };
    PopupBase.prototype.LCShown = function () {
        this.behavior.show();
    };
    PopupBase.prototype.hidePopup = function () {
        if (this.hidden) {
            return;
        }
        this.hidden = true;
        this.context.setProps({
            popupVisible: false,
        });
        this.onToggled.dispatch({ hidden: true });
    };
    /**
     * Раскрывает попап.
     * Не должен быть публичным, так как открывать папоп надо исключительно виджетом (shotChatList | showChat)
     */
    PopupBase.prototype.showPopup = function () {
        if (!this.hidden) {
            return;
        }
        this.hidden = false;
        this.iframeOpen({
            popupVisible: true,
        });
        this.onToggled.dispatch({ hidden: false });
    };
    PopupBase.prototype.showNewWindowRequest = function () {
        this.context.setProps({
            page: 'new-window-blocked',
        });
    };
    PopupBase.prototype.getStrategyByName = function (name) {
        return this.strategies.filter(function (strategy) { return strategy.name === name; })[0];
    };
    PopupBase.prototype.setBehavior = function (strategy) {
        var _this = this;
        var _a;
        if (this.behavior && this.currentStrategyName === strategy.name) {
            return;
        }
        (_a = this.behavior) === null || _a === void 0 ? void 0 : _a.remove();
        this.currentStrategyName = strategy.name;
        if (strategy.name === 'iframe') {
            this.behavior = new strategy.behavior({
                show: function () {
                    _this.showPopup();
                },
                hide: function () {
                    _this.hidePopup();
                },
                remove: function () {
                    _this.context.setProps({
                        iframe: undefined,
                    });
                },
                create: function (url, allow) {
                    var iframe = createIframe({
                        url: url,
                        allow: allow,
                    });
                    _this.context.setProps({
                        iframe: iframe,
                    });
                    return iframe;
                },
            });
        }
        else if (strategy.name === 'detached') {
            this.behavior = new strategy.behavior({
                ready: function () {
                    _this.hidePopup();
                },
            });
        }
    };
    PopupBase.prototype.handleNewWindowClick = function () {
        this.setBehavior(this.getStrategyByName('detached'));
        try {
            this.widget.preload();
            this.hidePopup();
        }
        catch (_a) { }
    };
    __decorate$9([
        lib$2.bind
    ], PopupBase.prototype, "handleNewWindowClick", null);
    return PopupBase;
}(BaseUI));

var Popup = /** @class */ (function (_super) {
    __extends$d(Popup, _super);
    function Popup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @doc
     * Смонтировать UI в указанный DOM узел.
     *
     * @doctemplate method_annotation
     */
    Popup.prototype.mount = function () {
        this.render(document.body);
    };
    /**
     * @doc
     * Установка/удаления элемента, откносительно которого будет открыт попап
     *
     * @doctemplate method_annotation
     */
    Popup.prototype.setPopupTarget = function (
    /**
     * @doc
     * Элемент, относительно которого будет открыт попап.
     * Если undefined то попап начнет открываться сбоку.
     * @doctemplate
     */
    target, 
    /**
     * @doc
     * Позиция попапа
     * @doctemplate
     */
    position) {
        this.context.setProps({
            popupTarget: target,
            popupPosition: position || this.context.props.popupPosition,
        });
    };
    return Popup;
}(PopupBase));

var b$7 = block('close');
function close (context) {
    var closeRef = context.useRef();
    var closeButtonRef = context.useRef();
    closeButtonRef.on('click', context.props.onCloseClick);
    /* eslint-disable indent */
    return "\n        <div\n            " + closeRef.id + "\n            class=\"" + closeRef.useClassName(function (_a) {
        var visible = _a.visible;
        return b$7({
            visible: visible,
        });
    }, ['visible']) + "\"\n        >\n            <div " + closeButtonRef.id + " class=\"" + b$7('button-box') + "\">\n                <div class=\"" + b$7('button') + "\"></div>\n            </div>\n        </div>\n    ";
    /* eslint-enable indent */
}

var b$6 = block('new-window');
function newWindowBlockedError(context) {
    var lang = context.props.lang;
    var rootRef = context.useRef();
    var buttonRef = context.useRef();
    buttonRef.on('click', context.props.onOpenNewTabClick);
    /* eslint-disable indent */
    return "\n        <div\n            " + rootRef.id + "\n            class=\"" + rootRef.useClassName(function (_a) {
        var visible = _a.visible;
        return b$6({
            visible: visible,
        });
    }, ['visible']) + "\"\n        >\n            <div class=\"" + b$6('title') + "\">\n                " + i18n('cookie-blocked-text', lang) + "\n            </div>\n            <div " + buttonRef.id + " class=\"" + b$6('button') + "\">\n                " + i18n('new-window-button', lang) + "\n            </div>\n        </div>\n    ";
    /* eslint-enable indent */
}

var b$5 = block('popup-ui');
function basePopupTemplate(context, header) {
    if (!context.props.lang) {
        throw new Error('');
    }
    var closeComponent = close(context.pipe(function (props) { return ({
        visible: props.page !== 'messenger',
        onCloseClick: props.onClose,
    }); }));
    var newWindowComponent = newWindowBlockedError(context.pipe(function (props) { return ({
        visible: props.page === 'new-window-blocked',
        onOpenNewTabClick: props.onNewTab,
        lang: props.lang,
    }); }));
    var baseComponent = baseTemplate(context.pipe(function (props) { return ({
        lang: props.lang,
        onRetry: props.onRetry,
        fullscreen: props.fullscreen,
        iframe: props.iframe,
        page: props.page,
    }); }), closeComponent);
    return popupTemplate$1(context.pipe(function (props) { return ({
        isMobile: props.isMobile,
        onParanjaClick: props.onClose,
        buttonMode: props.buttonMode,
        position: props.popupPosition,
        autocloseable: props.popupAutocloseable,
        target: props.popupTarget,
        visible: props.popupVisible,
        fullscreen: props.fullscreen,
        inner: props.inner,
        paranjaVisible: props.paranjaVisible,
        calculatePosition: props.calculatePosition || calculatePosition,
        pageScrollController: props.pageScrollController,
    }); }), "\n            " + baseComponent + "\n            " + newWindowComponent + "\n        ", header);
}
function popupTemplate (context, header) {
    return "\n        <div data-ref=\"popup-ui\" class=\"" + b$5() + "\">\n            " + basePopupTemplate(context, header) + "\n        </div>\n    ";
}

// eslint-disable-next-line valid-jsdoc
/**
 * @doctemplate function_annotation
 * @doctitle Popup ui
 * @doc
 * Интерфейс виджета для открытия мессенджера в popup-е.
 * Подходит, например, если у вас есть своя кнопка открытия виджета.
 *
 * Если задан параметр `popupTargetNode` попап будет спозиционирован относительно заданного узла
 * (настроить позиционирования можно через `popupTargetPosition`), иначе попап откроется
 * в правом нижнем углу.
 *
 * Параметры `popupTargetNode` и `popupTargetPosition` не обязательно задавать сразу,
 * в любой момент после инициализации виджета, можно вызвать метод `Popup::setPopupTarget`
 *
 * Для того что бы программно открыть виджет необходимо использовать `Widget::show`
 *
 * [Storybook](https://messenger-test.s3.mds.yandex.net/storybook/widget/latest/index.html?path=/story/widget--ui-popup)
 *
 * @example
 * import 'yandex-int/messenger.widget/lib/ui/popup.css';
 * import {
 *     YandexConfig,
 *     Widget,
 *     popupUIFactory,
 * } from 'yandex-int/messenger.widget';
 *
 * const ui = popupUIFactory({
 *     popupTargetNode: document.getElementById('my_custom_chat_button'),
 * });
 *
 * const widget = new Widget(new YandexConfig({
 *     serviceId: YOUR_SERVICE_ID,
 *     iframeOpenData: {
 *         // Параметры открытия виджета (идентификатор чата, идентификатор бота и т.п.)
 *         // [подробнее](/doc/interfaces.md#baseiframeopenparams)
 *     },
 * }))
 *     .setUI(ui)
 *     .init();
 *
 * ui.mount();
 *
 * document.getElementById('button').addEventListener('click', () => {
 *     widget.show();
 * });
 *
 * @doc
 * В случае если нужно отображение кол-ва непрочитанных сообщений можно подключить плагин UnreadCounter
 *
 * @example
 * import 'yandex-int/messenger.widget/lib/ui/popup.css';
 * import {
 *     YandexConfig,
 *     Widget,
 *     popupUIFactory,
 *     yandexUnreadCountFactory,
 * } from 'yandex-int/messenger.widget';
 *
 * const ui = new popupUIFactory({});
 * const unreadCounter = yandexUnreadCountFactory();
 *
 * unreadCounter.onChanged.addListener(({ data }) => console.log(data));
 *
 * const widget = new Widget(new YandexConfig({
 *     serviceId: -1,
 *     iframeOpenData: {
 *         // Параметры открытия виджета (идентификатор чата, идентификатор бота и т.п.)
 *         // [подробнее](/doc/interfaces.md#baseiframeopenparams)
 *     },
 * }))
 *     .addPlugin(unreadCounter)
 *     .setUI(ui);
 *     .init();
 *
 * ui.mount();
 */
function popupUIFactory(
/**
 * @docref template=members_annotation
 */
props) {
    return new Popup(popupTemplate, function () { return ({}); }, props);
}

var b$4 = block('icon');
function icon() {
    return "<svg class=\"" + b$4() + "\" viewBox=\"0 0 28 28\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n        <g clip-path=\"url(#clip-mssngr-widget-icon)\">\n        <g filter=\"url(#filter0-mssngr-widget)\">\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14 0C2.8 0 0 2.8 0 14C0 25.2 2.8 28 14 28C25.2 28 28 25.2 28 14C28 2.8 25.2 0 14 0Z\" fill=\"#00D7D7\"/>\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14 0C2.8 0 0 2.8 0 14C0 25.2 2.8 28 14 28C25.2 28 28 25.2 28 14C28 2.8 25.2 0 14 0Z\" fill=\"url(#paint0_linear-mssngr-widget)\"/>\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14 0C2.8 0 0 2.8 0 14C0 25.2 2.8 28 14 28C25.2 28 28 25.2 28 14C28 2.8 25.2 0 14 0Z\" fill=\"url(#paint1_linear-mssngr-widget)\"/>\n        </g>\n            <path d=\"M25.0249 13.7106C24.9593 13.5028 24.8061 13.3169 24.5983 13.1965L8.49834 4.16217C7.86396 3.81217 7.0874 4.2606 7.0874 4.99342V7.11529V8.38404L25.0249 13.7106Z\" fill=\"#FAFFFE\"/>\n            <path d=\"M7.0874 20.9013V23.0231C7.0874 23.745 7.86396 24.2044 8.49834 23.8544L24.5983 14.831C24.8171 14.7106 24.9593 14.5247 25.0249 14.3169L7.0874 19.6216V20.9013Z\" fill=\"#C8F4F9\"/>\n            <path d=\"M7.08759 8.37787L5.87353 8.01693C5.07509 7.77631 4.38603 8.60756 4.7579 9.35131L5.41415 10.6529L6.87978 13.5732L7.09853 13.9997V8.37787H7.08759Z\" fill=\"#DEF8FB\"/>\n            <path d=\"M7.0874 13.9998H25.0796C25.0796 13.8904 25.0577 13.792 25.0249 13.6936L7.0874 8.37793V13.9998Z\" fill=\"#DEF8FB\"/>\n            <path d=\"M7.09853 14.0005L4.7579 18.6489C4.38603 19.3927 5.07509 20.2239 5.87353 19.9833L7.08759 19.6224V14.0005H7.09853Z\" fill=\"#FAFFFE\"/>\n            <path d=\"M7.0874 19.6219L25.0358 14.3063C25.0686 14.2078 25.0905 14.0984 25.0905 14H7.0874V19.6219Z\" fill=\"#FAFFFE\"/>\n        </g>\n        <defs>\n        <filter id=\"filter0-mssngr-widget\" x=\"-25.7204\" y=\"-14.7308\" width=\"79.4408\" height=\"79.4408\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n            <feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n            <feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\"/>\n            <feOffset dy=\"10.9896\"/>\n            <feGaussianBlur stdDeviation=\"12.8602\"/>\n            <feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0\"/>\n            <feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow\"/>\n            <feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow\" result=\"shape\"/>\n        </filter>\n        <linearGradient id=\"paint0_linear-mssngr-widget\" x1=\"44.8437\" y1=\"-28.5469\" x2=\"14\" y2=\"16.5156\" gradientUnits=\"userSpaceOnUse\">\n            <stop stop-color=\"white\"/>\n            <stop offset=\"1\" stop-color=\"white\" stop-opacity=\"0\"/>\n        </linearGradient>\n        <linearGradient id=\"paint1_linear-mssngr-widget\" x1=\"14\" y1=\"33.3594\" x2=\"34.3437\" y2=\"-11.4844\" gradientUnits=\"userSpaceOnUse\">\n            <stop stop-color=\"#00BCBC\"/>\n            <stop offset=\"1\" stop-color=\"white\" stop-opacity=\"0\"/>\n        </linearGradient>\n        <clipPath id=\"clip-mssngr-widget-icon\">\n            <path d=\"M0 0H28V28H0V0Z\" fill=\"white\"/>\n        </clipPath>\n        </defs>\n    </svg>";
}

var b$3 = block('button');
function buttonTemplate$1(context, children) {
    var buttonRef = context.useRef();
    buttonRef.on('click', context.props.onClick);
    var text = context.props.buttonText ? "\n        <div class=\"" + b$3('text') + "\">\n            <div class=\"" + b$3('text-container') + "\">" + context.props.buttonText + "</div>\n        </div>" : '';
    /* eslint-disable indent */
    return "\n        <a " + buttonRef.id + " class=\"" + buttonRef.useClassName(function (props) { return b$3({
        mobile: props.isMobile,
        collapsed: props.collapsed,
        size: props.buttonSize,
        desktop: !props.isMobile,
        visible: props.visible,
    }); }, ['isMobile', 'visible', 'buttonSize', 'collapsed']) + "\">\n            <div class=\"" + b$3('container') + "\">\n                <div class=\"" + b$3('icon') + "\">\n                    " + icon() + "\n                </div>\n                " + text + "\n            </div>\n            " + (children ? children : '') + "\n        </a>";
    /* eslint-enable indent */
}

var b$2 = block('badge');
function getCount$1(data, shouldUseValueForChat) {
    if (shouldUseValueForChat) {
        return (data === null || data === void 0 ? void 0 : data.valueForChat) || 0;
    }
    return (data === null || data === void 0 ? void 0 : data.value) || 0;
}
function badgeTemplate(context) {
    var _a, _b;
    var _c = context.useState({
        count: getCount$1((_a = context.props.unreadCounterPlugin) === null || _a === void 0 ? void 0 : _a.lastValue, (_b = context.props.unreadCounterPlugin) === null || _b === void 0 ? void 0 : _b.shouldUseValueForChat),
    }), state = _c[0], setState = _c[1];
    var badgeRef = context.useRef();
    var badgeCountRef = context.useRef();
    badgeRef.useEffect(function (props) {
        var unreadCounterPlugin = props.unreadCounterPlugin;
        var handler = function (data) {
            setState(function () { return ({
                count: getCount$1(data, unreadCounterPlugin === null || unreadCounterPlugin === void 0 ? void 0 : unreadCounterPlugin.shouldUseValueForChat),
            }); });
        };
        if (unreadCounterPlugin) {
            setState(function () { return ({
                count: getCount$1(unreadCounterPlugin.lastValue, unreadCounterPlugin.shouldUseValueForChat),
            }); });
            unreadCounterPlugin.onChanged.addListener(handler);
        }
        return function () {
            unreadCounterPlugin === null || unreadCounterPlugin === void 0 ? void 0 : unreadCounterPlugin.onChanged.removeListener(handler);
        };
    }, ['unreadCounterPlugin']);
    /* eslint-disable indent */
    return "\n        <div\n            " + badgeRef.id + "\n            class=\"" + badgeRef.useClassName(function (props, _a) {
        var count = _a.count;
        return b$2({
            'has-count': Boolean(count),
            type: props.badgeType,
            visible: Boolean(count),
        });
    }, ['badgeType'], state) + "\"\n        >\n            <div " + badgeCountRef.id + " class=\"" + b$2('count') + "\">\n                " + badgeCountRef.useText(function (props, _a) {
        var count = _a.count;
        return normalizeBadgeString(count, props.badgeMaxCount);
    }, ['badgeMaxCount'], state) + "\n            </div>\n        </div>\n    ";
    /* eslint-enable indent */
}

var b$1 = block('button-ui');
function buttonTemplate(context, header) {
    var badgeComponent = badgeTemplate(context.pipe(function (props) { return ({
        badgeMaxCount: props.badgeMaxCount,
        unreadCounterPlugin: props.unreadCounterPlugin,
        badgeType: props.badgeType,
    }); }));
    var popupComponent = basePopupTemplate(context.pipe(function (props) { return ({
        lang: props.lang,
        isMobile: props.isMobile,
        page: props.page,
        iframe: props.iframe,
        fullscreen: props.fullscreen,
        popupAutocloseable: props.popupAutocloseable,
        buttonMode: true,
        popupVisible: props.popupVisible,
        popupPosition: undefined,
        popupTarget: undefined,
        paranjaVisible: props.paranjaVisible,
        onClose: props.onClose,
        onRetry: props.onRetry,
        onNewTab: props.onRetry,
        inner: true,
        pageScrollController: props.pageScrollController,
    }); }), header);
    /* eslint-disable indent */
    return "\n        <div class=\"" + b$1() + "\">\n            " + buttonTemplate$1(context.pipe(function (props) { return ({
        isMobile: props.isMobile,
        lang: props.lang,
        collapsed: props.collapsed,
        buttonSize: props.buttonSize,
        buttonText: props.buttonText,
        visible: props.popupVisible,
        onClick: props.onButtonClick,
    }); }), badgeComponent) + "\n            <div data-ref=\"popup-wrapper\" class=\"" + b$1('popup-wrapper') + "\">\n                " + popupComponent + "\n            </div>\n        </div>\n    ";
    /* eslint-enable indent */
}

function getNormalizeCollapsed(props) {
    var isMobile = props.isMobile, buttonText = props.buttonText, collapsedDesktop = props.collapsedDesktop, collapsedTouch = props.collapsedTouch;
    var collapsed = isMobile ? collapsedTouch : collapsedDesktop;
    if (!buttonText) {
        return 'always';
    }
    if (!isMobile && ['always', 'never', 'hover'].indexOf(collapsed) === -1) {
        return 'hover';
    }
    if (isMobile && ['always', 'never'].indexOf(collapsed) === -1) {
        return 'always';
    }
    return collapsed;
}
function normalizeProps(props, lang) {
    return __assign$2(__assign$2({}, props), { isMobile: isDefined(props.isMobile) ? props.isMobile : isMobile(), buttonText: isDefined(props.buttonText) ? props.buttonText : i18n('button-text-default', lang), badgeType: props.badgeType || 'num', badgeMaxCount: props.badgeMaxCount || 99 });
}
function buttonContextFactoryProvider(props) {
    return function (widget) {
        var normalizedProps = normalizeProps(props, widget.options.lang);
        var collapsed = getNormalizeCollapsed(normalizedProps);
        return {
            buttonMode: true,
            badgeMaxCount: normalizedProps.badgeMaxCount || 99,
            badgeType: normalizedProps.badgeType || 'num',
            collapsed: collapsed,
            buttonSize: collapsed === 'always' ? 'large' : 'normal',
            buttonText: normalizedProps.buttonText,
            unreadCounterPlugin: normalizedProps.unreadCounterPlugin,
            paranjaVisible: normalizedProps.paranjaVisible,
            pageScrollController: props.pageScrollController || new PageScrollController(),
            onButtonClick: function () {
                widget.show();
            },
        };
    };
}
var ButtonUI = /** @class */ (function (_super) {
    __extends$d(ButtonUI, _super);
    function ButtonUI(props) {
        return _super.call(this, buttonTemplate, buttonContextFactoryProvider(props), props) || this;
    }
    /**
     * @doc
     * Смонтировать UI в указанный DOM узел. По умолчанию в document.body
     *
     * @doctemplate method_annotation
     */
    ButtonUI.prototype.mount = function (
    /**
     * @doc
     * Узел в который будет смонитрован UI
     */
    node) {
        if (node === void 0) { node = document.body; }
        this.render(node);
    };
    return ButtonUI;
}(PopupBase));
/* eslint-disable valid-jsdoc */
/**
 * @doctemplate function_annotation
 * @doctitle Button ui
 * @doc
 * Классический виджет с кнопкой. Кнопка отображается в правом нижнем углу
 *
 * [Storybook](https://messenger-test.s3.mds.yandex.net/storybook/widget/latest/index.html?path=/story/widget--ui-button)
 *
 * @example
 * import 'yandex-int/messenger.widget/lib/ui/button.css';
 * import {
 *     YandexConfig,
 *     Widget,
 *     buttonUIFactory,
 *     yandexUnreadCounterFactory,
 * } from 'yandex-int/messenger.widget';
 *
 * const unreadCounterPlugin = yandexUnreadCounterFactory();
 *
 * const ui = buttonUIFactory({
 *    unreadCounterPlugin,
 * });
 *
 * const widget = new Widget(new YandexConfig({
 *     serviceId: YOUR_SERVICE_ID,
 *     iframeOpenData: {
 *         // Параметры открытия виджета (идентификатор чата, идентификатор бота и т.п.)
 *         // [подробнее](/doc/interfaces.md#baseiframeopenparams)
 *     },
 * }))
 *     .setPlugin(unreadCounterPlugin)
 *     .setUI(ui)
 *     .init();
 *
 * ui.mount();
 */
function buttonUIFactory(
/**
 * @docref template=members_annotation
 */
props) {
    return new ButtonUI(props);
}

var b = block('support-header');
var MAX_UNREAD_CHAT = 99;
function getText(value, lang) {
    if (value) {
        return i18n('support-unread-text-count', lang, value);
    }
    return i18n('support-unread-text', lang);
}
function getCount(value) {
    if (!value ||
        !isDefined(value.chatCount) ||
        !isDefined(value.valueForChat)) {
        return 0;
    }
    return value.chatCount - (value.valueForChat > 0 ? 1 : 0);
}
function supportHeaderTemplate(context) {
    var _a;
    var _b = context.useState({
        count: getCount((_a = context.props.unreadCounterPlugin) === null || _a === void 0 ? void 0 : _a.lastValue),
    }), state = _b[0], setState = _b[1];
    var textRef = context.useRef();
    var badgeRef = context.useRef();
    badgeRef.useEffect(function (props) {
        var handler = function (data) {
            setState(function () { return ({
                count: getCount(data),
            }); });
        };
        var unreadCounterPlugin = props.unreadCounterPlugin;
        if (unreadCounterPlugin) {
            handler(unreadCounterPlugin === null || unreadCounterPlugin === void 0 ? void 0 : unreadCounterPlugin.lastValue);
            unreadCounterPlugin.onChanged.addListener(handler);
        }
        return function () {
            unreadCounterPlugin === null || unreadCounterPlugin === void 0 ? void 0 : unreadCounterPlugin.onChanged.removeListener(handler);
        };
    }, ['unreadCounterPlugin']);
    /* eslint-disable indent */
    return "\n        <div class=\"" + b() + "\">\n            <a href=\"" + context.props.passportUrl + "\" target=\"_blank\" class=\"" + b('logo') + "\">\n                <svg width=\"58\" height=\"24\" viewBox=\"0 0 58 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 0H46C52.6274 0 58 5.37259 58 12C58 18.6274 52.6274 24 46 24H12C5.37257 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0ZM12 1.06077C5.95843 1.06077 1.06077 5.95843 1.06077 12C1.06077 18.0416 5.95842 22.9392 12 22.9392H46C52.0416 22.9392 56.9392 18.0416 56.9392 12C56.9392 5.95843 52.0416 1.06077 46 1.06077H12Z\" fill=\"black\"/>\n                    <rect x=\"5.30371\" y=\"4.64087\" width=\"14.5856\" height=\"14.5856\" rx=\"7.29282\" fill=\"#FC3F1D\"/>\n                    <path d=\"M13.6244 16.3167H15.148V7.56531H12.9319C10.7031 7.56531 9.53204 8.71117 9.53204 10.3985C9.53204 11.7458 10.1742 12.5391 11.3201 13.3576L9.33057 16.3167H10.9801L13.1963 13.005L12.4282 12.4887C11.4964 11.8592 11.0431 11.3681 11.0431 10.3103C11.0431 9.37854 11.6978 8.74895 12.9444 8.74895H13.6244V16.3167Z\" fill=\"white\"/>\n                    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M45.2273 17.2309V17.2376H43.0988V6.37415H46.3853C47.2488 6.37415 48.0453 6.46785 48.7682 6.65527C49.491 6.84268 50.1202 7.14389 50.6624 7.55888C51.1979 7.97387 51.6196 8.52943 51.9208 9.21216C52.222 9.90158 52.3759 10.7449 52.3759 11.7423C52.3759 12.927 52.1082 13.931 51.5794 14.7409C51.0506 15.5508 50.321 16.1733 49.3973 16.595C48.4736 17.0167 47.4295 17.2309 46.2648 17.2309H45.2273ZM45.2273 15.6378V7.96718H46.1979C46.9743 7.96718 47.6704 8.08097 48.2728 8.30854C48.8753 8.53612 49.3505 8.93103 49.6919 9.47989C50.0332 10.0354 50.2072 10.7784 50.2072 11.7155C50.2072 12.5856 50.0332 13.3085 49.6852 13.8909C49.3371 14.4732 48.8485 14.9083 48.226 15.2028C47.6035 15.4973 46.8806 15.6378 46.0573 15.6378H45.2273Z\" fill=\"black\"/>\n                    <path d=\"M41.2246 17.2376V6.37419H39.1162V17.2376H41.2246Z\" fill=\"black\"/>\n                    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M35.4694 11.9337C35.4694 15.9614 32.2043 19.2265 28.1766 19.2265C24.1489 19.2265 20.8838 15.9614 20.8838 11.9337C20.8838 7.90597 24.1489 4.64087 28.1766 4.64087C27.6415 4.64087 27.108 4.69977 26.5857 4.8165L26.9197 6.31064C24.3427 6.88414 22.416 9.18392 22.416 11.9337C22.416 15.1152 24.9951 17.6943 28.1766 17.6943C31.3581 17.6943 33.9372 15.1152 33.9372 11.9337V11.9337H35.4694ZM28.1766 4.64087C32.2043 4.64087 35.4694 7.90597 35.4694 11.9337C35.4694 11.3986 35.4105 10.8651 35.2938 10.3428L33.7997 10.6768C33.2262 8.09976 30.9264 6.17311 28.1766 6.17311H28.1766V4.64087ZM28.1766 16.2453C29.9511 16.2453 31.4752 15.1733 32.1366 13.6416L30.7323 13.0294C30.3071 14.0199 29.3228 14.7137 28.1766 14.7137C27.0424 14.7137 26.0668 14.0344 25.6344 13.0605L24.2301 13.6728C24.8987 15.1878 26.4142 16.2453 28.1766 16.2453Z\" fill=\"black\"/>\n                </svg>\n            </a>\n            <a href=\"" + context.props.supportUrl + "\" target=\"_blank\" class=\"" + b('unread') + "\">\n                <div class=\"" + b('unread-icon') + "\">\n                    <svg width=\"16\" height=\"16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6 10.347c-.39 0-.623 0-1.12-.08-.623-.1-1.377.218-2.263.952.328-1.023.288-1.855-.12-2.497a3.855 3.855 0 0 1-.597-2.1c0-2.077 1.775-3.725 4.1-3.725 2.325 0 4.1 1.648 4.1 3.725 0 2.078-1.775 3.725-4.1 3.725zM.79 12.635c1.274.013 2.286-.24 3.036-.758.674.24 1.407.37 2.174.37 3.314 0 6-2.437 6-5.625C12 3.435 9.314.997 6 .997S0 3.435 0 6.622c0 1.46.564 2.763 1.493 3.746-.05.628-.336 1.276-.86 1.944a.2.2 0 0 0 .156.323zm14.452 1.72c-1.152.007-2.069-.225-2.75-.695-.617.22-1.29.34-1.992.34-.874 0-1.7-.185-2.434-.518 1.027-.075 1.739-.426 2.347-.725.517-.254.958-.471 1.454-.45a2.77 2.77 0 0 1 1.408.423c-.233-1.15.019-1.65.326-2.259.096-.191.198-.393.292-.63.932-2.344.082-4.855-.76-5.54C14.84 5.157 16 6.838 16 8.843a4.955 4.955 0 0 1-1.368 3.433c.045.567.3 1.153.767 1.756a.2.2 0 0 1-.157.323z\" fill=\"currentColor\"/></svg>\n                    <div\n                        " + badgeRef.id + "\n                        class=\"" + badgeRef.useClassName(function (_, state) { return b('unread-badge', {
        visible: Boolean(state.count),
    }); }, [], state) + "\"\n                    >\n                        " + badgeRef.useText(function (_, _a) {
        var count = _a.count;
        return normalizeBadgeString(count, MAX_UNREAD_CHAT);
    }, [], state) + "\n                    </div>\n                </div>\n                <div " + textRef.id + " class=\"" + b('unread-text') + "\">\n                    " + textRef.useText(function (props, _a) {
        var count = _a.count;
        return getText(count, props.lang);
    }, ['lang'], state) + "\n                </div>\n            </a>\n        </div>\n    ";
    /* eslint-enable indent */
}

function template$1(context) {
    var headerComponent = supportHeaderTemplate(context.pipe(function (props) { return ({
        lang: props.lang,
        passportUrl: props.passportUrl,
        supportUrl: props.supportUrl,
        unreadCounterPlugin: props.unreadCounterPlugin,
    }); }));
    return buttonTemplate(context, headerComponent);
}

var SupportButtonUI = /** @class */ (function (_super) {
    __extends$d(SupportButtonUI, _super);
    function SupportButtonUI(props) {
        return _super.call(this, template$1, function (widget) { return (__assign$2(__assign$2({}, buttonContextFactoryProvider(props)(widget)), { passportUrl: replaceTld(PASSPORT_URL, widget.options.tld), supportUrl: replaceTld(SUPPORT_URL, widget.options.tld) })); }, props) || this;
    }
    /**
     * @doc
     * Смонтировать UI в указанный DOM узел. По умолчанию в document.body
     *
     * @doctemplate method_annotation
     */
    SupportButtonUI.prototype.mount = function (
    /**
     * @doc
     * Узел в который будет смонитрован UI
     */
    node) {
        if (node === void 0) { node = document.body; }
        this.render(node);
    };
    return SupportButtonUI;
}(PopupBase));
// eslint-disable-next-line valid-jsdoc
/**
 * @doctemplate function_annotation
 * @doctitle Виджет c кнопкой для чатов поддержки
 * @doc
 *
 * Подробнее про использование виджета с кнопкой можно прочесть [здесь](/doc/ui-button.md)
 * Использовать только для чатов находящихся в workspace `support`
 *
 * [Storybook](https://messenger-test.s3.mds.yandex.net/storybook/widget/latest/index.html?path=/story/widget--ui-supportbutton)
 *
 * @example
 * import 'yandex-int/messenger.widget/lib/ui/supportbutton.css';
 * import {
 *     YandexSingleChatConfig,
 *     Widget,
 *     supportButtonUIFactory,
 *     yandexUnreadCounterFactory,
 *     presets,
 * } from 'yandex-int/messenger.widget';
 *
 * const unreadCounterPlugin = yandexUnreadCounterFactory();
 *
 * const ui = supportButtonUIFactory({
 *     unreadCounterPlugin,
 * });
 *
 * const widget = new Widget(new YandexSingleChatConfig(
 *     presets.support(YOUR_SUPPORT_BOT_GUID),
 *     {
 *         serviceId: YOUR_SERVICE_ID,
 *     }
 * ))
 *     .setPlugin(unreadCounterPlugin)
 *     .setUI(ui)
 *     .init();
 *
 * ui.mount();
 */
function supportButtonUIFactory(
/**
 * @docref template=members_annotation
 */
props) {
    return new SupportButtonUI(props);
}

function template(context) {
    var headerComponent = supportHeaderTemplate(context.pipe(function (props) { return ({
        lang: props.lang,
        passportUrl: props.passportUrl,
        supportUrl: props.supportUrl,
        unreadCounterPlugin: props.unreadCounterPlugin,
    }); }));
    return popupTemplate(context, headerComponent);
}

// eslint-disable-next-line valid-jsdoc
/**
 * @doctemplate function_annotation
 * @doctitle
 * Виджет попап для чатов с поддержкой
 *
 * @doc
 * Подробнее про использование виджета попап можно прочесть [здесь](/doc/ui-popup.md)
 * Использовать только для чатов находящихся в workspace `support`
 *
 * [Storybook](https://messenger-test.s3.mds.yandex.net/storybook/widget/latest/index.html?path=/story/widget--ui-supportpopup)
 *
 * @docsubtitle
 * Пример интеграции виджета поддержки попапом
 *
 * @example
 * import 'yandex-int/messenger.widget/lib/ui/supportpopup.css';
 * import {
 *     YandexSingleChatConfig,
 *     Widget,
 *     supportPopupUIFactory,
 *     yandexUnreadCounterFactory,
 *     presets,
 * } from 'yandex-int/messenger.widget';
 *
 * const unreadCounterPlugin = yandexUnreadCounterFactory();
 *
 * const ui = supportPopupUIFactory({
 *     unreadCounterPlugin,
 * });
 *
 * const widget = new Widget(new YandexSingleChatConfig(
 *     presets.support(YOUR_SUPPORT_BOT_GUID),
 *     {
 *         serviceId: YOUR_SERVICE_ID,
 *     }
 * ))
 *     .setPlugin(unreadCounterPlugin)
 *     .setUI(ui)
 *     .init();
 *
 * ui.mount();
 */
function supportPopupUIFactory(
/**
 * @docref template=members_annotation
 */
props) {
    var contextFactory = buttonContextFactoryProvider(props);
    return new Popup(template, function (widget) { return (__assign$2(__assign$2({}, contextFactory(widget)), { passportUrl: replaceTld(PASSPORT_URL, widget.options.tld), supportUrl: replaceTld(SUPPORT_URL, widget.options.tld), unreadCounterPlugin: props.unreadCounterPlugin })); }, props);
}

var MIN_UNREAD_TTL = 10; // 10 сек
var MAX_UNREAD_TTL = 5 * 60; // 5 мин.
var MIN_UNREAD_TIMEOUT = MIN_UNREAD_TTL * 1000; // 10 сек.
var MAX_UNREAD_TIMEOUT = MAX_UNREAD_TTL * 1000; // 5 мин.
var LOCAL_STORAGE_KEY_NAME = 'yachat-unread';
var HEALTH_SERVICE_ID = 19; // serviceId Яндекс.Здоровье
var HEALTH_NAMESPACE = 5; // namespace Яндекс.Здоровья

function getServiceNamespace(serviceId) {
    // Количество непрочитанных сообщений из нескрытых чатов + из чатов неймспейса конкретного сервиса.
    return serviceId === HEALTH_SERVICE_ID ? HEALTH_NAMESPACE : undefined;
}
function getLocalStorageTimeout(data) {
    return data.expiredTimestamp - Date.now();
}
function isValidLocalStorageData(data) {
    var now = Date.now();
    return Boolean(data &&
        data.currentTimestamp < now && // Может возникнуть при переводе часов
        now < data.expiredTimestamp &&
        (data.expiredTimestamp - now) <= MAX_UNREAD_TIMEOUT &&
        data.hasAuth === hasAuth());
}
function prepareTtl(ttl) {
    if (ttl < MIN_UNREAD_TTL) {
        return MIN_UNREAD_TTL;
    }
    if (ttl > MAX_UNREAD_TTL) {
        return MAX_UNREAD_TTL;
    }
    return ttl;
}
function getErrorTimeout(status, rawTimeout) {
    var timeout = Math.max(MIN_UNREAD_TIMEOUT, rawTimeout);
    // Для ошибок авторизации сразу ставим максимальный таймаут
    return status === 401 || status === 403 ?
        MAX_UNREAD_TIMEOUT :
        Math.min(timeout * 2, MAX_UNREAD_TIMEOUT);
}

var UnreadCounter = /** @class */ (function () {
    function UnreadCounter(params) {
        this.isStarted = false;
        this.needFetch = false;
        this.reqNum = 0; // Для статистики запросов.
        this.rn = Math.floor(Math.random() * 1e6); // Для отключения кеширования в IE.
        this.timeout = MIN_UNREAD_TIMEOUT;
        this.timeoutId = -1;
        this.params = params;
        this.fetch = this.fetch.bind(this);
        this.handleOnline = this.handleOnline.bind(this);
        this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
    }
    Object.defineProperty(UnreadCounter.prototype, "shouldUseSavedData", {
        get: function () {
            return (!this.params.ns || this.params.ns.length === 0) && this.params.workspaceId === undefined;
        },
        enumerable: false,
        configurable: true
    });
    UnreadCounter.prototype.start = function () {
        if (this.isStarted ||
            !this.params.url ||
            !window.navigator.cookieEnabled) {
            return;
        }
        this.isStarted = true;
        this.bindEvents();
        this.fetch();
    };
    UnreadCounter.prototype.stop = function () {
        this.isStarted = false;
        this.clearTimeout();
        this.unbindEvents();
    };
    UnreadCounter.prototype.removeData = function () {
        removeLocalStorageJsonItem(LOCAL_STORAGE_KEY_NAME);
    };
    UnreadCounter.prototype.fetch = function () {
        this.clearTimeout();
        if (document.hidden || !window.navigator.onLine) {
            this.needFetch = true;
            this.retryFetch();
            return;
        }
        this.needFetch = false;
        if (this.shouldUseSavedData) {
            var data = getLocalStorageJsonItem(LOCAL_STORAGE_KEY_NAME);
            if (isValidLocalStorageData(data)) {
                this.runCallback(data.response);
                this.timeoutId = window.setTimeout(this.fetch, getLocalStorageTimeout(data));
                return;
            }
        }
        this.makeRequest();
    };
    UnreadCounter.prototype.retryFetch = function () {
        this.clearTimeout();
        this.timeoutId = window.setTimeout(this.fetch, this.timeout);
    };
    UnreadCounter.prototype.bindEvents = function () {
        document.addEventListener('visibilitychange', this.handleVisibilityChange, false);
        window.addEventListener('online', this.handleOnline, false);
    };
    UnreadCounter.prototype.unbindEvents = function () {
        document.removeEventListener('visibilitychange', this.handleVisibilityChange, false);
        window.removeEventListener('online', this.handleOnline, false);
    };
    UnreadCounter.prototype.handleVisibilityChange = function () {
        if (this.needFetch && !document.hidden) {
            this.fetch();
        }
    };
    UnreadCounter.prototype.handleOnline = function () {
        if (this.needFetch) {
            this.fetch();
        }
    };
    UnreadCounter.prototype.makeRequest = function () {
        var _this = this;
        var xhr = new XMLHttpRequest();
        xhr.open('GET', this.getUrl(), true);
        xhr.withCredentials = true;
        // Не поддерживается в IE11 и в старых Webkit.
        // https://bugs.webkit.org/show_bug.cgi?id=73648
        // xhr.responseType = 'json';
        xhr.onload = function () {
            if (!_this.isStarted) {
                return;
            }
            if (xhr.status !== 200) {
                _this.handleError({ Status: xhr.status });
                return;
            }
            var data;
            try {
                data = JSON.parse(xhr.responseText);
            }
            catch (e) {
                data = null;
            }
            if (data && typeof data === 'object') {
                if ('Status' in data) {
                    _this.handleError(data);
                    return;
                }
                else if ('Ttl' in data) {
                    _this.handleResponse(data);
                    return;
                }
            }
            /**
             * Если от бека пустой ответ или в нём нет полей Ttl и Status,
             * то ответ считаем невалидным и прекращаем поллинг.
             */
            _this.stop();
        };
        xhr.onerror = xhr.onabort = xhr.ontimeout = function () { return _this.handleError({ Status: xhr.status }); };
        xhr.send(null);
    };
    UnreadCounter.prototype.runCallback = function (data) {
        if ('Ttl' in data && !('Status' in data)) {
            this.params.callback({
                lastTimestamp: data.LastUnreadTsMcs,
                value: data.UnreadCount || 0,
                valueForChat: data.ChatUnreadCount || 0,
                chatCount: data.ChatCount || 0,
            });
        }
    };
    UnreadCounter.prototype.getUrl = function () {
        this.reqNum++;
        var _a = this.params, serviceId = _a.serviceId, workspaceId = _a.workspaceId, url = _a.url, chatId = _a.chatId, guid = _a.guid, ns = _a.ns, withCountChats = _a.withCountChats, orgId = _a.orgId;
        return queryStringify$1(url, {
            all_ns: getServiceNamespace(serviceId),
            parentOrigin: getOrigin(),
            rn: this.rn,
            reqNum: this.reqNum,
            chat_id: chatId,
            other_guid: guid,
            serviceId: serviceId,
            client: workspaceId,
            ns: ns,
            count_chats: withCountChats ? '1' : undefined,
            organization_id: orgId,
        });
    };
    UnreadCounter.prototype.clearTimeout = function () {
        window.clearTimeout(this.timeoutId);
    };
    UnreadCounter.prototype.handleResponse = function (response) {
        this.runCallback(response);
        this.timeout = prepareTtl(response.Ttl) * 1000;
        this.saveData(response, this.timeout);
        this.retryFetch();
    };
    UnreadCounter.prototype.handleError = function (response) {
        this.timeout = getErrorTimeout(response.Status, this.timeout);
        this.saveData(response, this.timeout);
        this.retryFetch();
    };
    UnreadCounter.prototype.saveData = function (response, timeout) {
        if (!this.shouldUseSavedData) {
            return;
        }
        var now = Date.now();
        setLocalStorageJsonItem(LOCAL_STORAGE_KEY_NAME, {
            currentTimestamp: now,
            expiredTimestamp: now + timeout,
            hasAuth: hasAuth(),
            response: response,
        });
    };
    return UnreadCounter;
}());

var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
(undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};

(undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};

/**
 * @doctitle Плагин для полинга кол-ва непрочитанных сообщений
 *
 * @doc Позвозляет получить кол-во непрочитанных сообщений без открытия мессенджера.
 * При этом после открытия виджета - полинг прекращается и начинают использоваться данные мессенджера.
 *
 * В случае если сервис находится не на домене `yandex.{tld}` или `*.yandex.{tld}`
 * необходимо обратиться к дежурному мессенджера.
 *
 * @doc
 * Для упращенной инициализации плагина можно использовать две фабрики:
 *
 * `yandexUnreadCounterFactory` - для внешних сервисов яндекса
 *
 * `yandexTeamUnreadCounterFactory` - для внутренних сервисов яндекса
 *
 * @docsubtitle Пример
 *
 * @example
 * import {
 *     Widget,
 *     Config,
 *     yandexUnreadCounterFactory,
 * } from 'yandex-int/messenger.widget';
 *
 * const widget = new Widget(new Config().create());
 * const unreadCounter = yandexUnreadCounterFactory();
 *
 * unreadCounter.onChanged
 *     .addListener((value: UnreadCounterData) => console.log(value))
 *
 * widget
 *     .addPlugin(unreadCounter)
 *     .init();
 *
 * @doc
 * Доступны два клиента полинга из пакета `yandex-int/messenger.unread-counter`
 *
 * `UnreadCounter` - для получения данных используется полинг https ручки мессенджера
 * Подходит для интеграции в сервисы яндекса. Необходимо разрешить `CORS` на yandex.{tld}
 *
 * `UnreadCounterIframeClient` - для получения данных используется iframe
 * (подходит при интеграции во внешние сервисы)
 *
 * @docsubtitle Пример с `UnreadCounter`
 *
 * @example
 * import { UnreadCounter } from 'yandex-int/messenger.unread-counter';
 * import {
 *     Widget,
 *     Config,
 *     UnreadCounterPlugin,
 *     YANDEX_UNREAD_COUNTER_ENDPOINT,
 * } from 'yandex-int/messenger.widget';
 *
 * const widget = new Widget(new Config().create());
 * const unreadCounter = new UnreadCounterPlugin(
 *     YANDEX_UNREAD_COUNTER_ENDPOINT,
 *     (params) => new UnreadCounter(params)
 * );
 *
 * unreadCounter.onChanged
 *     .addListener((value: UnreadCounterData) => console.log(value))
 *
 * widget
 *     .addPlugin(unreadCounter)
 *     .init();
 *
 */
var UnreadCounterPlugin = /** @class */ (function () {
    /**
     * @doctitle Конструктор
     * @doctemplate method_annotation
     */
    function UnreadCounterPlugin(
    /**
     * @doc
     * URL ручки непрочитанных сообщений
     * @doctemplate members_annotation
     */
    unreadUrl, 
    /**
     * @doc
     * Фабрика клиента получения кол-ва непрочитанных из внешнего источника
     * Стандартные клиенты лежат в пакете `yandex-int/messenger.unread-counter`
     * @doctemplate members_annotation
     */
    unreadCounterFactory) {
        this.unreadUrl = unreadUrl;
        this.unreadCounterFactory = unreadCounterFactory;
        /**
         * @doc
         * Вызывется при изменении значения непрочитанных сообщений
         * @doctemplate members_annotation
         */
        this.onChanged = new Event();
    }
    /**
     * @private
     */
    UnreadCounterPlugin.prototype.init = function (_a, widget) {
        var _b;
        var serviceId = _a.serviceId, workspaceId = _a.workspaceId, unreadCounterChatId = _a.unreadCounterChatId, unreadCounterOtherGuid = _a.unreadCounterOtherGuid, unreadCounterNsFilter = _a.unreadCounterNsFilter, unreadWithCountChats = _a.unreadWithCountChats, orgId = _a.orgId;
        this.widget = widget;
        this.widget.events.counter.addListener(this.handleUnreadCounter);
        this.unreadCounterClient = this === null || this === void 0 ? void 0 : this.unreadCounterFactory({
            callback: this.update,
            url: replaceTld(this.unreadUrl),
            serviceId: serviceId,
            workspaceId: workspaceId,
            chatId: unreadCounterChatId,
            guid: unreadCounterOtherGuid,
            ns: unreadCounterNsFilter,
            withCountChats: unreadWithCountChats,
            orgId: orgId,
        });
        (_b = this.unreadCounterClient) === null || _b === void 0 ? void 0 : _b.start();
    };
    UnreadCounterPlugin.prototype.handleUnreadCounter = function (_a) {
        var data = _a.data;
        this.update(data);
    };
    UnreadCounterPlugin.prototype.update = function (data) {
        var lastValue = this.lastValue;
        var _a = data.valueForChat, valueForChat = _a === void 0 ? 0 : _a, _b = data.value, value = _b === void 0 ? 0 : _b, _c = data.lastTimestamp, lastTimestamp = _c === void 0 ? 0 : _c, _d = data.seqnoForChat, seqnoForChat = _d === void 0 ? 0 : _d, _e = data.chatCount, chatCount = _e === void 0 ? 0 : _e;
        if (lastValue && (value === lastValue.value &&
            valueForChat === lastValue.valueForChat &&
            lastTimestamp === lastValue.lastTimestamp &&
            seqnoForChat === lastValue.seqnoForChat &&
            chatCount === lastValue.chatCount)) {
            return;
        }
        this.lastValue = { value: value, lastTimestamp: lastTimestamp, valueForChat: valueForChat, seqnoForChat: seqnoForChat, chatCount: chatCount };
        this.onChanged.dispatch(this.lastValue);
    };
    Object.defineProperty(UnreadCounterPlugin.prototype, "shouldUseValueForChat", {
        get: function () {
            var _a;
            return Boolean((_a = 
            // Если передан фильтр по чат айди то нужно использовать поле valueForChat
            this.widget) === null || _a === void 0 ? void 0 : _a.options.unreadCounterChatId);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @private
     */
    UnreadCounterPlugin.prototype.LCClose = function () {
        var _a;
        this.widget.events.counter.removeListener(this.handleUnreadCounter);
        (_a = this.unreadCounterClient) === null || _a === void 0 ? void 0 : _a.stop();
        this.onChanged.removeAllListener();
    };
    /**
     * @private
     */
    UnreadCounterPlugin.prototype.LCReady = function () {
        var _a;
        (_a = this.unreadCounterClient) === null || _a === void 0 ? void 0 : _a.stop();
    };
    __decorate$9([
        lib$2.bind
    ], UnreadCounterPlugin.prototype, "handleUnreadCounter", null);
    __decorate$9([
        lib$2.bind
    ], UnreadCounterPlugin.prototype, "update", null);
    return UnreadCounterPlugin;
}());

var YANDEX_UNREAD_COUNTER_ENDPOINT = 'https://yandex.{tld}/messenger/api/unread_count';
var YANDEX_TEAM_UNREAD_COUNTER_ENDPOINT = 'https://backend.messenger.yandex-team.ru/unread_count';

/**
 * @doctemplate function_annotation
 * @docsubtitle Фабрика плагина непрочитанных сообщений для сервисов яндекса
 *
 * @doc
 * Если сервис находится не на домене yandex.{tld}/*.yandex.{tld},
 * необходимо обратиться дежурному мессенджера для добавления домена в разрешенные
 */
function yandexUnreadCounterFactory() {
    return new UnreadCounterPlugin(YANDEX_UNREAD_COUNTER_ENDPOINT, function (params) { return new UnreadCounter(params); });
}
/**
 * @doctemplate function_annotation
 * @docsubtitle Фабрика плагина непрочитанных сообщений для внутренних сервисов яндекса
 */
function yandexTeamUnreadCounterFactory() {
    return new UnreadCounterPlugin(YANDEX_TEAM_UNREAD_COUNTER_ENDPOINT, function (params) { return new UnreadCounter(params); });
}

/**
 * Открывает заданный публичный чат или канал по chat_id
 */
var SCHEMA_CHAT = 'messenger://chat/open';
/**
 * Открывает список чатов
 */
var SCHEMA_CHAT_LIST = 'messenger://chat/list';
/**
 * Открывает заданный чат или канал по invite_hash
 */
var SCHEMA_INVITE = 'messenger://chat/invite_byhash';
/**
 * Открывает чат 1-1 с пользователем
 */
var SCHEMA_USER = 'messenger://user/';
/**
 * Получаем из фичи messenger доступные диплинки
 *
 * @returns Массив доступных схем диплинка
 */
var getMessengerAvailablePaths = function () {
    var nativeMessengerScheme = getNativeMessengerScheme();
    return (nativeMessengerScheme.params ? nativeMessengerScheme.params['available-paths'] : []);
};
/**
 *  Создаёт диплинк по указанныи url параметрам и оциям
 *
 * @param options Опции для составления диплинка
 * @param urlParams url параметры
 * @returns Диплинк с query параметрами
 */
var getMessengerUrl = function (options, urlParams) {
    var guid = options.guid, chatId = options.chatId, inviteHash = options.inviteHash, context = options.context;
    var availablePaths = getMessengerAvailablePaths();
    if (inviteHash && availablePaths.indexOf(SCHEMA_INVITE) !== -1) {
        // Открыть чат по inviteHash: https://st.yandex-team.ru/MSSNGRIOS-4404
        return queryStringify$1(SCHEMA_INVITE, __assign$2({ invite_hash: inviteHash, context: context }, urlParams));
    }
    if (chatId && availablePaths.indexOf(SCHEMA_CHAT) !== -1) {
        // Открыть чат по chatId https://st.yandex-team.ru/MSSNGR-8061
        return queryStringify$1(SCHEMA_CHAT, __assign$2({ chat_id: chatId, context: context }, urlParams));
    }
    if (guid && availablePaths.indexOf(SCHEMA_USER) !== -1) {
        // Открыть чат с пользователем по guid
        return queryStringify$1(SCHEMA_USER, __assign$2({ user_id: guid, context: context }, urlParams));
    }
    return queryStringify$1(SCHEMA_CHAT_LIST, __assign$2({ context: context }, urlParams));
};
var getNativeUrl = function (options, urlParams) {
    if (!isNativeAvailable()) {
        return;
    }
    return getMessengerUrl(options, urlParams);
};
var tryOpenNative = function (options) {
    var serviceId = options.serviceId, clickId = options.clickId, _a = options.params, params = _a === void 0 ? {} : _a;
    var nativeUrl = getNativeUrl(params, {
        serviceId: serviceId,
        clickId: clickId,
    });
    if (nativeUrl) {
        window.location.replace(nativeUrl);
        metrikaReachGoal('widget-opened-native', {
            clickId: clickId,
        });
        return true;
    }
    return false;
};

/**
 * @doctitle Плагин для открытия нативного мессенджера в мобильных ПП и Ябро
 *
 * @doc
 * В случаее если браузер (мобильные ПП и Ябро) поддерживает диплинки мессенджера
 * вместо виджета будет открыт нативный мессенджер.
 *
 * Нативный мессенджер не поддерживает api и события виджета, поэтому подходит только
 * в случае если использовать их не планируется.
 *
 * @example
 * import { Widget, Config } from 'yandex-int/messenger.widget';
 * import { NativeInterceptor } from 'yandex-int/messenger.widget/plugins';
 *
 * const widget = new Widget(new Config().create());
 *
 * widget.addPlugin(new NativeInterceptor());
 */
var NativeInterceptor = /** @class */ (function () {
    function NativeInterceptor() {
    }
    /**
     * @private
     */
    NativeInterceptor.prototype.init = function (options) {
        this.serviceId = options.serviceId;
    };
    /**
     * @private
     */
    NativeInterceptor.prototype.LCBeforeRequest = function (event) {
        if (isNativeAvailable()) {
            event.preventDefault(Promise.reject(new Error('Native messenger does not support api')));
        }
    };
    /**
     * @private
     */
    NativeInterceptor.prototype.LCBeforeShow = function (event) {
        if (!isNativeAvailable()) {
            return;
        }
        tryOpenNative({
            params: event.data,
            serviceId: this.serviceId,
        });
        event.preventDefault();
    };
    return NativeInterceptor;
}());

var DEEP_LINK = /^https?:\/\/yandex\.[^/]+\/chat/;
var isAnchor = function (element) {
    return element.tagName === 'A';
};

/**
 * @doctitle Плагин для открытия виджета при клике на url мессенджера
 *
 * @doc
 * Позволяет открывать ссылки мессенджера на сайте в виджете.
 * Плагин подписывается на CAPTURE фазу события `click`,
 * и в случае если target события - элемент `A` с `href` равным одному
 * из диплинков мессенджера - открывает виджет.
 *
 * @example
 * import { Widget, Config } from 'yandex-int/messenger.widget';
 * import { Deeplinker } from 'yandex-int/messenger.widget/plugins';
 *
 * const widget = new Widget(new Config().create());
 *
 * widget.addPlugin(new Deeplinker());
 */
var Deeplinker = /** @class */ (function () {
    function Deeplinker() {
    }
    /**
     * @private
     */
    Deeplinker.prototype.init = function (_, widget) {
        if (!isNativeAvailable()) {
            this.widget = widget;
            window.addEventListener('click', this.handleClick, true);
        }
    };
    /**
     * @private
     */
    Deeplinker.prototype.LCClose = function () {
        if (!isNativeAvailable()) {
            window.removeEventListener('click', this.handleClick, true);
        }
        this.widget = undefined;
    };
    Deeplinker.prototype.handleClick = function (event) {
        var _a;
        var node = event.target;
        while (node) {
            if (isAnchor(node) && DEEP_LINK.test(node.href)) {
                (_a = this.widget) === null || _a === void 0 ? void 0 : _a.show({ deeplink: node.href });
                event.preventDefault();
                return;
            }
            node = node.parentElement;
        }
    };
    __decorate$9([
        lib$2.bind
    ], Deeplinker.prototype, "handleClick", null);
    return Deeplinker;
}());

export { BACKEND_DEV, BACKEND_PROD, BACKEND_TEST, Block, CONNECTION_TIMEOUT, Config, Deeplinker, EVENTS_NAMES, HOST_DEV, HOST_DEV_INTERNAL, HOST_PROD, HOST_PROD_INTERNAL, HOST_PULL, HOST_PULL_INTERNAL, HOST_RELEASE, HOST_RELEASE_INTERNAL, IframePostMessageTransport, IframeStrategy, NativeInterceptor, PASSPORT_URL, Popup, PopupBase, PostMessageChannelTransport, SUPPORT_URL, UnreadCounterPlugin, WIDGET_TRANSPORT_SCOPE, Widget, WidgetAPI, WidgetHandlers, WindowStrategy, YANDEX_TEAM_UNREAD_COUNTER_ENDPOINT, YANDEX_UNREAD_COUNTER_ENDPOINT, YandexConfig, YandexSingleBlockChatConfig, YandexSingleChatConfig, YandexTeamConfig, YandexTeamSingleBlockChatConfig, YandexTeamSingleChatConfig, blockUIFactory, buttonContextFactoryProvider, buttonUIFactory, defaultBehaviorStrategies, eventsFactory, popupUIFactory, preset, presets, supportButtonUIFactory, supportPopupUIFactory, yandexTeamUnreadCounterFactory, yandexUnreadCounterFactory };
